/**
 * The Lillebjörn — Find My Dog's Size
 * Native Shopify Web Component (no build step, no framework).
 * Registers <lillebjorn-fit-finder>, reading real product/variant JSON
 * emitted by sections/lillebjorn-fit-finder.liquid.
 */
(function () {
  "use strict";

  if (customElements.get("lillebjorn-fit-finder")) return;

  /* ============================================================
     1. LIVE SEARCH & BREED AUTOCOMPLETE
     ============================================================ */

  // Comprehensive, alphabetized placeholder list for the autocomplete UI.
  // "Mixed Breed / Other" is intentionally pinned last, not alphabetized,
  // since it is a fallback action rather than a breed.
  var BREED_NAMES = [
    "Affenpinscher","Afghan Hound","Airedale Terrier","Akita","Alaskan Malamute",
    "American Bulldog","American Eskimo Dog","American Staffordshire Terrier",
    "Australian Cattle Dog","Australian Shepherd","Azawakh","Basenji","Basset Hound",
    "Beagle","Bearded Collie","Bedlington Terrier","Belgian Malinois",
    "Bernese Mountain Dog","Bichon Frise","Bloodhound","Border Collie","Border Terrier",
    "Borzoi","Boston Terrier","Bouvier des Flandres","Boxer","Boykin Spaniel",
    "Brittany","Bull Terrier","Bulldog","Bullmastiff","Cairn Terrier","Cane Corso",
    "Cardigan Welsh Corgi","Cavalier King Charles Spaniel","Chesapeake Bay Retriever",
    "Chihuahua","Chinese Crested","Chow Chow","Cocker Spaniel","Collie","Coonhound",
    "Dachshund (Miniature)","Dachshund (Standard)","Dalmatian","Doberman Pinscher",
    "Dogo Argentino","Dogue de Bordeaux","Dutch Shepherd","English Setter",
    "English Springer Spaniel","Field Spaniel","Flat-Coated Retriever","French Bulldog",
    "German Shepherd","German Shorthaired Pointer","Golden Retriever","Great Dane",
    "Great Pyrenees","Greyhound","Havanese","Ibizan Hound","Irish Setter",
    "Irish Wolfhound","Italian Greyhound","Jack Russell Terrier","Japanese Chin",
    "Keeshond","Kerry Blue Terrier","Komondor","Labrador Retriever","Lagotto Romagnolo",
    "Lhasa Apso","Maltese","Mastiff","Miniature Pinscher","Miniature Schnauzer",
    "Newfoundland","Norwegian Elkhound","Norwich Terrier","Old English Sheepdog",
    "Papillon","Pekingese","Pembroke Welsh Corgi","Pharaoh Hound","Pit Bull Terrier",
    "Pointer","Pomeranian","Poodle (Miniature)","Poodle (Standard)","Poodle (Toy)",
    "Portuguese Water Dog","Pug","Rat Terrier","Rhodesian Ridgeback","Rottweiler",
    "Saint Bernard","Saluki","Samoyed","Schnauzer","Scottish Terrier","Shar Pei",
    "Shetland Sheepdog","Shiba Inu","Shih Tzu","Siberian Husky","Sloughi",
    "Spanish Galgo","Springer Spaniel","Staffordshire Bull Terrier","Vizsla",
    "Weimaraner","Welsh Terrier","West Highland White Terrier","Whippet",
    "Xoloitzcuintli","Yorkshire Terrier"
  ];
  var FALLBACK_BREED_NAME = "Mixed Breed / Other";

  // Breeds with a hand-measured sizing profile (highest precision tier).
  // Every OTHER name in BREED_NAMES resolves through the archetype/size-class
  // matrix below — nothing in the lookup table hits the Mixed Breed fallback
  // anymore. Category is one of the 4 sizing brackets (see BUCKET NOTES).
  var CURATED_BREEDS = {
    "italian greyhound": { neck: [20, 27], chest: [36, 46], neckDefault: 23, chestDefault: 40, build: "Slender / Elegant", category: "sighthound" },
    "whippet": { neck: [27, 35], chest: [52, 63], neckDefault: 31, chestDefault: 58, build: "Slender / Elegant", category: "sighthound" },
    "greyhound": { neck: [32, 41], chest: [58, 72], neckDefault: 36, chestDefault: 64, build: "Slender / Elegant", category: "sighthound" },
    "saluki": { neck: [28, 37], chest: [54, 66], neckDefault: 32, chestDefault: 59, build: "Slender / Elegant", category: "sighthound" },
    "dachshund (standard)": { neck: [24, 31], chest: [36, 48], neckDefault: 27, chestDefault: 42, build: "Proportional / Low Profile", category: "standard" },
    "dachshund (miniature)": { neck: [17, 25], chest: [28, 39], neckDefault: 21, chestDefault: 34, build: "Petite / Low Profile", category: "standard" },
    "labrador retriever": { neck: [37, 48], chest: [66, 86], neckDefault: 42, chestDefault: 76, build: "Athletic / Standard", category: "standard" },
    "golden retriever": { neck: [38, 49], chest: [65, 84], neckDefault: 43, chestDefault: 75, build: "Athletic / Standard", category: "standard" },
    "german shepherd": { neck: [39, 51], chest: [62, 86], neckDefault: 46, chestDefault: 74, build: "Athletic / Standard", category: "standard" },
    "rottweiler": { neck: [44, 56], chest: [72, 94], neckDefault: 50, chestDefault: 82, build: "Heavy / Muscular", category: "bully" },
    "doberman pinscher": { neck: [38, 48], chest: [63, 80], neckDefault: 43, chestDefault: 71, build: "Athletic / Standard", category: "standard" },
    "boxer": { neck: [38, 49], chest: [64, 82], neckDefault: 43, chestDefault: 73, build: "Heavy / Muscular", category: "bully" },
    "siberian husky": { neck: [35, 45], chest: [58, 74], neckDefault: 39, chestDefault: 65, build: "Athletic / Standard", category: "standard" },
    "bernese mountain dog": { neck: [42, 54], chest: [76, 96], neckDefault: 48, chestDefault: 86, build: "Athletic / Standard", category: "standard" },
    "great dane": { neck: [46, 58], chest: [80, 100], neckDefault: 52, chestDefault: 90, build: "Athletic / Standard", category: "standard" },
    "border collie": { neck: [32, 42], chest: [52, 68], neckDefault: 36, chestDefault: 59, build: "Athletic / Standard", category: "standard" },
    "vizsla": { neck: [32, 41], chest: [55, 70], neckDefault: 36, chestDefault: 61, build: "Athletic / Standard", category: "standard" },
    "poodle (standard)": { neck: [31, 40], chest: [53, 68], neckDefault: 35, chestDefault: 59, build: "Athletic / Standard", category: "standard" },
    "poodle (miniature)": { neck: [22, 29], chest: [38, 49], neckDefault: 25, chestDefault: 43, build: "Petite / Low Profile", category: "toy" },
    "cocker spaniel": { neck: [27, 35], chest: [46, 60], neckDefault: 30, chestDefault: 52, build: "Proportional / Low Profile", category: "standard" },
    "beagle": { neck: [28, 36], chest: [46, 59], neckDefault: 31, chestDefault: 51, build: "Compact / Broad", category: "standard" },
    "french bulldog": { neck: [28, 36], chest: [47, 61], neckDefault: 32, chestDefault: 54, build: "Compact / Broad", category: "bully" },
    "boston terrier": { neck: [25, 33], chest: [41, 53], neckDefault: 28, chestDefault: 46, build: "Compact / Broad", category: "bully" },
    "pug": { neck: [24, 32], chest: [40, 52], neckDefault: 27, chestDefault: 45, build: "Compact / Broad", category: "bully" },
    "shih tzu": { neck: [20, 27], chest: [34, 44], neckDefault: 23, chestDefault: 38, build: "Petite / Low Profile", category: "toy" },
    "cavalier king charles spaniel": { neck: [21, 29], chest: [36, 47], neckDefault: 24, chestDefault: 41, build: "Petite / Low Profile", category: "toy" },
    "pembroke welsh corgi": { neck: [28, 36], chest: [48, 62], neckDefault: 31, chestDefault: 54, build: "Compact / Broad", category: "standard" },
    "chihuahua": { neck: [16, 22], chest: [26, 35], neckDefault: 18, chestDefault: 30, build: "Petite / Low Profile", category: "toy" }
  };

  // ---- Universal archetype / size-class engine (item 4 + 5/6/8) ----
  // Every breed NOT in CURATED_BREEDS above is still real, personalized
  // data: it derives from a size-class baseline (absolute circumference
  // band) adjusted by a body-shape archetype multiplier. This is what lets
  // "American Bulldog" (bully × large) or any of the ~90 other lookup-table
  // breeds size correctly instead of silently degrading to the generic
  // Mixed Breed fallback.
  var SIZE_CLASS_BASE = {
    toy: { neck: [16, 22], chest: [26, 36] },
    small: { neck: [22, 30], chest: [36, 50] },
    medium: { neck: [30, 40], chest: [50, 66] },
    large: { neck: [38, 50], chest: [64, 84] },
    giant: { neck: [46, 60], chest: [80, 104] }
  };

  // The 4 strict sizing brackets. sighthound narrows the neck relative to a
  // deep chest; bully (brachycephalic/broad) thickens the neck base for
  // powerful shoulders; toy/standard pass the size-class baseline through.
  var ARCHETYPE_MULTIPLIER = {
    sighthound: { neck: 0.90, chest: 1.08 },
    bully: { neck: 1.14, chest: 1.06 },
    toy: { neck: 1.00, chest: 1.00 },
    standard: { neck: 1.00, chest: 1.00 }
  };

  var BREED_ARCHETYPES = {
    "affenpinscher": { archetype: "toy", sizeClass: "toy" },
    "afghan hound": { archetype: "sighthound", sizeClass: "large" },
    "airedale terrier": { archetype: "standard", sizeClass: "medium" },
    "akita": { archetype: "standard", sizeClass: "large" },
    "alaskan malamute": { archetype: "standard", sizeClass: "large" },
    "american bulldog": { archetype: "bully", sizeClass: "large" },
    "american eskimo dog": { archetype: "standard", sizeClass: "small" },
    "american staffordshire terrier": { archetype: "bully", sizeClass: "medium" },
    "australian cattle dog": { archetype: "standard", sizeClass: "medium" },
    "australian shepherd": { archetype: "standard", sizeClass: "medium" },
    "azawakh": { archetype: "sighthound", sizeClass: "medium" },
    "basenji": { archetype: "standard", sizeClass: "small" },
    "basset hound": { archetype: "standard", sizeClass: "medium" },
    "bearded collie": { archetype: "standard", sizeClass: "medium" },
    "bedlington terrier": { archetype: "standard", sizeClass: "small" },
    "belgian malinois": { archetype: "standard", sizeClass: "medium" },
    "bichon frise": { archetype: "toy", sizeClass: "toy" },
    "bloodhound": { archetype: "standard", sizeClass: "large" },
    "border terrier": { archetype: "standard", sizeClass: "small" },
    "borzoi": { archetype: "sighthound", sizeClass: "large" },
    "bouvier des flandres": { archetype: "standard", sizeClass: "large" },
    "boykin spaniel": { archetype: "standard", sizeClass: "small" },
    "brittany": { archetype: "standard", sizeClass: "small" },
    "bull terrier": { archetype: "bully", sizeClass: "medium" },
    "bulldog": { archetype: "bully", sizeClass: "medium" },
    "bullmastiff": { archetype: "bully", sizeClass: "giant" },
    "cairn terrier": { archetype: "standard", sizeClass: "small" },
    "cane corso": { archetype: "bully", sizeClass: "giant" },
    "cardigan welsh corgi": { archetype: "standard", sizeClass: "small" },
    "chesapeake bay retriever": { archetype: "standard", sizeClass: "large" },
    "chinese crested": { archetype: "toy", sizeClass: "toy" },
    "chow chow": { archetype: "bully", sizeClass: "medium" },
    "collie": { archetype: "standard", sizeClass: "large" },
    "coonhound": { archetype: "standard", sizeClass: "large" },
    "dalmatian": { archetype: "standard", sizeClass: "large" },
    "dogo argentino": { archetype: "bully", sizeClass: "large" },
    "dogue de bordeaux": { archetype: "bully", sizeClass: "large" },
    "dutch shepherd": { archetype: "standard", sizeClass: "medium" },
    "english setter": { archetype: "standard", sizeClass: "large" },
    "english springer spaniel": { archetype: "standard", sizeClass: "medium" },
    "field spaniel": { archetype: "standard", sizeClass: "small" },
    "flat-coated retriever": { archetype: "standard", sizeClass: "large" },
    "german shorthaired pointer": { archetype: "standard", sizeClass: "large" },
    "great pyrenees": { archetype: "standard", sizeClass: "giant" },
    "havanese": { archetype: "toy", sizeClass: "toy" },
    "ibizan hound": { archetype: "sighthound", sizeClass: "large" },
    "irish setter": { archetype: "standard", sizeClass: "large" },
    "irish wolfhound": { archetype: "sighthound", sizeClass: "giant" },
    "jack russell terrier": { archetype: "standard", sizeClass: "small" },
    "japanese chin": { archetype: "toy", sizeClass: "toy" },
    "keeshond": { archetype: "standard", sizeClass: "medium" },
    "kerry blue terrier": { archetype: "standard", sizeClass: "medium" },
    "komondor": { archetype: "standard", sizeClass: "giant" },
    "lagotto romagnolo": { archetype: "standard", sizeClass: "small" },
    "lhasa apso": { archetype: "toy", sizeClass: "toy" },
    "maltese": { archetype: "toy", sizeClass: "toy" },
    "mastiff": { archetype: "bully", sizeClass: "giant" },
    "miniature pinscher": { archetype: "toy", sizeClass: "toy" },
    "miniature schnauzer": { archetype: "toy", sizeClass: "small" },
    "newfoundland": { archetype: "standard", sizeClass: "giant" },
    "norwegian elkhound": { archetype: "standard", sizeClass: "medium" },
    "norwich terrier": { archetype: "standard", sizeClass: "small" },
    "old english sheepdog": { archetype: "standard", sizeClass: "large" },
    "papillon": { archetype: "toy", sizeClass: "toy" },
    "pekingese": { archetype: "toy", sizeClass: "toy" },
    "pharaoh hound": { archetype: "sighthound", sizeClass: "medium" },
    "pit bull terrier": { archetype: "bully", sizeClass: "medium" },
    "pointer": { archetype: "standard", sizeClass: "large" },
    "pomeranian": { archetype: "toy", sizeClass: "toy" },
    "poodle (toy)": { archetype: "toy", sizeClass: "toy" },
    "portuguese water dog": { archetype: "standard", sizeClass: "medium" },
    "rat terrier": { archetype: "standard", sizeClass: "small" },
    "rhodesian ridgeback": { archetype: "standard", sizeClass: "large" },
    "saint bernard": { archetype: "bully", sizeClass: "giant" },
    "samoyed": { archetype: "standard", sizeClass: "medium" },
    "schnauzer": { archetype: "standard", sizeClass: "medium" },
    "scottish terrier": { archetype: "standard", sizeClass: "small" },
    "shar pei": { archetype: "bully", sizeClass: "medium" },
    "shetland sheepdog": { archetype: "standard", sizeClass: "small" },
    "shiba inu": { archetype: "standard", sizeClass: "small" },
    "sloughi": { archetype: "sighthound", sizeClass: "medium" },
    "spanish galgo": { archetype: "sighthound", sizeClass: "medium" },
    "springer spaniel": { archetype: "standard", sizeClass: "medium" },
    "staffordshire bull terrier": { archetype: "bully", sizeClass: "medium" },
    "weimaraner": { archetype: "standard", sizeClass: "large" },
    "welsh terrier": { archetype: "standard", sizeClass: "small" },
    "west highland white terrier": { archetype: "standard", sizeClass: "small" },
    "xoloitzcuintli": { archetype: "standard", sizeClass: "medium" },
    "yorkshire terrier": { archetype: "toy", sizeClass: "toy" }
  };

  function buildForArchetype(archetype, sizeClass) {
    if (archetype === "sighthound") return "Slender / Elegant";
    if (archetype === "toy") return "Petite / Low Profile";
    if (archetype === "bully") return (sizeClass === "toy" || sizeClass === "small") ? "Compact / Broad" : "Heavy / Muscular";
    return (sizeClass === "large" || sizeClass === "giant") ? "Athletic / Standard" : "Proportional / Low Profile";
  }

  function deriveFromArchetype(name, entry) {
    var base = SIZE_CLASS_BASE[entry.sizeClass];
    var mul = ARCHETYPE_MULTIPLIER[entry.archetype];
    var neck = [Math.round(base.neck[0] * mul.neck), Math.round(base.neck[1] * mul.neck)];
    var chest = [Math.round(base.chest[0] * mul.chest), Math.round(base.chest[1] * mul.chest)];
    return {
      neck: neck,
      chest: chest,
      neckDefault: Math.round((neck[0] + neck[1]) / 2),
      chestDefault: Math.round((chest[0] + chest[1]) / 2),
      build: buildForArchetype(entry.archetype, entry.sizeClass),
      category: entry.archetype,
      // Carried through only for the bespoke-order email (see
      // buildCustomSizeMailto) — CURATED_BREEDS entries don't have this
      // field at all (they use hand-measured ranges instead of the
      // size-class baseline), so it stays undefined for those breeds rather
      // than inventing a classification the source data doesn't have.
      sizeClass: entry.sizeClass
    };
  }

  var MIXED_FALLBACK = {
    neck: null,
    chest: null,
    neckDefault: 30,
    chestDefault: 46,
    build: "Standard Proportions",
    category: "standard",
    isFallback: true
  };

  var BUILD_OPTIONS = [
    "Slender / Elegant", "Proportional / Low Profile", "Petite / Low Profile",
    "Heavy / Muscular", "Compact / Broad", "Athletic / Standard", "Standard Proportions"
  ];

  // Display-only copy for the BODY & NECK BUILD dropdown. Each key is the
  // canonical short value stored in CURATED_BREEDS.build / buildForArchetype
  // / state.bodyBuild / MIXED_FALLBACK.build — that value never changes, so
  // every equality check against it (option `selected`, BUILD_TO_CATEGORY
  // lookups) keeps working untouched. Only the rendered <option> text is
  // the longer, example-laden string below.
  var BUILD_OPTION_LABELS = {
    "Slender / Elegant": "Slender / Elegant — Long & Delicate Neck (e.g., Whippet, Greyhound, Saluki)",
    "Athletic / Standard": "Athletic / Standard — Athletic / Standard Neck (e.g., Retriever, German Shepherd, Pointer, Vizsla)",
    "Standard Proportions": "Standard Proportions — Standard Neck (e.g., Border Collie, Spaniel, Aussie, Jack Russell)",
    "Proportional / Low Profile": "Proportional / Low Profile — Short Legs & Standard Neck (e.g., Dachshund, Corgi, Basset Hound)",
    "Petite / Low Profile": "Petite / Low Profile — Petite / Miniature Breed (e.g., Toy Poodle, Yorkie, Maltese, Pomeranian)",
    "Heavy / Muscular": "Heavy / Muscular — Thick & Muscular Neck (e.g., Staffy, Pit Bull, Rottweiler, Boxer)",
    "Compact / Broad": "Compact / Broad — Compact & Broad Neck (e.g., French Bulldog, Pug, Boston Terrier, Bullmastiff)"
  };

  // Reverse mapping used by the Step 2 build-select "double safety net"
  // (see the [data-build-select] change handler in renderScreen1): a
  // manual build pick is the ultimate source of truth for the
  // recommendation category, overriding whatever resolveBreedProfile()
  // derived from typed breed text, in either direction.
  //
  // "Compact / Broad" is deliberately OMITTED here — it is the one build
  // label that isn't anatomically unambiguous: CURATED_BREEDS pairs it with
  // both true bully breeds (French Bulldog, Boston Terrier, Pug) AND
  // non-bully standard breeds (Beagle, Pembroke Welsh Corgi). Forcing it to
  // "bully" silently reclassified a Beagle/Corgi into the bully track the
  // moment the build dropdown was touched. Every other label here maps to
  // exactly one category across every curated breed that uses it, so it's
  // safe to force an override for those.
  var BUILD_TO_CATEGORY = {
    "Slender / Elegant": "sighthound",
    "Petite / Low Profile": "toy",
    "Heavy / Muscular": "bully",
    "Athletic / Standard": "standard",
    "Proportional / Low Profile": "standard",
    "Standard Proportions": "standard"
  };

  // Core English sighthound keywords for the fuzzy text-matching safety net
  // in resolveBreedProfile() below — a typed mix like "Whippet Mix" or
  // "Greyhound x Lab" matches neither CURATED_BREEDS nor BREED_ARCHETYPES
  // exactly, but still deserves the sighthound-safe Wide collar routing.
  var SIGHTHOUND_KEYWORDS = ["whippet", "greyhound", "borzoi", "saluki", "afghan", "wolfhound"];

  function matchesSighthoundKeyword(normalizedText) {
    return SIGHTHOUND_KEYWORDS.some(function (kw) { return normalizedText.indexOf(kw) !== -1; });
  }

  function resolveBreedProfile(name) {
    var trimmed = String(name || "").trim();
    var key = trimmed.toLowerCase();
    // Escaped once here (display-only from this point on) since free-typed
    // breed text flows into innerHTML strings (guardrail copy, why-text).
    if (key && CURATED_BREEDS[key]) {
      return Object.assign({ name: escapeHtml(trimmed) }, CURATED_BREEDS[key]);
    }
    if (key && BREED_ARCHETYPES[key]) {
      return Object.assign({ name: escapeHtml(trimmed) }, deriveFromArchetype(trimmed, BREED_ARCHETYPES[key]));
    }
    // Sighthound double-safety net, text side: a typed mix (e.g. "Whippet
    // Mix") matches neither table above exactly, but still carries a
    // recognizable sighthound keyword. Route it to the sighthound
    // category/build — anatomically it still needs the Wide collar — instead
    // of silently falling through to generic Mixed Breed proportions below.
    // Numeric neck/chest defaults intentionally stay the generic fallback
    // values (no known real measurements for an unmatched mix); only the
    // recommendation category and the Step 2 build pre-select change.
    if (key && matchesSighthoundKeyword(key)) {
      return Object.assign({ name: escapeHtml(trimmed) }, MIXED_FALLBACK, { category: "sighthound", build: "Slender / Elegant" });
    }
    // Free text that matches nothing in the lookup table, or an explicit
    // "Mixed Breed / Other" pick, still resolves to real sizing defaults —
    // every named breed above this line always does. An EMPTY name (the
    // untouched initial state) is deliberately NOT relabeled to "Mixed
    // Breed / Other" here: that name is reserved for an actual explicit
    // choice, never silently assigned before the user has chosen anything.
    return Object.assign({ name: trimmed ? escapeHtml(trimmed) : "" }, MIXED_FALLBACK);
  }

  /* ============================================================
     Sizing engine (ported from the approved design's DCLogic)
     ============================================================ */

  // Commercial sizing matrices. Each *_NODES array is the FULL set of edges
  // — n+1 nodes bound n size tiers — not just the internal tie-points, so
  // the array endpoints double as the slider's own min/max. Collars and
  // harnesses use different letter ladders (harness adds XXXS) and
  // different node counts, so nothing here is shared between the two.
  var COLLAR_SIZES = ["XXS", "XS", "S", "M", "L", "XL"];
  var NECK_NODES = [17, 22, 27, 32, 37, 42, 47];
  // The neck slider itself is allowed to travel past the last standard node
  // (47cm / XL) up to this ceiling — that's the "premium custom collar"
  // zone, not a bug: anything > 47cm bypasses standard sizing entirely.
  var NECK_CUSTOM_MAX = 65;

  var HARNESS_SIZES = ["XXXS", "XXS", "XS", "S", "M", "L", "XL"];
  var CHEST_NODES = [26, 30, 34, 38, 46, 54, 64, 76];
  // Mirrors NECK_CUSTOM_MAX: the chest slider is allowed to travel past the
  // last standard node (76cm / XL) up to this ceiling — the "premium custom
  // harness" zone for giant breeds, not a bug. Anything > 76cm bypasses
  // standard sizing entirely instead of silently clamping to XL.
  var CHEST_CUSTOM_MAX = 120;

  // cm -> Size letter for a given node/letter pair. nodes.length must be
  // sizes.length + 1.
  function sizeFromValue(cm, nodes, sizes) {
    for (var i = 0; i < nodes.length - 1; i++) if (cm < nodes[i + 1]) return sizes[i];
    return sizes[sizes.length - 1];
  }

  // Index of the node array entry closest to cm, and its distance. dist===0
  // means cm landed exactly on a boundary node.
  function nearestBoundary(cm, nodes) {
    var best = null, bestDist = Infinity;
    nodes.forEach(function (n, i) {
      var d = Math.abs(cm - n);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return { index: best, dist: bestDist };
  }

  // A node at array index k sits between sizes[k-1] (lower) and sizes[k]
  // (upper); clamped at the two ends of the ladder since the outermost
  // nodes (the catalog's absolute floor/ceiling) have no size below/above.
  function boundaryLetters(nodeIndex, sizes) {
    return {
      lower: sizes[Math.max(0, nodeIndex - 1)],
      upper: sizes[Math.min(sizes.length - 1, nodeIndex)]
    };
  }

  // A cm value only counts as an interlock-triggering boundary when it
  // lands on a node (within `epsilon`) AND that node genuinely separates
  // two different Size letters. The catalog's absolute floor/ceiling nodes
  // (e.g. 17cm or 47cm for collars) clamp lower===upper — there is no
  // smaller/larger size to be ambiguous with, so nothing to resolve and
  // no reason to block the CTA there.
  //
  // epsilon defaults to 0 (exact match only) so every pre-existing call
  // site that hasn't been touched keeps its exact original behavior. Real
  // callers now pass BOUNDARY_TIE_EPSILON_CM (see that constant's own
  // comment) and the value being checked is state's separately-tracked
  // *Precise cm figure, not the already-rounded whole-cm one — see
  // buildMeasureVals/computeSize.
  function boundaryTie(cm, nodes, sizes, epsilon) {
    var nb = nearestBoundary(cm, nodes);
    if (nb.dist > (epsilon || 0)) return null;
    var letters = boundaryLetters(nb.index, sizes);
    if (letters.lower === letters.upper) return null;
    return letters;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  /* ----------------------------------------------------------------
     Unit display helpers (CM / IN toggle)

     Centimeters remain the ONLY unit the sizing engine itself ever sees —
     state.neckSize/chestSize, every *_NODES array, every breed range, and
     every function above this point (sizeFromValue/boundaryTie/rangeStatus)
     stay untouched integers. These helpers exist purely to translate a cm
     value to/from what Step 3 displays, at the two DOM edges (the slider's
     label and the number input) — never inside the engine itself.
     ---------------------------------------------------------------- */
  var CM_PER_INCH = 2.54;
  var UNIT_STORAGE_KEY = "lb-ff-unit";

  // Chart-consistent display conversion — same one-line formula already
  // used by lillebjorn-size-guide.js's own working cm/in toggle, verified
  // to reproduce the official Size Guide's inches column exactly (e.g.
  // cmToIn(32) === 12.6, matching the printed S/M boundary).
  function cmToIn(cm) { return Math.round(cm / CM_PER_INCH * 10) / 10; }

  // Inverse, used only when committing a typed/dragged inches value back
  // into the canonical cm state. Always rounds to a whole centimeter so
  // state.neckSize/chestSize never become fractional — that integer
  // guarantee is what keeps boundaryTie()/sizeFromValue() above completely
  // unaware a unit toggle exists.
  function inToCm(inches) { return Math.round(inches * CM_PER_INCH); }

  // The slider's Inches-mode step is 0.1in — deliberately matching cmToIn's
  // own precision (it always returns a multiple of 0.1) rather than a
  // "nicer-feeling" 0.25in quarter-inch. That match is what lets
  // measureBlockMarkup use cmToIn(min)/cmToIn(max) directly as the slider's
  // own endpoints below: since cmToIn's output always already sits exactly
  // on a 0.1in grid, there's no separate snapping helper needed the way a
  // coarser, non-matching step would require. It's also still comfortably
  // under 1cm (0.1in = 0.254cm): sampling a monotonic drag at a stride
  // smaller than the sizing engine's own 1cm quantization can never skip
  // past a whole centimeter, so every size-boundary node stays exactly as
  // reachable by dragging in Inches mode as it is in CM mode today.
  //
  // This does NOT make the slider and the settled number identical on
  // every single release, though — that's a common misconception worth
  // being precise about. Each whole centimeter still spans roughly 0.39in
  // (1/2.54), so 3-4 different 0.1in slider stops can all round to the
  // SAME committed centimeter, and only one of those stops is the exact
  // value cmToIn() would print for it. Release on one of the others and
  // the number still visibly settles by up to ~0.2in. What 0.1in actually
  // guarantees is narrower but just as important: every value this code
  // ever assigns to the slider is now exactly on its own grid, so the
  // browser's native range-input step-sanitization can never again
  // silently substitute a DIFFERENT value than the one assigned (the
  // actual bug this used to work around — see apply() below).
  var INCHES_SLIDER_STEP = 0.1;

  // How close a measurement must land to a size-boundary node to trigger
  // the LOOSE/SNUG interlock — evaluated against a *precise*, unrounded
  // cm-equivalent value (see state.neckPrecise/chestPrecise below), never
  // against the already-rounded whole-cm value used for the actual size
  // lookup. This distinction is the fix for a real bug: rounding a typed/
  // dragged inches reading to the nearest whole centimeter has a ~±0.2in
  // catchment (each cm spans ~0.39in), so in Inches mode a typed 12.5in or
  // 12.7in — a shopper who'd say they're clearly NOT on a boundary — both
  // happened to round to the exact same 32cm S/M node and triggered the
  // interlock just as often as an actual 12.6in reading would.
  //
  // The tolerance itself must be at least as large as cmToIn's OWN
  // one-decimal rounding error, or the chart's own printed boundary label
  // stops reliably triggering its own boundary — a real regression an
  // earlier, tighter 0.05cm value here actually had: 37cm's printed
  // boundary is "14.6in", but 14.6in converts back to 37.084cm, 0.084cm
  // away from the node itself, so a shopper typing the EXACT number this
  // component prints for that boundary ("14.6") failed to trigger it.
  // Auditing every node on both ladders found a worst case of 0.102cm
  // (chest's 54cm / "21.3in" M/L boundary). cmToIn rounds to the nearest
  // 0.1in, so its own worst-case error is bounded by half that step —
  // 0.05in — which converts to 0.127cm, comfortably covering every real
  // node with margin. Deriving it from INCHES_SLIDER_STEP rather than a
  // bare literal keeps that reasoning self-evident at the call site.
  //
  // One constant safely covers both units, no per-unit branch needed: in
  // CM mode the precise value is always a whole integer, so dist is always
  // either exactly 0 or >=1 — far outside even this larger tolerance — so
  // CM mode's behavior stays byte-for-byte exact-match-only regardless.
  var BOUNDARY_TIE_EPSILON_CM = (INCHES_SLIDER_STEP / 2) * CM_PER_INCH;

  // The single "which unit is the shopper looking at" formatter, shared by
  // every render path below (slider/number-input markup, live drag sync,
  // size-range labels, guardrail copy) so there is exactly one place that
  // decides cm-vs-in — not one ad hoc branch per call site.
  function formatMeasureDisplay(cm, unit) {
    return unit === "in" ? cmToIn(cm) : cm;
  }

  function rangeStatus(value, range) {
    if (!range) return { status: "none" };
    if (value < range[0]) {
      var diffLow = range[0] - value;
      return { status: diffLow <= 4 ? "amber" : "red", dir: "below", diff: diffLow };
    }
    if (value > range[1]) {
      var diffHigh = value - range[1];
      return { status: diffHigh <= 4 ? "amber" : "red", dir: "above", diff: diffHigh };
    }
    return { status: "none" };
  }

  // unit is optional and defaults to "cm" so any pre-existing call site that
  // hasn't been touched yet keeps producing today's exact output.
  function sizeRangeLabel(sizeLetter, nodes, sizes, noun, unit) {
    var idx = sizes.indexOf(sizeLetter);
    if (idx === -1) return "";
    var lo = nodes[idx], hi = nodes[idx + 1];
    // .toFixed(1) forces a consistent one-decimal look ("26.0", not "26")
    // even when cmToIn's rounding happens to land on a whole number — a
    // range like "26–33.9in" would otherwise read as an inconsistent mix
    // of decimal precisions for no reason a shopper could tell.
    if (unit === "in") return "Fits " + noun + " " + cmToIn(lo).toFixed(1) + "–" + cmToIn(hi).toFixed(1) + " in";
    return "Fits " + noun + " " + lo + "–" + hi + "cm";
  }

  var MEASURE_META = {
    neck: { nodes: NECK_NODES, sizes: COLLAR_SIZES, breedKey: "neck" },
    chest: { nodes: CHEST_NODES, sizes: HARNESS_SIZES, breedKey: "chest" }
  };

  /* ============================================================
     Leathers, product families, recommendation rules
     ============================================================ */

  var LEATHERS = [
    { key: "black", name: "Black", hex: "#111111" },
    { key: "red", name: "Red", hex: "#B31F24" },
    { key: "green", name: "Green", hex: "#1E4620" },
    { key: "blue", name: "Blue", hex: "#1D3354" },
    { key: "brown", name: "Brown", hex: "#9E5B38" }
  ];

  // Family keys correspond to the <script type="application/json"> product
  // blobs emitted by the Liquid section (one merchant-picked product each).
  //
  /* 2. DYNAMIC VARIANT MAPPING — "Classic" and "Wide" each structurally
     split into two distinct Shopify product LINES (Aeris vs Vero), not two
     finishes/widths of one product — every -classic/-wide key below is
     mapped to its own set of per-color settings in the Liquid section.
     "Classic" additionally splits into two width-bound cards (2cm + 3cm)
     per line, matching that product's own Width variant option. */
  // defaultWidth is the label shown when a product has no live Shopify
  // Width option to read a real value from (see the productCarriesWidthData
  // fallback in buildProductCards) — the fixed physical width that single-
  // SKU line actually ships in, not a guess.
  var PRODUCT_FAMILIES = {
    "aeris-classic": { type: "collar", widths: ["2cm", "3cm"], widthSplit: true, defaultWidth: "3cm" },
    "vero-classic": { type: "collar", widths: ["2cm", "3cm"], widthSplit: true },
    "aeris-wide": { type: "collar", widths: ["4.5cm"], defaultWidth: "4.5cm" },
    "vero-wide": { type: "collar", widths: ["4.5cm"], defaultWidth: "4.5cm" },
    // Leash is deliberately NOT declared here: unlike every family above,
    // its width is never one of a fixed set of ALTERNATIVE cards to
    // browse — it's a single DERIVED value per main card (see
    // resolveLeashForCard), so it never goes through buildProductCards'
    // family-expansion loop at all.
    "harness": { type: "harness", widths: [] }
  };

  // Human-readable label per family type — read by buildProductCards to
  // build each card's widthLabel, generalized here rather than two
  // hardcoded "COLLAR"/"HARNESS" strings inlined directly.
  var TYPE_LABELS = { collar: "COLLAR", harness: "HARNESS", leash: "LEASH" };

  // One-line product differentiators shown under each card's title on the
  // results screen (cardMarkup only — see familyDifferentiator below).
  // Copy is verbatim from COLLAR_CATALOG in calculator.html:1266-1270 and
  // the Vero Harness entry at calculator.html:1370 — nothing paraphrased.
  // Keyed by the same familyKey (+ width, for vero-classic's two lines)
  // buildProductCards already computes; never by product.title/description,
  // which stay exactly as they were for every existing matching/sizing
  // decision.
  var FAMILY_DIFFERENTIATOR = {
    "aeris-classic": "A collar designed for comfortable neck support on any dog, big or small.",
    "aeris-wide": "A wider, breathable collar designed to protect and support long necks.",
    "vero-wide": "Wide collar designed to protect and support long necks, from small breeds to large.",
    "harness": "An adjustable leather harness designed to sit comfortably above the shoulder.",
    "vero-classic": {
      "3cm": "A classic, slightly wider collar for added neck support and comfort.",
      "2cm": "A classic collar crafted for shorter necks and smaller frames."
    }
  };

  function familyDifferentiator(familyKey, width) {
    var entry = FAMILY_DIFFERENTIATOR[familyKey];
    if (!entry) return "";
    if (typeof entry === "string") return entry;
    return entry[width] || "";
  }

  /* ============================================================
     UPSELL SYSTEM — Walk Kit / Complete Bundle
     ------------------------------------------------------------
     Two mutually exclusive merchandising tiers layered on top of the
     results screen, decided by what the shopper already chose in Screen 1
     (s.selectionId), never both offered on the same card at once:
       - Walk Kit (single-item selections — "collar" or "harness" alone):
         this ONE item + a color- and size-matched Leash, 10% off the set.
       - Complete Bundle (the "Collar & Harness Bundle" selection only):
         THIS card's item + its sibling item (the other main card already
         on screen — see findBundlePartnerCard) + a matching Leash, 10%
         off the whole set.
     They're mutually exclusive by design, not merely by convention: on
     the Bundle selection, both the collar card AND the harness card would
     otherwise each independently offer their own "+ Leash" tier, and a
     shopper could click both and silently double-add a leash. Making
     Complete Bundle the ONLY upsell tier available there (see
     buildUpsellTiers) removes that risk structurally instead of trying to
     lock it at cart-add time.
     The discount is never computed as a fake client-side discount applied
     at checkout — see addToCart below, which relies on a real Shopify
     Automatic Discount configured against this exact fixed product list
     to actually reduce the order total. The numbers shown here exist so
     the shopper sees the same total BEFORE checkout that Shopify's own
     discount engine will charge, not to enforce it themselves.
     The rate itself now comes from the section's own
     "Displayed discount percentage" setting (data-bundle-discount-percent,
     read in connectedCallback into this.bundleDiscountRate) instead of
     being hardcoded — that setting's own paragraph copy is the one place
     a merchant is told to keep it equal to the real Automatic Discount's
     percentage. UPSELL_DISCOUNT_RATE_DEFAULT below is only the fallback
     for a missing/invalid attribute (e.g. an older cached section render
     from before this setting existed), not the value actually used.
     ============================================================ */
  var UPSELL_DISCOUNT_RATE_DEFAULT = 0.10;

  var CART_BAG_ICON_SVG = '<svg class="lb-ff__cta-icon" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M4.5 5.7V4.3a3.5 3.5 0 0 1 7 0v1.4" stroke-width="1.3" stroke-linecap="round"/><rect x="2.3" y="5.7" width="11.4" height="8.3" rx="1.4" stroke-width="1.3"/></svg>';
  var CART_LOCK_ICON_SVG = '<svg class="lb-ff__secure-icon" width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><rect x="3.4" y="7.2" width="9.2" height="6.6" rx="1.2" stroke-width="1.3"/><path d="M5.4 7.2V5a2.6 2.6 0 0 1 5.2 0v2.2" stroke-width="1.3" stroke-linecap="round"/></svg>';

  // Single source of truth for the Add to Cart button's "ready" (buyable,
  // not out-of-stock/just-added) label — read both when cardMarkup first
  // renders it and when addToCart restores it after the "ADDED ✓" cosmetic
  // window, via the button's own data-ready-label attribute (see both call
  // sites), so the two can never drift out of sync with each other. Bag
  // icon + short category label + price. Deliberately the short category
  // name (COLLAR / WALK KIT / BUNDLE — the same category logic Size Guide
  // already uses for its eyebrow), NOT the real Shopify product title:
  // titles like "Vero Classic Collar & Leash in Black" made this button's
  // text wrap onto multiple lines and read as noise. Every call site
  // already has its own short category label available (cardMarkup's own
  // `eyebrow`, bundlePairMarkup's tier-derived label) by the time this is
  // called.
  function cartCtaLabelHtml(shortCategoryLabel, priceText) {
    return CART_BAG_ICON_SVG +
      '<span class="lb-ff__cta-text">ADD ' + escapeHtml(String(shortCategoryLabel).toUpperCase()) + ' TO CART' +
      (priceText ? ' — ' + escapeHtml(priceText) : '') +
      '</span>';
  }

  /* ---------- Leash width mapping (real catalog: 1.5cm / 2cm only) ----------
     The leash catalogue is genuinely simpler than the collar/harness one —
     exactly two widths, no anatomical allowlist, no puppy-copy branching.
     Width is derived from whichever size letter was ALREADY resolved for
     the paired collar/harness card (c.size in buildUpsellTiers below), via
     one flat lookup per item type — never re-derived from breed category.

     Collar: COLLAR_SIZES = ["XXS","XS","S","M","L","XL"] (6 letters) —
     matches the brief's exact thresholds with no ambiguity.

     Harness: HARNESS_SIZES = ["XXXS","XXS","XS","S","M","L","XL"] (7
     letters — one smaller than collar's scale, confirmed against the real
     array above, not assumed). The brief names exact letters only for the
     2cm side ("medium, large, extra-large" = M/L/XL); "smaller end of the
     harness range" is filled in here as everything below M (XXXS/XXS/XS/S)
     rather than guessing a different split — this is the one boundary
     worth a human sign-off on if the real intent draws the line elsewhere
     (e.g. XXXS/XXS only). */
  var LEASH_WIDTH_BY_COLLAR_SIZE = {
    XXS: "1.5cm", XS: "1.5cm", S: "1.5cm",
    M: "2cm", L: "2cm", XL: "2cm"
  };
  var LEASH_WIDTH_BY_HARNESS_SIZE = {
    XXXS: "1.5cm", XXS: "1.5cm", XS: "1.5cm", S: "1.5cm",
    M: "2cm", L: "2cm", XL: "2cm"
  };

  // Leash "Size" option is repurposed to mean STYLE ("Classic" / "Hands
  // Free") rather than a dog size — the leash has no dog-size dimension of
  // its own, and reusing the option resolveVariant already parses generically
  // means zero changes are needed to lillebjorn-product-json.liquid's
  // option-name parsing (it already extracts whatever a product's "Size"
  // option values are, sight-unseen of what they mean).
  var LEASH_STYLE_DEFAULT = "Classic";
  // The two real values a leash product's repurposed "Size" option must
  // use, verbatim — read by the leash selector (see cardMarkup's/
  // bundlePairMarkup's leashSectionHtml) to render both options and by
  // nothing else, so adding a third style later is exactly a one-line
  // change to this array.
  //
  // IMPORTANT — these are LOOKUP VALUES, not display copy. "Hands Free"
  // (not "Omni Hands Free") is load-bearing: it's this.state.leashStyle
  // verbatim, which resolveLeashForCard's colorMap branch compares
  // against AND which resolveKitAsset uses as a literal object key into
  // upsell.kitImagery[tierKey][designId][color][...] — and that JSON
  // tree is built by snippets/lillebjorn-kit-collection-scan.liquid's
  // own `scan_styles = 'Classic,Hands Free' | split: ','`, which is
  // hardcoded Liquid-side and NOT sourced from this array. A previous
  // pass renamed this array's entry to "Omni Hands Free" for display
  // purposes and broke both of those lookups silently (kit photos always
  // fell back to the base single-item photo for this style, since
  // "Omni Hands Free" was never a real key in the Liquid-emitted JSON).
  // The merchant-facing "Omni Hands Free" name lives ONLY in
  // LEASH_STYLE_DISPLAY_NAME below now — never in this array — so
  // renaming what shoppers SEE can never again silently break what this
  // component looks UP.
  var LEASH_STYLE_OPTIONS = ["Classic", "Hands Free"];
  // Display-only label per style — the one place a shopper-facing rename
  // (e.g. "Hands Free" -> "Omni Hands Free", the merchant's actual product
  // line name) is safe to make, since nothing here is ever used as a
  // lookup key. Falls back to the raw value itself if a style somehow has
  // no entry, so a missing mapping degrades to a slightly-wrong label
  // instead of "undefined" in the UI.
  var LEASH_STYLE_DISPLAY_NAME = {
    "Classic": "Classic",
    "Hands Free": "Omni Hands Free"
  };
  // One short, functional (not marketing-fluffy) sentence per style, shown
  // on BOTH options at once (redesigned selector — see leashSectionHtml —
  // no longer swaps a single caption in/out on toggle) — answers "why
  // would I pick this one" for each option side by side, letting a
  // shopper compare before choosing rather than having to click one to
  // learn what the other does. Keyed by the exact LEASH_STYLE_OPTIONS
  // values (the lookup values, not LEASH_STYLE_DISPLAY_NAME's labels) so
  // a missing entry is obvious.
  var LEASH_STYLE_DESCRIPTIONS = {
    "Classic": "Traditional handheld lead — clip it on and hold, just like your dog's current leash.",
    // Dropped "walking multiple dogs" (not a real use case this
    // single-strap style actually supports) in favor of naming the
    // activities it's actually built for.
    "Hands Free": "Adjustable cross-body strap — worn hands-free for runs, hikes, or everyday walks."
  };
  // Small-caps subtitle under each style's name in the redesigned selector
  // — names the WEARING mode plainly (handheld vs. worn cross-body) before
  // the shopper even reads the fuller description below it.
  var LEASH_STYLE_SUBTITLE = {
    "Classic": "Handheld",
    "Hands Free": "Cross-body"
  };

  // Anatomical width matrix — identical for adults and puppies (only the
  // Step 4 disclaimer copy differs by age; the family/width routing itself
  // never changes with isPuppy). Wide 4.5cm is reserved exclusively for
  // Sighthound's long-neck support and is never pushed as a baseline for
  // Bully/Standard, and never withheld from a Sighthound puppy.
  // Toy previously routed to a fictional "narrow-2cm" line (an "Aeris
  // Narrow" that was never a real product). Vero Classic is the only real
  // family that actually carries a genuine 2cm variant (Aeris Classic ships
  // 3cm only — see PRODUCT_FAMILIES + the dynamic width filter in
  // buildProductCards), so toy now points at the real thing instead.
  //
  // Family membership here is necessary but not sufficient — it's further
  // narrowed by CATEGORY_WIDTH_ALLOWLIST below (a hard anatomical gate on
  // which WIDTHS within those families are actually safe to show). Bully's
  // alt is intentionally empty: Wide 4.5cm was never anatomically correct
  // as a bully cross-sell (that width exists for sighthound throat support,
  // not a bully's thick neck base), and 2cm is banned outright for bully —
  // there is no other real product left to offer as a bully cross-sell.
  var RECOMMENDATION_RULES = {
    "sighthound": { main: ["aeris-wide", "vero-wide"], alt: ["aeris-classic", "vero-classic"] },
    "toy": { main: ["vero-classic"], alt: [] },
    "bully": { main: ["aeris-classic", "vero-classic"], alt: [] },
    "standard": { main: ["aeris-classic", "vero-classic"], alt: ["aeris-wide"] }
  };

  // Hard anatomical width gate — independent of, and narrower than, the
  // family lists above. A family being "recommended" for a category does
  // NOT mean every width it stocks is safe to show for that category:
  //   - bully: strictly 3cm only. A 2cm collar is never appropriate for a
  //     thick/muscular neck base, regardless of the dog's size bracket.
  //   - toy: strictly 2cm only. A 3cm collar is unnecessarily heavy/wide
  //     for a delicate, petite frame.
  //   - sighthound: 4.5cm for the main recommendation (unaffected here,
  //     since aeris-wide/vero-wide only ever carry 4.5cm) and 3cm for the
  //     cross-sell alt — never 2cm, which undercuts the exact throat-safety
  //     reasoning the Wide recommendation exists for.
  //   - standard has no fixed allowlist: small/medium standard breeds keep
  //     both 2cm and 3cm. They're still subject to the large-neck ceiling
  //     immediately below.
  var CATEGORY_WIDTH_ALLOWLIST = {
    "bully": ["3cm"],
    "toy": ["2cm"],
    "sighthound": ["3cm", "4.5cm"]
  };

  // Global large-neck ceiling, layered on top of the allowlist above and
  // applied regardless of category: once a dog's resolved collar size
  // reaches XL (neck >= 42cm — the L/XL boundary in NECK_NODES), a 2cm
  // collar is never offered again, full stop. A 2cm width is too flimsy
  // for that circumference no matter how the breed's build was classified.
  function isWidthAllowedForCategory(width, category, familyType, recNeckSize) {
    if (familyType !== "collar" || !width) return true; // harnesses have no width option
    var allowlist = CATEGORY_WIDTH_ALLOWLIST[category];
    if (allowlist && allowlist.indexOf(width) === -1) return false;
    if (width === "2cm" && recNeckSize === "XL") return false;
    return true;
  }

  // breed.name is blank whenever no breed was ever typed — both the plain
  // raw-measurement flow AND a manual Body & Neck Build pick made without
  // typing a breed override category but never touch name. Every WHY_TEXT
  // template below reads breed.name directly, so past this guard every
  // one of them would render as the grammatically broken "Given your 's
  // slender neck..." instead of a generic "your dog's".
  function breedPossessive(breed) {
    return (breed.name ? ("your " + breed.name) : "your dog") + "'s";
  }
  var WHY_TEXT = {
    "sighthound": function (breed) { return "Given " + breedPossessive(breed) + " slender, elegant neck, we prioritized a wider 4.5cm profile to distribute pressure evenly and protect the throat during quick turns."; },
    "bully": function (breed) { return "With " + breedPossessive(breed) + " powerful shoulders and thicker neck base, we matched our true-to-size Classic collar in a robust 3cm width for a precise, supportive fit."; },
    "toy": function (breed) { return "Given " + breedPossessive(breed) + " delicate frame, we matched a featherweight, narrow profile for a light, comfortable fit."; },
    "standard": function (breed) { return "We tailored this recommendation to " + breedPossessive(breed) + " build and measurements for a precise, comfortable fit."; }
  };

  // Step 4 puppy safety disclaimers, keyed by breed.category. The width
  // recommendation itself is identical to the adult routing above — this
  // text is the ONLY thing that changes for Growing Puppy.
  var PUPPY_COLLAR_DISCLAIMER = {
    "sighthound": "We recommended our Wide 4.5cm collar to properly protect and support your sighthound's delicate, long neck. Since your puppy is still growing, check the fit regularly to ensure safety.",
    "toy": "We recommended our ultra-light 2cm collar for your puppy's delicate frame. Since they are still growing, please check the collar tightness regularly.",
    "bully": "We recommended our comfortable 3cm Classic collar for your puppy's current proportions. Since your puppy is still growing, please check the fit regularly.",
    "standard": "We recommended our comfortable 2cm/3cm Classic collar for your puppy's current proportions. Since your puppy is still growing, please check the fit regularly."
  };
  var PUPPY_HARNESS_DISCLAIMER = "Since your puppy is still growing, please adjust the harness straps regularly to ensure a safe, secure fit as their proportions develop.";

  var OPTIONS = [
    { id: "collar", label: "Just a Collar", sub: "Tailored neck essentials for daily elegance.", types: ["collar"] },
    { id: "harness", label: "Just a Harness", sub: "Structured support for the everyday adventurer.", types: ["harness"] },
    { id: "bundle", label: "Collar & Harness Bundle", sub: "A complete wardrobe, cut from the same hide.", types: ["collar", "harness"] }
  ];

  /* ============================================================
     Variant resolution — matches computed Size/Width against the real
     Shopify variants emitted server-side by the Liquid section. Color is
     NOT a variant option here — each color is its own Shopify product (see
     productMap in connectedCallback), so color is resolved by picking which
     product to read before this function ever runs.
     ============================================================ */

  // The live catalogue names width options like "3cm (1.18 inch)", not the
  // bare "3cm" this component computes — Shopify appends the imperial
  // conversion automatically and merchants don't control that string. Match
  // on a leading-token basis instead of exact equality so real variants
  // resolve without renaming anything in Shopify.
  function widthMatches(optionValue, wantWidth) {
    if (!wantWidth || !optionValue) return true;
    var escaped = wantWidth.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return new RegExp("^" + escaped + "\\b", "i").test(String(optionValue).trim());
  }

  // Dynamic width filtering: family.widths (PRODUCT_FAMILIES) declares the
  // full set of widths that product LINE can anatomically carry, not a
  // promise that every product in that family carries a real Shopify Width
  // option for each one. Two distinct catalog shapes exist in practice:
  //  - A product WITH a real Width option (currently only Vero Classic) —
  //    productHasWidth() below checks which of the declared widths that
  //    specific product's variants actually stock.
  //  - A product with NO Width option at all (Aeris Classic, Aeris Wide,
  //    Vero Wide, Harness) — there's only one real SKU, so
  //    productCarriesWidthData() below is used instead, in
  //    buildProductCards(), to collapse multiple declared widths (e.g.
  //    Aeris Classic's ["2cm","3cm"]) down to a single undifferentiated
  //    card rather than guessing which declared number that one SKU is.
  function productCarriesWidthData(product) {
    return !!(product && product.variants && product.variants.some(function (v) {
      return v.options && v.options.width;
    }));
  }

  function productHasWidth(product, width) {
    if (!width || !product || !product.variants) return true;
    return product.variants.some(function (v) {
      return v.options && v.options.width && widthMatches(v.options.width, width);
    });
  }

  // Temporary diagnostic logging for the upsell tier pipeline — every call
  // site below is tagged "[lb-ff:diag]" so it's a single devtools filter
  // to isolate, and each one is a plain console.log (not console.debug) so
  // it survives whatever the browser's default console level is. Silenced
  // by default via LBFF_DEBUG rather than deleted at each call site —
  // dozens of call sites carry real diagnostic value for the next time
  // something like the "tiers completely missing" issue comes up, and
  // ripping them all out would mean rewriting them from scratch then. Flip
  // LBFF_DEBUG to true (e.g. from the console: a real customer-facing
  // storefront should never ship with this true) to bring every one of
  // them back with no other code changes.
  var LBFF_DEBUG = false;
  function lbffDiag(label, data) {
    if (!LBFF_DEBUG) return;
    console.log("[lb-ff:diag] " + label, data);
  }

  // Strict Stock Rule: Size and Width are NEVER relaxed — a missing
  // width at the resolved size simply resolves to null (card renders
  // UNAVAILABLE). The size letter computed in Step 4 is never upgraded or
  // substituted to paper over a stock gap.
  //
  // NOTE — a real asymmetry worth checking first: widthOk below matches
  // case-insensitively via widthMatches' regex, but sizeOk is a STRICT
  // `===` string comparison. Since the leash catalogue repurposes "Size"
  // to mean STYLE ("Classic"/"Hands Free" — see resolveLeashForCard), if a
  // real Shopify variant's Size option value is anything other than the
  // exact literal string passed in `want.size` (e.g. "classic" lowercase,
  // or "Classic " with a trailing space), every one of that leash
  // product's variants will silently fail sizeOk and resolveVariant will
  // return null — no error, no card, tier just doesn't render. The log
  // below prints every candidate variant's real options.size next to
  // want.size specifically so a mismatch here is visible immediately
  // instead of having to guess.
  function resolveVariant(productData, want) {
    if (!productData || !productData.variants) return null;
    var pool = productData.variants.filter(function (v) { return v.available !== false; });
    if (!pool.length) {
      // Logging the FULL raw object here, not just title/count: a real,
      // fully-resolved Shopify product can never legitimately have zero
      // variants (Shopify guarantees every product ships with at least
      // one, even an unconfigured "Default Title"). If productTitle is
      // null AND variants is empty, this is not a stock/matching problem
      // this function can fix — it's the signature of Liquid's `product`
      // reference being non-nil (so lillebjorn-product-json.liquid's
      // {%- if product -%} branch ran) while that specific product's own
      // fields came back empty: almost always because the referenced
      // product isn't published to the Online Store channel, is a draft,
      // or isn't published to the market/channel currently being viewed.
      // Dumping the whole object (not just two derived fields) here so
      // that's visible directly instead of inferred from two numbers.
      // Storefront market/currency/locale context logged alongside it —
      // real Shopify.* globals only, guarded defensively since none of
      // them are guaranteed present on every theme/page — so a genuine
      // per-market difference (the working theory under investigation)
      // is visible directly on the same log line as the empty product,
      // not something to cross-reference from a separate screenshot.
      lbffDiag("resolveVariant: no AVAILABLE variants on this product at all — see NOTE above this log line before assuming this is a code bug", {
        rawProductData: productData,
        storefrontContext: {
          shopifyCurrencyActive: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : null,
          shopifyCountry: (window.Shopify && window.Shopify.country) || null,
          shopifyLocale: (window.Shopify && window.Shopify.locale) || null,
          documentLang: document.documentElement.lang || null,
          pageUrl: window.location.href
        }
      });
      return null;
    }

    var sizeOk = function (v) { return !want.size || !v.options.size || v.options.size === want.size; };
    var widthOk = function (v) { return !want.width || !v.options.width || widthMatches(v.options.width, want.width); };

    var found = pool.filter(function (v) { return sizeOk(v) && widthOk(v); });

    lbffDiag("resolveVariant candidates", {
      productTitle: productData.title,
      wanted: want,
      candidates: pool.map(function (v) {
        return {
          variantId: v.id,
          "options.size (raw)": v.options.size,
          "options.width (raw)": v.options.width,
          sizeMatched: sizeOk(v),
          widthMatched: widthOk(v)
        };
      }),
      matchedCount: found.length,
      resolvedVariantId: found[0] ? found[0].id : null
    });

    return found[0] || null;
  }

  // Resolves the ONE real leash variant for a given main card. Two
  // independent things vary the result:
  //  - WIDTH (1.5cm/2cm) is DERIVED from that card's own already-resolved
  //    size letter (c.size) — never independently browsed the way collar
  //    width alternatives are.
  //  - STYLE ("Classic"/"Hands Free") now picks which PRODUCT COLOR-MAP to
  //    resolve against, not a variant option within one product: there is
  //    only ONE Leash picker per color in the theme editor (always the
  //    Classic product — see the section settings), so "Hands Free" reads
  //    from upsell.leashHandsFreeColorMap instead, a SEPARATE product the
  //    Liquid section discovers automatically by scanning
  //    collections['hands-free-leashes'] for a color + style-token match
  //    (see snippets/lillebjorn-leash-alt-lookup.liquid) rather than a
  //    second admin field.
  // Returns null — never a substituted width/style/product — the instant
  // any input is missing, matching this file's Strict Stock Rule
  // everywhere else: a shopper never silently gets the wrong leash.
  function resolveLeashForCard(c, upsell, leashStyle) {
    var diagBase = { familyKey: c.familyKey, size: c.size, leashStyle: leashStyle, selectedLeather: upsell && upsell.selectedLeather };

    var colorMap = leashStyle === "Hands Free" ? (upsell && upsell.leashHandsFreeColorMap) : (upsell && upsell.leashColorMap);
    if (!colorMap) {
      lbffDiag("resolveLeashForCard: no color map at all for the requested style — for \"Classic\" this means no Leash color is mapped in the section settings at all; for \"Hands Free\" it means the Liquid section's collections['hands-free-leashes'] scan (see lillebjorn-leash-alt-lookup.liquid) never reached productMap", diagBase);
      return null;
    }
    var productData = colorMap[upsell.selectedLeather] || null;
    if (!productData) {
      lbffDiag(
        leashStyle === "Hands Free"
          ? "resolveLeashForCard: no Hands Free counterpart was discovered for this color — no product in collections['hands-free-leashes'] matched both this color and an omni/hands-free style token; check that collection's membership/tagging"
          : "resolveLeashForCard: no Leash product mapped for this exact leather color — check the \"Leash\" settings block in the theme editor for this color",
        diagBase
      );
      return null;
    }

    var family = PRODUCT_FAMILIES[c.familyKey];
    if (!family) {
      lbffDiag("resolveLeashForCard: familyKey doesn't exist in PRODUCT_FAMILIES at all (should never happen for a real main card)", diagBase);
      return null;
    }
    var category = family.type; // "collar" or "harness" — the item-type category this function's width mapping actually branches on (breed category, e.g. "sighthound", is NOT an input to leash width — see the width-mapping comment above LEASH_WIDTH_BY_COLLAR_SIZE)
    var widthMap = category === "collar" ? LEASH_WIDTH_BY_COLLAR_SIZE : LEASH_WIDTH_BY_HARNESS_SIZE;
    var width = widthMap[c.size];
    if (!width) {
      lbffDiag("resolveLeashForCard: this card's size letter has no entry in the width-mapping table for its category — check c.size against LEASH_WIDTH_BY_COLLAR_SIZE/LEASH_WIDTH_BY_HARNESS_SIZE's exact keys (case-sensitive)", Object.assign({}, diagBase, { category: category, widthMapUsed: category === "collar" ? "LEASH_WIDTH_BY_COLLAR_SIZE" : "LEASH_WIDTH_BY_HARNESS_SIZE", availableSizeKeys: Object.keys(widthMap) }));
      return null;
    }

    lbffDiag("resolveLeashForCard: attempting variant lookup", Object.assign({}, diagBase, { category: category, resolvedLeashWidth: width, leashProductTitle: productData.title, leashProductVariantCount: productData.variants ? productData.variants.length : 0 }));

    // Style is no longer a variant-level filter here (see the function
    // comment above) — width is the only real axis left to match on
    // within whichever product (Classic or Omni Hands Free) colorMap
    // already selected.
    var variant = resolveVariant(productData, { size: null, width: width });
    if (!variant) {
      lbffDiag("resolveLeashForCard: OUT OF STOCK / NO MATCHING VARIANT — resolveVariant found no available variant matching this width. See the \"resolveVariant candidates\" log immediately above this one for the exact options.width values that were actually compared.", Object.assign({}, diagBase, { category: category, resolvedLeashWidth: width }));
      return null;
    }
    lbffDiag("resolveLeashForCard: RESOLVED", Object.assign({}, diagBase, { category: category, resolvedLeashWidth: width, resolvedVariantId: variant.id }));
    return { variant: variant, width: width, style: leashStyle, title: productData.title, url: productData.url };
  }

  // Complete Bundle's other main item — the FIRST other-type card in
  // `allCards` with a real variant (deterministic: collar families are
  // always listed before harness in renderScreen3's mainFamilies array,
  // and within collar families themselves in RECOMMENDATION_RULES' own
  // declared order). Worth flagging explicitly rather than treating as an
  // obviously-correct default: when the current card is the Harness and
  // more than one collar width card is on screen (e.g. Vero Classic
  // 2cm AND 3cm both eligible), this always pairs with whichever one
  // renders FIRST — not a size-aware "best" pairing, since there's no
  // single unambiguous "the" collar once a family legitimately offers
  // more than one width alternative.
  function findBundlePartnerCard(c, allCards) {
    var myType = (PRODUCT_FAMILIES[c.familyKey] || {}).type;
    var partner = (allCards || []).filter(function (other) {
      var otherType = (PRODUCT_FAMILIES[other.familyKey] || {}).type;
      return otherType && otherType !== myType && other.variant;
    })[0];
    return partner || null;
  }

  // "Aeris"/"Vero"/"Harness" — the design-LINE identifier a card's photos
  // are actually shot around, not the coarser collar-vs-harness item type
  // (an Aeris Classic and an Aeris Wide card share the same kit photo per
  // color; a Vero one doesn't). Derived from the familyKey string itself
  // (the segment before its first "-") rather than a second hand-maintained
  // table, so it can never drift out of sync with PRODUCT_FAMILIES' own
  // keys above. Matches the design_id the Liquid section's collection
  // scanner searches product titles/tags/type for — see
  // snippets/lillebjorn-kit-collection-scan.liquid.
  function designIdentifierForFamily(familyKey) {
    var base = String(familyKey).split("-")[0];
    return base.charAt(0).toUpperCase() + base.slice(1);
  }

  // Real pre-composed studio photography AND the real catalog title for
  // the Walk Kit / Complete Bundle tiers — deliberately NOT a CSS-
  // composited stack of the individual item + leash photos, and NOT a
  // synthesized "[Family] Walk Kit in [Color]" string. upsell.kitImagery
  // is shaped
  // { walkkit: { Aeris: { colorKey: { styleKey: { widthKey: { url, title } } } }, ... },
  //   bundle: {...same shape...} }, populated by the Liquid section's real
  // collection scan (collections['dog-walk-kits'] / ['bundles-collection']
  // — see snippets/lillebjorn-kit-collection-scan.liquid), not a
  // merchant-picked image setting and not a guessed handle. Both url and
  // title come from the SAME matched real Shopify product in that scan —
  // never assembled or guessed independently of one another. Falls back
  // to null (caller uses the card's own plain single-item photo/title)
  // rather than a broken <img> or a wrong heading the moment any one
  // level of that lookup is missing — same degrade-quietly rule as every
  // other "no match found yet" path in this file, and specifically why
  // the Liquid scanner must emit EMPTY strings for both fields on a miss
  // rather than some other placeholder: a generic stand-in here would
  // look like a real (but wrong) kit photo/title instead of correctly
  // falling through to this exact card's own accurate ones.
  // leashStyle is a lookup level (tierKey -> designId -> color -> style)
  // so switching the Classic/Hands Free toggle can swap in a genuinely
  // different pre-composed photo — this is this.state.leashStyle's raw
  // lookup VALUE ("Hands Free"), never LEASH_STYLE_DISPLAY_NAME's shopper-
  // facing label ("Omni Hands Free") — see LEASH_STYLE_OPTIONS' own
  // comment for why conflating those two previously broke this exact
  // lookup. Width is the FINAL level, keyed by the card's own c.width
  // (e.g. "2cm"/"3cm"/"4.5cm") with "_" reserved for design lines that
  // have no real width option (e.g. Harness) — this is what lets a Vero
  // Classic 2cm card and a Vero Classic 3cm card, which share the same
  // design/color/style bucket, still resolve to two different real
  // products.
  //
  // Returns { url: string, title: string } or null — NEVER a bare url
  // string (renamed from the old resolveKitPhoto for exactly this reason:
  // a caller silently treating this as a url again would break the moment
  // this shape changed).
  function resolveKitAsset(c, upsell, tierKey, leashStyle) {
    if (!upsell || !upsell.kitImagery) {
      lbffDiag("resolveKitAsset: upsell.kitImagery is entirely missing — the Liquid section's \"kit-imagery\" JSON key never reached productMap (falls back to the card's own base photo/title, which is correct/harmless, but check this if photos/titles are unexpectedly generic)", { familyKey: c.familyKey, tierKey: tierKey });
      return null;
    }
    if (tierKey !== "walkkit" && tierKey !== "bundle") return null;

    var designId = designIdentifierForFamily(c.familyKey);
    // The exact string this looks up productMap["kit-imagery"][tierKey]
    // with — compare this LOGGED value's casing character-by-character
    // against the real keys visible by running
    // JSON.stringify(document.querySelector('[data-lb-ff-products]').textContent)
    // in devtools (or just this.productMap["kit-imagery"] on the element
    // instance) — "Vero" (JS, capitalized) vs "vero" (a Liquid output that
    // wasn't capitalized) would silently miss right here.
    var availableDesignKeys = upsell.kitImagery[tierKey] ? Object.keys(upsell.kitImagery[tierKey]) : [];
    var byDesign = upsell.kitImagery[tierKey] && upsell.kitImagery[tierKey][designId];
    var byColor = byDesign && byDesign[upsell.selectedLeather];
    // Logged unconditionally (not just on a miss) so a leashStyle
    // spelling mismatch between this JS file's lookup VALUE and the
    // Liquid-emitted JSON key (exactly the bug that broke this lookup
    // once already — see LEASH_STYLE_OPTIONS' own comment) is visible
    // directly in this one log line instead of requiring a second,
    // separate devtools inspection to discover.
    var availableStyleKeysAtColor = byColor ? Object.keys(byColor) : [];
    var byStyle = byColor && byColor[leashStyle];
    var widthKey = c.width || "_";
    // .url (not the bucket object itself) is the truthiness check here —
    // the Liquid scanner emits { url: "", title: "" } (never omits the
    // key) on a miss, and an object literal is always truthy even when
    // both its fields are empty strings, so checking the bucket itself
    // would wrongly treat "found the bucket, but it's a miss" as success.
    var atWidth = byStyle && byStyle[widthKey];
    var atFallbackWidth = byStyle && byStyle["_"];
    var chosen = (atWidth && atWidth.url) ? atWidth : ((atFallbackWidth && atFallbackWidth.url) ? atFallbackWidth : null);

    lbffDiag("resolveKitAsset: lookup", {
      familyKey: c.familyKey,
      tierKey: tierKey,
      leashStyle: leashStyle,
      widthKey: widthKey,
      lookupKey: "kitImagery[\"" + tierKey + "\"][\"" + designId + "\"][\"" + upsell.selectedLeather + "\"][\"" + leashStyle + "\"][\"" + widthKey + "\"]",
      designIdComputedByJS: designId,
      availableDesignKeysInLiquidOutput: availableDesignKeys,
      designKeyExistsInLiquidOutput: availableDesignKeys.indexOf(designId) !== -1,
      availableStyleKeysAtThisColorInLiquidOutput: availableStyleKeysAtColor,
      styleKeyExistsInLiquidOutput: availableStyleKeysAtColor.indexOf(leashStyle) !== -1,
      selectedLeather: upsell.selectedLeather,
      result: chosen || "(empty — falls back to base product photo/title)"
    });

    return chosen;
  }

  // Appends the exact ALREADY-RESOLVED variant (c.variant — this card's
  // own size/color match, done once by resolveVariant when the card was
  // built) to its product url, so clicking through lands a shopper on the
  // precise variant they were just shown here rather than the product's
  // own default. No variant (out of stock — c.variant is null) or no url
  // at all just returns whatever url there is, same degrade-quietly rule
  // as everywhere else in this file.
  function variantUrl(c) {
    if (!c.url || !c.variant) return c.url || "";
    return c.url + (c.url.indexOf("?") === -1 ? "?" : "&") + "variant=" + c.variant.id;
  }

  // Inserts thousandsSep every 3 digits from the right of the integer part,
  // then joins the decimal part (if any) with decimalSep. The \B...(?!\d)
  // lookahead is the standard "insert only on exact multiples of 3
  // remaining digits" idiom — it never fires inside a number that's
  // already shorter than 4 digits, and never leaves a stray separator at
  // the very start of the string.
  function formatNumber(value, decimals, thousandsSep, decimalSep) {
    var sign = value < 0 ? "-" : "";
    var fixed = Math.abs(value).toFixed(decimals);
    var parts = fixed.split(".");
    var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return sign + withThousands + (parts[1] ? decimalSep + parts[1] : "");
  }

  // Every standard Shopify money_format placeholder Liquid's own `money`
  // filters produce, not just the plain {{amount}} this originally shipped
  // with — a market/currency (e.g. Indonesia/IDR) whose money_format uses
  // any of the others was rendering the raw, un-substituted "{{...}}"
  // literally, since the old version only ever replaced amount /
  // amount_no_decimals and left every other token untouched.
  var MONEY_FORMATS = {
    amount: { decimals: 2, thousands: ",", decimal: "." },
    amount_no_decimals: { decimals: 0, thousands: ",", decimal: "." },
    amount_with_comma_separator: { decimals: 2, thousands: ".", decimal: "," },
    amount_no_decimals_with_comma_separator: { decimals: 0, thousands: ".", decimal: "," },
    amount_with_space_separator: { decimals: 2, thousands: " ", decimal: "," },
    amount_no_decimals_with_space_separator: { decimals: 0, thousands: " ", decimal: "," }
  };

  // Fires a GA4 event. This store loads GA4 as plain gtag.js via Shopify's
  // Google & YouTube channel (tags G-Y1BK52L3YX / GT-M38ZW6BB /
  // AW-17296394969) and has NO GTM container — verified on the live
  // storefront, where window.google_tag_manager holds zero GTM-* keys.
  //
  // That distinction is the whole reason this function looks like it does.
  // gtag.js only acts on command-shaped ("arguments") dataLayer entries;
  // a plain dataLayer.push({event: name}) is a GTM convention, and with no
  // container to run a Custom Event trigger it is inert. The previous
  // version of this helper used exactly that contract, so every event it
  // "fired" landed in the array correctly shaped and was read by nobody —
  // 90 days of these reached GA4 as precisely zero rows. gtag() is
  // therefore the primary path, with dataLayer.push kept as a fallback so
  // this keeps working unchanged if a GTM container is ever added.
  //
  // send_to pins delivery to the GA4 tag alone. Without it gtag broadcasts
  // to every configured target, which would fold these interaction events
  // into the Google Ads conversion tag (AW-17296394969) too.
  //
  // `tool` is stamped here rather than at each call site so this drawer and
  // the size-guide page emit one shared sizing_tool_* event family
  // separated by a single dimension, directly comparable in one GA4 report.
  // Keep in sync with the matching helper in lillebjorn-size-guide.js.
  var LBFF_GA4_MEASUREMENT_ID = "G-Y1BK52L3YX";

  function trackSizingEvent(name, payload) {
    var params = Object.assign({ tool: "fit_finder" }, payload || {});
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", name, Object.assign({ send_to: LBFF_GA4_MEASUREMENT_ID }, params));
        return;
      }
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
    } catch (e) {
      // A broken or blocked analytics tag must never affect the drawer
      // itself (same defensive posture as the Shopify.analytics.publish
      // try/catch in addToCart below).
      console.warn("lillebjorn-fit-finder: analytics event failed", e);
    }
  }

  // Locks the underlying page's own scroll while the drawer is open — a
  // full-height overlay+drawer with the page still scrollable behind it
  // let the two scroll independently, which on a page barely taller than
  // the viewport could leave BOTH a native page scrollbar and the
  // drawer's own scrollbar visible side by side ("double scrollbar").
  // Module-level refcount (not a plain boolean) because this custom
  // element can legitimately exist more than once on a page — see
  // disconnectedCallback's own comment on a second reconnect — so one
  // instance's closeDrawer must not re-enable page scroll while another
  // instance's drawer is still open. Saves the pre-existing inline
  // overflow (nearly always "") rather than assuming it was unset, so a
  // theme that sets its own inline overflow on <html>/<body> gets it back
  // exactly as it was rather than a hard-coded guess.
  var lbffBodyScrollLockCount = 0;
  var lbffSavedHtmlOverflow = "";
  var lbffSavedBodyOverflow = "";
  function lockBodyScroll() {
    if (lbffBodyScrollLockCount === 0) {
      lbffSavedHtmlOverflow = document.documentElement.style.overflow;
      lbffSavedBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
    lbffBodyScrollLockCount++;
  }
  function unlockBodyScroll() {
    lbffBodyScrollLockCount = Math.max(0, lbffBodyScrollLockCount - 1);
    if (lbffBodyScrollLockCount === 0) {
      document.documentElement.style.overflow = lbffSavedHtmlOverflow;
      document.body.style.overflow = lbffSavedBodyOverflow;
    }
  }

  function money(cents, format) {
    // typeof NaN === "number" is true, so a plain typeof check alone would
    // let a NaN through and render the literal string "€NaN" — explicitly
    // excluded here too.
    if (typeof cents !== "number" || isNaN(cents)) return "";
    var value = cents / 100;

    // Longest/most-specific tokens listed first — real regex engines
    // backtrack through alternation when the trailing \s*\}\} fails to
    // match, so this ordering isn't strictly required for correctness, but
    // it keeps the intent (and the match) unambiguous at a glance.
    return (format || "€{{amount}}").replace(
      /\{\{\s*(amount_no_decimals_with_comma_separator|amount_no_decimals_with_space_separator|amount_with_comma_separator|amount_with_space_separator|amount_no_decimals|amount)\s*\}\}/g,
      function (match, token) {
        var spec = MONEY_FORMATS[token];
        return formatNumber(value, spec.decimals, spec.thousands, spec.decimal);
      }
    );
  }

  /* ============================================================
     The custom element
     ============================================================ */

  function LillebjornFitFinder() {
    return Reflect.construct(HTMLElement, [], LillebjornFitFinder);
  }
  Object.setPrototypeOf(LillebjornFitFinder.prototype, HTMLElement.prototype);
  Object.setPrototypeOf(LillebjornFitFinder, HTMLElement);

  LillebjornFitFinder.prototype.connectedCallback = function () {
    // Re-entry guard: without this, connectedCallback running a second time
    // on the same instance (custom elements fire it again on any reconnect
    // — e.g. moving the node, or a theme/app re-inserting it without going
    // through disconnectedCallback first) would re-run every step below —
    // appending a second copy of template() into the light DOM, appending
    // a SECOND overlay+drawer pair to document.body (the first, now
    // orphaned, never gets removed since it isn't a descendant of anything
    // this element's own section wrapper replacement would clean up),
    // and — the most damaging part — binding a second, permanent
    // document-level keydown listener via bindStaticEvents, stacking one
    // more on every reconnect with no bound. disconnectedCallback below
    // clears this flag on its way out, so a genuine disconnect-then-
    // reconnect still gets a full, clean re-init rather than being
    // permanently locked out.
    if (this._lbffInitialized) return;
    this._lbffInitialized = true;

    var self = this;
    this.classList.add("lb-ff");

    var dataScript = this.querySelector('script[data-lb-ff-products]');
    this.productMap = {};
    try {
      this.productMap = dataScript ? JSON.parse(dataScript.textContent) : {};
    } catch (e) {
      console.error("lillebjorn-fit-finder: could not parse product JSON", e);
    }

    this.supportEmail = this.getAttribute("data-support-email") || "support@thelillebjorn.com";
    this.moneyFormat = this.getAttribute("data-money-format") || "€{{amount}}";

    // Merchant-configurable "SAVE X%" rate for Walk Kit/Complete Bundle
    // tiers (see the "Walk Kit / Complete Bundle pricing" section
    // setting and UPSELL_DISCOUNT_RATE_DEFAULT's own comment above).
    // parseFloat + range/NaN guard rather than trusting the attribute
    // outright — a 0-50 range input can't produce anything invalid today,
    // but this attribute is also just a plain string on the DOM, editable
    // by anything, so it's validated the same as any other external input
    // rather than assumed safe because it usually comes from Liquid.
    var discountPercent = parseFloat(this.getAttribute("data-bundle-discount-percent"));
    this.bundleDiscountRate = (!isNaN(discountPercent) && discountPercent >= 0 && discountPercent <= 100)
      ? discountPercent / 100
      : UPSELL_DISCOUNT_RATE_DEFAULT;

    // Display-only preference — never touches the sizing engine, which
    // always sees neckSize/chestSize as plain cm integers regardless of
    // this flag (see the "Unit display helpers" above). localStorage can
    // throw in Safari private mode / sandboxed iframes, so a stored
    // preference is a best-effort read: any failure or unrecognized value
    // just falls back to "cm", never a fatal error.
    var storedUnit = "cm";
    try {
      var rawUnit = window.localStorage && window.localStorage.getItem(UNIT_STORAGE_KEY);
      if (rawUnit === "cm" || rawUnit === "in") storedUnit = rawUnit;
    } catch (e) {
      // Ignore — default to cm.
    }

    this.state = {
      open: false,
      screen: 0,
      selectionId: null,
      breedName: "",
      breedProfile: resolveBreedProfile(""),
      ageProfile: "adult",
      bodyBuild: MIXED_FALLBACK.build,
      neckSize: MIXED_FALLBACK.neckDefault,
      chestSize: MIXED_FALLBACK.chestDefault,
      // Precise (unrounded) cm-equivalent companion to neckSize/chestSize —
      // used ONLY for the boundary-tie tightness check (see
      // BOUNDARY_TIE_EPSILON_CM). Starts equal to the rounded default since
      // no finer reading exists yet; every place that sets *Size below also
      // sets its *Precise counterpart in lockstep.
      neckPrecise: MIXED_FALLBACK.neckDefault,
      chestPrecise: MIXED_FALLBACK.chestDefault,
      unit: storedUnit,
      boundaryChoice: {},
      selectedLeather: "black",
      cartAdded: {},
      comboExpanded: false,
      comboActiveIndex: -1,
      // Upsell tier per results card, keyed the same way cartAdded is
      // (familyKey + "|" + width) so choosing a tier on one card never
      // affects a sibling card's own selection. Lazily defaulted per card
      // the first time that card renders (see buildUpsellTiers) rather
      // than pre-filled here, since which tier is even eligible depends
      // on leash stock the state object can't know about yet at
      // construction time.
      upsellTier: {},
      // Which leash style ("Classic" / "Hands Free") the Walk Kit/Bundle
      // tiers resolve against — bound to the toggle UI inside those tiers
      // (see wireSingleCard's [data-leash-style] handler).
      leashStyle: LEASH_STYLE_DEFAULT,
      // Open/closed state for Screen 3's progressive-disclosure accordions
      // (WHAT'S INCLUDED / LEASH STYLE per card, plus the single shared
      // OTHER FITS WORTH CONSIDERING cross-sell block — see accordionMarkup
      // below). Keyed by the same id accordionMarkup renders into
      // data-accordion, e.g. "included:<cardKey>" — absent means "closed",
      // its default, so a card that's never been rendered yet still starts
      // collapsed without needing to be pre-seeded here. Persisted here
      // (not just in the DOM) so a shopper's open/closed choice survives a
      // tier switch, leash-style change, or leather swap re-rendering that
      // exact card's markup from scratch via replaceCardGroup/
      // replaceBundlePairGroup/refreshAllCards.
      accordionOpen: {},
      // Active segment per Step 4 card ("set" / "leash" / "details") —
      // the segmented-configurator refactor (Concept 2): one panel per
      // card, switched by editorial underline tabs, price row + CTA fixed
      // below it. Keyed by cardKey like upsellTier/cartAdded so a
      // shopper's tab choice survives the partial re-renders
      // replaceCardGroup/refreshAllCards perform. Absent = the card's
      // default segment ("set" when tiers exist, else "details").
      cardSegment: {}
    };

    // Optional PDP shortcut: the Liquid section can pass
    // data-preselect-option="collar"|"harness"|"bundle" (e.g. derived from
    // the current product's tag/type on a product page — see
    // lillebjorn-fit-finder.liquid) to skip Screen 1 entirely and land the
    // shopper straight on Screen 2 already scoped to what they're shopping
    // for. An absent or unrecognized value is a deliberate no-op — every
    // existing deployment without this attribute keeps starting at Screen 0.
    var preselect = this.getAttribute("data-preselect-option");
    if (preselect && OPTIONS.some(function (o) { return o.id === preselect; })) {
      this.state.selectionId = preselect;
      this.state.screen = 1;
    }

    // Append rather than replace innerHTML: the light-DOM trigger button
    // and JSON <script> the Liquid section rendered must survive init.
    this.insertAdjacentHTML("beforeend", this.template());

    // Reparent the overlay + drawer to be literal direct children of
    // <body> — a classic modal "portal" pattern — instead of leaving them
    // wherever Shopify's Section Rendering happens to place
    // <lillebjorn-fit-finder> (inside an auto-generated
    // <div id="shopify-section-...">, itself potentially inside further
    // theme wrappers used for scroll-reveal animations or the sticky
    // header's own hide/show transform). Any one of those ancestors
    // creating its own CSS stacking context (transform, opacity, filter,
    // isolation, etc.) traps this drawer's z-index comparison inside THAT
    // context instead of at the real document root — which is exactly how
    // the sticky header, sitting in a different stacking context, was
    // able to paint over a drawer whose z-index (999999/1000000) looks
    // unbeatable on paper. No z-index fixes that; only escaping the
    // ancestor does.
    //
    // Moving the actual nodes (not cloning) preserves every listener
    // attached to them below. classList.add("lb-ff") on the moved drawer
    // re-establishes the --lbff-* custom properties and base typography
    // that class defines on <lillebjorn-fit-finder> — without it, the
    // drawer would silently lose all of them the instant it's no longer
    // a descendant of the element that originally carried "lb-ff" (see
    // lillebjorn-fit-finder.css, which now gates open/closed state via
    // self-referencing [data-open] on these two elements directly rather
    // than the old .lb-ff[data-open] descendant-combinator form, for the
    // same reason).
    var overlayEl = this.querySelector("[data-lb-ff-overlay]");
    var drawerEl = this.querySelector(".lb-ff__drawer");
    drawerEl.classList.add("lb-ff");
    document.body.appendChild(overlayEl);
    document.body.appendChild(drawerEl);
    this._overlayEl = overlayEl;
    this._drawerEl = drawerEl;

    // Item 1 — ONE delegated tooltip listener set on the drawer itself
    // (see wireTooltipDelegation's own comment) rather than re-binding
    // [data-tooltip-trigger] on every card group after every re-render.
    // drawerEl is created once here and never replaced for the life of
    // this component, so wiring it exactly once in connectedCallback is
    // sufficient for every product card that will ever render inside it.
    wireTooltipDelegation(drawerEl);

    this.cacheEls();
    this.bindStaticEvents();
    // Bound here rather than lazily inside renderScreen3 (its previous
    // home) — Screen 2 (see updateProgressRail) needs this same scroll
    // listener too, and a shopper who reaches Screen 2 without
    // ever having rendered Screen 3 first would otherwise scroll with no
    // listener bound yet. bindStickyRecapScroll no-ops on every call after
    // its first (see its own _stickyRecapBound guard), so calling it once
    // here for the lifetime of this instance is sufficient for both.
    this.bindStickyRecapScroll();
    this.render();

    var internalTrigger = this.querySelector("[data-lb-ff-open]");
    if (internalTrigger) internalTrigger.addEventListener("click", function () { self.openDrawer(); });

    // Any element elsewhere in the theme (e.g. a nav link, or a button
    // injected later by an unrelated component such as Quick Shop's
    // dynamically-rendered dialog body) can also open this drawer by
    // carrying data-lb-ff-open-external, optionally scoped to this
    // instance via data-lb-ff-target="<element id>". Delegated on
    // document — rather than queried once and bound directly — so it
    // keeps working for elements that don't exist in the DOM yet at
    // connectedCallback time (a direct querySelectorAll+addEventListener
    // here would silently miss anything inserted afterward, e.g. Quick
    // Shop's body, which loads on demand well after this runs).
    this._externalOpenClickHandler = function (e) {
      var el = e.target.closest && e.target.closest("[data-lb-ff-open-external]");
      if (!el) return;
      var target = el.getAttribute("data-lb-ff-target");
      if (target && target !== self.id) return;
      self.openDrawer();
    };
    document.addEventListener("click", this._externalOpenClickHandler);
  };

  // Mirrors connectedCallback's own setup step for step, in reverse — the
  // drawer/overlay were deliberately moved OUT to document.body (see that
  // comment) specifically to escape ancestor stacking contexts, which
  // means they are NOT cleaned up automatically when whatever originally
  // contained this element is removed/replaced (e.g. a Shopify Theme
  // Editor section re-render). Left alone, that leaves a permanently
  // orphaned drawer+overlay in document.body plus a permanently firing
  // document-level keydown listener for every reconnect that ever
  // happens. Clearing _lbffInitialized here (rather than leaving it set
  // forever) is what lets a genuine future reconnect of this exact node
  // get a full, clean re-init instead of being silently locked out by the
  // guard in connectedCallback.
  LillebjornFitFinder.prototype.disconnectedCallback = function () {
    // A reconnect (Shopify Theme Editor re-render — see this function's own
    // comment further down) can tear this instance down mid-open, which
    // would otherwise leak its lockBodyScroll() call forever: closeDrawer,
    // the only other place that unlocks it, would never run.
    if (this.state && this.state.open) unlockBodyScroll();
    if (this._overlayEl && this._overlayEl.parentNode) this._overlayEl.parentNode.removeChild(this._overlayEl);
    if (this._drawerEl && this._drawerEl.parentNode) this._drawerEl.parentNode.removeChild(this._drawerEl);
    // true (capture) must match the capture flag the listener was added
    // with in bindStaticEvents — removeEventListener is a no-op otherwise.
    if (this._keydownHandler) document.removeEventListener("keydown", this._keydownHandler, true);
    if (this._externalOpenClickHandler) document.removeEventListener("click", this._externalOpenClickHandler);
    this._externalOpenClickHandler = null;
    this._lbffInitialized = false;
  };

  LillebjornFitFinder.prototype.template = function () {
    return (
      '<div class="lb-ff__overlay" data-lb-ff-overlay></div>' +
      '<div class="lb-ff__drawer" role="dialog" aria-modal="true" aria-label="Find My Dog\'s Size">' +
      '  <div class="lb-ff__header">' +
      '    <div>' +
      '      <div class="lb-ff__header-title">Find My Dog\'s Size</div>' +
      '      <div class="lb-ff__header-step" data-lb-ff-step-label aria-live="polite" aria-atomic="true"></div>' +
      '    </div>' +
      '    <button type="button" class="lb-ff__close" data-lb-ff-close aria-label="Close">✕</button>' +
      '  </div>' +
      '  <div class="lb-ff__content">' +
      '    <div class="lb-ff__dots" data-lb-ff-dots></div>' +
      '    <div class="lb-ff__screen" data-screen="0"></div>' +
      '    <div class="lb-ff__screen" data-screen="1"></div>' +
      '    <div class="lb-ff__screen" data-screen="2"></div>' +
      '    <div class="lb-ff__screen" data-screen="3"></div>' +
      '  </div>' +
      // Reading-progress rail for Screens 2 and 3 alike, whenever either
      // actually has somewhere to scroll (see updateProgressRail) —
      // positioned against .lb-ff__drawer, same
      // as .lb-ff__sticky-recap below and the shared tooltip, since
      // .lb-ff__content itself scrolls and a rail that scrolled away with
      // it couldn't show progress through the WHOLE pane. hidden by
      // default; updateProgressRail reveals it only once a qualifying
      // screen is active and actually has something to scroll.
      '  <div class="lb-ff__progress-rail" data-progress-rail hidden aria-hidden="true">' +
      '    <div class="lb-ff__progress-rail-fill" data-progress-rail-fill></div>' +
      '    <div class="lb-ff__progress-rail-marker" data-progress-rail-marker hidden></div>' +
      '  </div>' +
      // Sticky-footer tier — flex-shrink:0, same as .lb-ff__header, so the
      // primary CTA (Screen 1/2 only; Screen 0 has no CTA and Screen 3 has
      // multiple per-card Add to Cart buttons instead — see
      // renderScreen0/renderScreen3 clearing this) never scrolls with
      // .lb-ff__content. Empty by default; :empty{display:none} in CSS
      // means it takes zero space until a screen populates it.
      '  <div class="lb-ff__footer" data-lb-ff-footer></div>' +
      '</div>'
    );
  };

  LillebjornFitFinder.prototype.cacheEls = function () {
    // Sourced from this._overlayEl/this._drawerEl (set in connectedCallback
    // right after the two are reparented to <body>), not this.querySelector
    // — they're no longer descendants of <lillebjorn-fit-finder> itself.
    this.els = {
      overlay: this._overlayEl,
      stepLabel: this._drawerEl.querySelector("[data-lb-ff-step-label]"),
      dots: this._drawerEl.querySelector("[data-lb-ff-dots]"),
      screens: this._drawerEl.querySelectorAll(".lb-ff__screen"),
      footer: this._drawerEl.querySelector("[data-lb-ff-footer]"),
      progressRail: this._drawerEl.querySelector("[data-progress-rail]"),
      progressRailFill: this._drawerEl.querySelector("[data-progress-rail-fill]"),
      progressRailMarker: this._drawerEl.querySelector("[data-progress-rail-marker]")
    };
  };

  LillebjornFitFinder.prototype.bindStaticEvents = function () {
    var self = this;
    this._drawerEl.querySelector("[data-lb-ff-close]").addEventListener("click", function () { self.closeDrawer(); });
    this.els.overlay.addEventListener("click", function () { self.closeDrawer(); });
    // Stored on the instance (not an anonymous inline function) so
    // disconnectedCallback can actually remove this exact listener —
    // document.removeEventListener requires the same function reference
    // that was passed to addEventListener.
    this._keydownHandler = function (e) {
      if (!self.state.open) return;
      if (e.key === "Escape") {
        // Capture-phase + stopPropagation here (see addEventListener call
        // below) so that when this drawer is opened from on top of another
        // dialog (e.g. a theme Quick Shop modal), this Escape press is
        // consumed entirely by this drawer and never reaches that other
        // dialog's own Escape/close handling — otherwise both would close
        // on the same keypress, since neither owns the other.
        e.stopPropagation();
        // Escape closes an open tooltip first (see the shared smart
        // tooltip system — lbffTooltipOpenTrigger/hideSharedTooltip), and
        // only falls through to closing the whole drawer if none was open
        // — otherwise a shopper reading a tooltip loses the entire drawer
        // on one keypress instead of just dismissing what they were
        // looking at. ensureTooltipGlobalListeners wires its OWN Escape
        // handler too, but only lazily on the first tooltip open, and
        // listener order for the same event/target is registration order
        // — this one (wired unconditionally, here, at connectedCallback
        // time) would otherwise fire first and close the drawer out from
        // under an open tooltip before that later handler ever ran.
        if (lbffTooltipOpenTrigger) {
          var trigger = lbffTooltipOpenTrigger;
          hideSharedTooltip();
          trigger.focus();
          return;
        }
        self.closeDrawer();
        return;
      }
      // Modal focus trap (WCAG 2.4.3 / 2.1.2): a dialog must never hand
      // Tab focus to the page behind it. Recomputed on every press rather
      // than cached once, since renderScreen() swaps each screen's
      // innerHTML — and so its focusable set — on every step change.
      if (e.key === "Tab") self.trapFocus(e);
    };
    // Capture phase (the trailing `true`): runs before the event reaches
    // whatever element it actually targeted, and before any bubble-phase
    // listener bound elsewhere (including another dialog's own Escape
    // handling) ever sees it — required for this._keydownHandler's
    // stopPropagation() above to reliably beat a host theme dialog (e.g.
    // Quick Shop) that might be listening for Escape itself.
    document.addEventListener("keydown", this._keydownHandler, true);
  };

  // Every focusable node currently inside the drawer, in DOM/tab order.
  // Filtered to actually-visible nodes (offsetParent !== null) so an
  // off-screen sibling screen (data-active="false") never becomes a trap
  // boundary by mistake.
  LillebjornFitFinder.prototype.focusableEls = function () {
    var drawer = this._drawerEl;
    if (!drawer) return [];
    var nodes = drawer.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(nodes, function (node) { return node.offsetParent !== null; });
  };

  LillebjornFitFinder.prototype.trapFocus = function (e) {
    var focusable = this.focusableEls();
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  LillebjornFitFinder.prototype.openDrawer = function () {
    // Remembered so closeDrawer() can hand focus back to whatever opened
    // it (the trigger button, or an external opener) instead of leaving
    // it on a now-hidden node.
    this.lastFocused = document.activeElement;
    this.state.open = true;
    lockBodyScroll();
    // data-open drives visibility via [data-open] directly on these two
    // elements (see lillebjorn-fit-finder.css) now that they're reparented
    // to <body> and no longer descendants of this element — kept on `this`
    // too, harmlessly, in case anything outside this repo still targets
    // lillebjorn-fit-finder[data-open].
    this.setAttribute("data-open", "true");
    this._overlayEl.setAttribute("data-open", "true");
    this._drawerEl.setAttribute("data-open", "true");
    // A modal that doesn't move focus into itself on open leaves
    // keyboard/screen-reader users stranded on whatever they just
    // clicked, with no indication a full-screen dialog appeared at all.
    // The close button already exists in the DOM at this point (built
    // once in connectedCallback), so this can focus it synchronously —
    // no need for a deferred rAF/setTimeout tick.
    var closeBtn = this._drawerEl.querySelector("[data-lb-ff-close]");
    if (closeBtn) closeBtn.focus();
    trackSizingEvent("sizing_tool_opened", {
      preselect_option: this.getAttribute("data-preselect-option") || null
    });
  };
  LillebjornFitFinder.prototype.closeDrawer = function () {
    // Guards unlockBodyScroll below against a double-close (e.g. the
    // overlay and the close button both firing in the same tick) — without
    // this, a second call would decrement lbffBodyScrollLockCount for a
    // lock this instance never re-acquired, under-counting it and
    // potentially unlocking page scroll while a DIFFERENT instance's
    // drawer is still open.
    var wasOpen = this.state.open;
    this.state.open = false;
    this.removeAttribute("data-open");
    this._overlayEl.removeAttribute("data-open");
    this._drawerEl.removeAttribute("data-open");
    if (wasOpen) unlockBodyScroll();
    if (this.lastFocused && typeof this.lastFocused.focus === "function") this.lastFocused.focus();
  };

  LillebjornFitFinder.prototype.goToScreen = function (n) {
    var previousScreen = this.state.screen;
    this.state.screen = n;
    this.render();
    // Move focus to the new step's heading (or, on the results screen,
    // its verdict panel — see the [data-step-focus] markers in each
    // renderScreen*) so keyboard/screen-reader users land at the top of
    // the new content instead of staying wherever they last were (e.g. on
    // "← Back"). The step label above is aria-live, so this pairs a
    // spoken announcement with an actual focus move. Only called from here
    // (an actual step change), not from render() itself, since render()
    // also runs on ordinary in-step interactions (a swatch pick, a
    // boundary choice) where yanking focus away would be disruptive.
    var activeScreen = this._drawerEl.querySelector('.lb-ff__screen[data-active="true"]');
    var focusTarget = activeScreen && activeScreen.querySelector("[data-step-focus]");
    if (focusTarget) focusTarget.focus();

    // Forward progress only — goToScreen is also called by every "← Back"
    // link (see renderScreen1/2/3's data-back handlers), and a Back click
    // isn't a completed step. step_index matches the visible "STEP X OF 4"
    // numbering already on screen (previousScreen is 0-indexed).
    if (n > previousScreen) {
      trackSizingEvent("sizing_tool_step_completed", { step_index: previousScreen + 1 });
      // Fired here rather than inside renderScreen3 itself, which re-runs
      // on every in-screen interaction (leather swap, tier change) — this
      // guarantees exactly one fire per actual arrival at the results screen.
      if (n === 3) {
        var types = this.currentTypes();
        trackSizingEvent("sizing_tool_result_viewed", {
          recommended_neck_size: types.indexOf("collar") !== -1 ? this.computeSize("neck") : null,
          recommended_chest_size: types.indexOf("harness") !== -1 ? this.computeSize("chest") : null,
          selection_id: this.state.selectionId
        });
      }
    }
  };

  /* ---------- render dispatch ---------- */

  LillebjornFitFinder.prototype.render = function () {
    var s = this.state;
    var labels = ["STEP 1 OF 4 · SELECT", "STEP 2 OF 4 · PROFILE", "STEP 3 OF 4 · MEASURE", "STEP 4 OF 4 · RESULTS"];
    this.els.stepLabel.textContent = labels[s.screen];

    this.els.dots.innerHTML = [0, 1, 2, 3].map(function (i) {
      return '<div class="lb-ff__dot" data-filled="' + (i <= s.screen) + '"></div>';
    }).join("");

    for (var i = 0; i < this.els.screens.length; i++) {
      var el = this.els.screens[i];
      var active = parseInt(el.getAttribute("data-screen"), 10) === s.screen;
      el.setAttribute("data-active", active ? "true" : "false");
      if (active) this.renderScreen(el, s.screen);
    }
    // Unconditional (not just inside the s.screen === 3 branch above) so
    // navigating AWAY from Screen 3 — Back to Screen 2, a fresh
    // measurement — hides the rail too; updateProgressRail's own
    // this.state.screen check handles that half, this call just makes sure
    // it actually runs on every render(), not only Screen 3's own.
    this.updateProgressRail();
  };

  LillebjornFitFinder.prototype.renderScreen = function (el, n) {
    if (n === 0) return this.renderScreen0(el);
    if (n === 1) return this.renderScreen1(el);
    if (n === 2) return this.renderScreen2(el);
    if (n === 3) return this.renderScreen3(el);
  };

  /* ---------- Screen 0: select ---------- */

  LillebjornFitFinder.prototype.renderScreen0 = function (el) {
    var self = this;
    var images = this.optionImages();
    // No single primary CTA on this screen — the option cards themselves
    // are the action. Clears any footer content left over from Screen 1/2
    // (e.g. after Back navigation) rather than showing a stale button.
    this.els.footer.innerHTML = "";
    el.innerHTML =
      '<div class="lb-ff__eyebrow">STEP ONE</div>' +
      '<h2 class="lb-ff__title" tabindex="-1" data-step-focus>What are you sizing today?</h2>' +
      '<p class="lb-ff__sub">Choose an option below to begin.</p>' +
      OPTIONS.map(function (o) {
        // The bundle option renders a premium 50/50 split using two images
        // side-by-side; collar/harness each render a single lifestyle shot.
        var srcs = o.id === "collar" ? [images.collar]
          : o.id === "harness" ? [images.harness]
          : [images.bundleLeft, images.bundleRight];
        var imagesHtml = srcs.map(function (src) {
          return '<div class="lb-ff__option-image" style="' + (src ? "background-image:url('" + escapeHtml(src) + "')" : '') + '"></div>';
        }).join('');
        return (
          '<button type="button" class="lb-ff__option" data-opt="' + o.id + '">' +
          '  <div class="lb-ff__option-images">' + imagesHtml + '</div>' +
          '  <div class="lb-ff__option-scrim"></div>' +
          '  <div class="lb-ff__option-copy">' +
          '    <div><div class="lb-ff__option-label">' + o.label + '</div>' +
          '    <div class="lb-ff__option-sub">' + o.sub + '</div></div>' +
          '    <div class="lb-ff__option-arrow">→</div>' +
          '  </div>' +
          '</button>'
        );
      }).join("");

    el.querySelectorAll("[data-opt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.state.selectionId = btn.getAttribute("data-opt");
        self.goToScreen(1);
      });
    });
  };

  // Reads the 4 option images (Screen 1 fix) from data attributes so the
  // Liquid section can bind real Shopify CDN URLs without touching this file.
  LillebjornFitFinder.prototype.optionImages = function () {
    return {
      collar: this.getAttribute("data-image-collar") || "",
      harness: this.getAttribute("data-image-harness") || "",
      bundleLeft: this.getAttribute("data-image-bundle-left") || "",
      bundleRight: this.getAttribute("data-image-bundle-right") || ""
    };
  };

  /* ---------- Screen 1: profile (breed live-search + age + build) ---------- */

  LillebjornFitFinder.prototype.renderScreen1 = function (el) {
    var self = this;
    var s = this.state;

    el.innerHTML =
      '<div class="lb-ff__back" data-back>← BACK</div>' +
      '<div class="lb-ff__eyebrow">STEP TWO</div>' +
      '<h2 class="lb-ff__title" tabindex="-1" data-step-focus>Tell us about your dog</h2>' +
      '<p class="lb-ff__sub">Required to calibrate an accurate baseline before measuring.</p>' +

      '<div class="lb-ff__field">' +
      '  <label class="lb-ff__field-label" for="lbffBreedInput">BREED <span class="lb-ff__field-required">— REQUIRED</span></label>' +
      '  <div class="lb-ff__combobox" data-combobox>' +
      '    <input type="text" id="lbffBreedInput" class="lb-ff__combobox-input" autocomplete="off"' +
      '      role="combobox" aria-expanded="false" aria-autocomplete="list" aria-controls="lbffBreedList"' +
      '      placeholder="Start typing a breed…" value="' + escapeHtml(s.breedName) + '">' +
      '    <ul class="lb-ff__combobox-list" id="lbffBreedList" role="listbox" data-combobox-list></ul>' +
      '  </div>' +
      '  <div class="lb-ff__guardrail" data-tone="amber" data-breed-hint role="status" aria-live="polite" style="' + (s.breedProfile.isFallback && s.breedName ? '' : 'display:none') + '">' +
           "We don't have " + (s.breedName ? escapeHtml(s.breedName) : "this breed") + " on file yet — no problem. The next step measures your dog directly, so your fit is just as precise either way." +
      '  </div>' +
      '</div>' +

      '<div class="lb-ff__field" data-dim-on-combobox-open>' +
      '  <span class="lb-ff__field-label">AGE PROFILE</span>' +
      '  <div class="lb-ff__segmented">' +
      '    <button type="button" class="lb-ff__segmented-btn" data-age="adult" data-on="' + (s.ageProfile === "adult") + '">ADULT DOG</button>' +
      '    <button type="button" class="lb-ff__segmented-btn" data-age="puppy" data-on="' + (s.ageProfile === "puppy") + '">GROWING PUPPY</button>' +
      '  </div>' +
      (s.ageProfile === "puppy" ? '<p class="lb-ff__field-hint">We size to your puppy’s exact current measurements — never larger in advance, since a loose collar isn’t safe. Safety and re-measuring guidance follows on the results screen.</p>' : '') +
      '</div>' +

      '<div class="lb-ff__field" data-dim-on-combobox-open>' +
      '  <label class="lb-ff__field-label" for="lbffBuildSelect">BODY &amp; NECK BUILD</label>' +
      '  <select id="lbffBuildSelect" class="lb-ff__select" data-build-select>' +
           BUILD_OPTIONS.map(function (b) { return '<option value="' + b + '"' + (b === s.bodyBuild ? " selected" : "") + '>' + (BUILD_OPTION_LABELS[b] || b) + '</option>'; }).join("") +
      '  </select>' +
      '  <p class="lb-ff__field-hint">Auto-suggested from breed — override if needed.</p>' +
      '</div>';

    // CTA lives in the sticky footer (see .lb-ff__footer in template()), not
    // in `el` — this screen's own scrolling content never has to include it
    // in its height, and it never scrolls out of view. A fresh button node
    // is written here every render, so no stale click listener from a prior
    // render can double-fire — same reasoning as the rest of this file's
    // innerHTML-replace pattern.
    this.els.footer.innerHTML = '<button type="button" class="lb-ff__cta" data-continue>CONTINUE TO MEASUREMENTS</button>';
    var continueBtn = this.els.footer.querySelector("[data-continue]");

    el.querySelector("[data-back]").addEventListener("click", function () { self.goToScreen(0); });
    el.querySelectorAll("[data-age]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        self.state.ageProfile = btn.getAttribute("data-age");
        // Re-derive the slider defaults for the new age — see
        // applyAgeProfile() for the puppy shrink-factor math.
        self.applyAgeProfile();
        self.render();
      });
    });
    el.querySelector("[data-build-select]").addEventListener("change", function (e) {
      self.state.bodyBuild = e.target.value;
      // Double-safety net (see BUILD_TO_CATEGORY): a manual build pick
      // always wins over whatever category resolveBreedProfile() derived
      // from the typed breed text — a generic/mixed breed with Slender /
      // Elegant manually selected still gets routed to sighthound-safe Wide
      // collars, and a real sighthound breed can opt back into Standard.
      self.state.breedProfile.category = BUILD_TO_CATEGORY[e.target.value] || self.state.breedProfile.category;
    });
    continueBtn.addEventListener("click", function () {
      if (self.isBreedBlocked()) return;
      self.goToScreen(2);
    });

    this.wireBreedCombobox(el, el.querySelector("[data-combobox]"), continueBtn);

    // Step 2 interlock: no breed context populated yet (including a fresh
    // render right after clearing the field) means the CTA starts/stays
    // disabled until a real selection lands in state.breedName.
    this.updateProfileContinueButton(continueBtn);
  };

  // "Populated" means either an autocomplete pick, an explicit Mixed Breed /
  // Other choice, or free text resolved on blur — all three set a non-empty
  // state.breedName. An empty/never-touched field is the only blocked state.
  LillebjornFitFinder.prototype.isBreedBlocked = function () {
    return !this.state.breedName || !this.state.breedName.trim();
  };

  LillebjornFitFinder.prototype.updateProfileContinueButton = function (btn) {
    if (!btn) return;
    var blocked = this.isBreedBlocked();
    btn.disabled = blocked;
    btn.setAttribute("aria-disabled", blocked ? "true" : "false");
  };

  LillebjornFitFinder.prototype.wireBreedCombobox = function (screenEl, root, continueBtn) {
    var self = this;
    var input = root.querySelector(".lb-ff__combobox-input");
    var list = root.querySelector("[data-combobox-list]");

    // While the list is open on a narrow drawer it can fully cover Age
    // Profile / Body & Neck Build below with no visual trace they're still
    // there. Dimming + inert (rather than just closing the list on scroll,
    // or leaving them untouched) marks them as "temporarily paused," not
    // gone, and keeps them out of the tab order while they're not visible.
    var dimTargets = screenEl.querySelectorAll("[data-dim-on-combobox-open]");
    function setFieldsDimmed(on) {
      dimTargets.forEach(function (f) {
        f.classList.toggle("lb-ff__field--dimmed", on);
        if (on) f.setAttribute("inert", ""); else f.removeAttribute("inert");
      });
    }

    function matches(query) {
      var q = query.trim().toLowerCase();
      if (!q) return BREED_NAMES.slice(0, 8);
      var starts = [], contains = [];
      BREED_NAMES.forEach(function (name) {
        var l = name.toLowerCase();
        if (l.indexOf(q) === 0) starts.push(name);
        else if (l.indexOf(q) !== -1) contains.push(name);
      });
      return starts.concat(contains).slice(0, 8);
    }

    function renderList(query) {
      var results = matches(query);
      var html = results.map(function (name, i) {
        return '<li class="lb-ff__combobox-option" role="option" data-value="' + escapeHtml(name) + '" data-index="' + i + '">' + escapeHtml(name) + "</li>";
      }).join("");
      html += '<li class="lb-ff__combobox-option" role="option" data-fallback="true" data-value="' + FALLBACK_BREED_NAME + '" data-index="' + results.length + '">' + FALLBACK_BREED_NAME + "</li>";
      list.innerHTML = html || '<li class="lb-ff__combobox-empty">No matches — will use Mixed Breed / Other</li>';
      // Auto-highlight the first real match (not the trailing "Mixed Breed /
      // Other" fallback row) so pressing Enter right after typing selects it
      // immediately, without requiring an explicit ArrowDown first — matches
      // how most browser/OS autocomplete fields behave.
      self.state.comboActiveIndex = results.length > 0 ? 0 : -1;
      highlight(list.querySelectorAll(".lb-ff__combobox-option[data-value]"));
    }

    function open() {
      self.state.comboExpanded = true;
      root.setAttribute("data-expanded", "true");
      input.setAttribute("aria-expanded", "true");
      renderList(input.value);
      setFieldsDimmed(true);
    }
    function close() {
      self.state.comboExpanded = false;
      root.removeAttribute("data-expanded");
      input.setAttribute("aria-expanded", "false");
      setFieldsDimmed(false);
    }

    function choose(name) {
      self.state.breedName = name;
      self.applyBreedSelection(name);
      input.value = name;
      close();
      self.render();
    }

    input.addEventListener("focus", function () {
      open();
      // "nearest" is a no-op when the field (and the list about to open
      // below it) already fits the visible content area — this only moves
      // anything on a short/narrow viewport where the list would otherwise
      // fight the fold or a software keyboard.
      input.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
    input.addEventListener("input", function () {
      renderList(input.value);
      open();
      // Instant re-lock: clearing the field back to empty must disable the
      // CTA immediately, without waiting for blur. Non-empty in-progress
      // typing that hasn't been selected/blurred yet is left alone — the
      // button only unlocks via an explicit choose() or the blur fallback.
      if (!input.value.trim()) {
        self.state.breedName = "";
        self.state.breedProfile = resolveBreedProfile("");
        self.updateProfileContinueButton(continueBtn);
      }
    });
    input.addEventListener("blur", function () {
      // Delay so a click on an option registers before the list unmounts —
      // mousedown on a list item fires (and calls choose(), see below)
      // before this timeout runs.
      setTimeout(function () {
        close();
        // Free-typed text that was never explicitly chosen from the
        // dropdown (e.g. "Whippet Mix", which matches no suggestion) still
        // resolves as the literal breed name on blur, mirroring choose().
        // This is what lets the sighthound fuzzy-keyword match in
        // resolveBreedProfile() fire from typed input, not just an exact
        // dropdown pick. Skipped when the text is empty (handled by the
        // instant re-lock above) or already resolved (avoids re-running
        // selection on every stray blur/refocus).
        var typed = input.value.trim();
        if (typed && typed !== self.state.breedName) choose(typed);
      }, 120);
    });
    input.addEventListener("keydown", function (e) {
      var opts = list.querySelectorAll(".lb-ff__combobox-option[data-value]");
      if (e.key === "ArrowDown") {
        e.preventDefault();
        self.state.comboActiveIndex = Math.min(self.state.comboActiveIndex + 1, opts.length - 1);
        highlight(opts);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        self.state.comboActiveIndex = Math.max(self.state.comboActiveIndex - 1, 0);
        highlight(opts);
      } else if (e.key === "Enter") {
        e.preventDefault();
        var active = opts[self.state.comboActiveIndex];
        if (active) choose(active.getAttribute("data-value"));
      } else if (e.key === "Escape") {
        close();
      }
    });

    function highlight(opts) {
      opts.forEach(function (o, i) { o.setAttribute("data-active", i === self.state.comboActiveIndex ? "true" : "false"); });
    }

    list.addEventListener("mousedown", function (e) {
      var opt = e.target.closest("[data-value]");
      if (opt) choose(opt.getAttribute("data-value"));
    });
  };

  // Growing Puppy starting position: a flat 35% shrink off the breed's
  // ADULT baseline, giving a safer, roughly age-appropriate slider default
  // instead of literally handing a puppy its breed's full adult size.
  var PUPPY_SHRINK_FACTOR = 0.65;

  LillebjornFitFinder.prototype.applyBreedSelection = function (name) {
    var profile = resolveBreedProfile(name);
    this.state.breedProfile = profile;
    this.state.bodyBuild = profile.build;
    this.applyAgeProfile();
  };

  // Derives neckSize/chestSize from the CURRENT breedProfile + ageProfile —
  // called both when a breed is (re)selected and when Adult/Puppy is
  // toggled, so it always recomputes from the breed's original
  // neckDefault/chestDefault rather than from whatever the slider currently
  // shows. That makes Adult <-> Puppy idempotent (no compounding shrink on
  // repeated toggles) and keeps the age toggle from being a no-op on the
  // starting position (a puppy no longer defaults to its breed's full adult
  // size — see PUPPY_SHRINK_FACTOR above).
  //
  // Ceiling is intentionally NECK_CUSTOM_MAX/CHEST_CUSTOM_MAX, not the
  // standard-matrix ceiling (47cm / 76cm): a breed whose real default
  // exceeds standard sizing (e.g. Great Dane: neckDefault 52, chestDefault
  // 90) must land ABOVE the standard ceiling so isCustomNeck()/
  // isCustomChest() are already true the moment Step 2 renders — that's
  // what flips the CTA to "REQUEST CUSTOM SIZE" (the existing bespoke/email
  // flow) automatically, instead of silently truncating them to a
  // commercial "Size XL" that was never actually their size.
  LillebjornFitFinder.prototype.applyAgeProfile = function () {
    var profile = this.state.breedProfile;
    var factor = this.state.ageProfile === "puppy" ? PUPPY_SHRINK_FACTOR : 1;
    this.state.neckSize = clamp(Math.round(profile.neckDefault * factor), NECK_NODES[0], NECK_CUSTOM_MAX);
    this.state.chestSize = clamp(Math.round(profile.chestDefault * factor), CHEST_NODES[0], CHEST_CUSTOM_MAX);
    // Breed/age defaults have no finer-than-cm reading behind them, so the
    // precise companion is just the rounded value itself.
    this.state.neckPrecise = this.state.neckSize;
    this.state.chestPrecise = this.state.chestSize;
    // A boundary-tie LOOSE/SNUG choice tied to the previous slider value is
    // meaningless once the value itself has just moved (new breed or age).
    this.state.boundaryChoice = {};
  };

  /* ---------- Screen 2: measurement ---------- */

  LillebjornFitFinder.prototype.currentTypes = function () {
    var opt = OPTIONS.filter(function (o) { return o.id === this.state.selectionId; }, this)[0];
    return opt ? opt.types : [];
  };

  // `value` is the rounded whole-cm figure used for the actual size lookup
  // and breed-range guardrail (rangeStatus/sizeFromValue below) — unit-
  // agnostic, exactly as before. `preciseValue` is the separate, unrounded
  // cm-equivalent used ONLY for the boundary-tie tightness check (see
  // BOUNDARY_TIE_EPSILON_CM) — defaults to `value` if omitted, so this
  // stays exact-match-only for any caller that hasn't been updated.
  LillebjornFitFinder.prototype.buildMeasureVals = function (key, value, preciseValue) {
    var self = this;
    var meta = MEASURE_META[key];
    var breed = this.state.breedProfile;
    var precise = preciseValue === undefined ? value : preciseValue;
    // Screen 3 (index 2): a breed without a matched sizing profile
    // (including the Mixed Breed / Other fallback) silently suppresses
    // guardrail / out-of-range prompts, since there is no reference range.
    // Growing Puppy suppresses it too, for a different reason: breed[key]
    // is the ADULT standard range, and a puppy is expected to measure
    // smaller than that — comparing against it produces false "double-check
    // this measurement" warnings on perfectly normal puppy proportions.
    var isFallback = !!breed.isFallback;
    var isPuppy = this.state.ageProfile === "puppy";
    var rs = (isFallback || isPuppy) ? { status: "none" } : rangeStatus(value, breed[meta.breedKey]);
    // The Size-letter tie-break (e.g. exactly 42cm sitting on the L/XL line)
    // is a property of the commercial sizing matrix, not of breed data — it
    // must apply for every breed and every age, including puppies and the
    // Mixed Breed / Other fallback, so it is intentionally NOT gated on
    // isFallback or isPuppy. Only the breed-standard guardrail above is.
    var letters = boundaryTie(precise, meta.nodes, meta.sizes, BOUNDARY_TIE_EPSILON_CM);
    var isBoundary = !!letters;
    var choice = this.state.boundaryChoice[key];
    var liveSize = sizeFromValue(value, meta.nodes, meta.sizes);
    // Premium custom-size zone: neck past 47cm/XL or chest past 76cm/XL
    // reads as "Custom Size" instead of a misleading "Size XL".
    var isCustom = (key === "neck" && value > NECK_NODES[NECK_NODES.length - 1]) ||
      (key === "chest" && value > CHEST_NODES[CHEST_NODES.length - 1]);
    var sizeLabel = isCustom ? "Custom Size" : (isBoundary ? "Size " + letters.lower + "/" + letters.upper + " Boundary" : "Size " + liveSize);

    var guardrailMessage = "";
    if (rs.status === "amber") {
      guardrailMessage = "A little outside the typical range for " + breed.name + " — not unusual for an individual dog, just worth a second measurement to be sure.";
    } else if (rs.status === "red") {
      // breed.neck/breed.chest are always cm — same unit-aware formatting
      // used everywhere else, never a second conversion scheme. .toFixed(1)
      // keeps a consistent one-decimal look (see sizeRangeLabel's own
      // comment) rather than a mix like "26–33.9 in".
      var unit = this.state.unit;
      var neckRange = unit === "in"
        ? cmToIn(breed.neck[0]).toFixed(1) + "–" + cmToIn(breed.neck[1]).toFixed(1) + " in"
        : breed.neck[0] + "–" + breed.neck[1] + "cm";
      var chestRange = unit === "in"
        ? cmToIn(breed.chest[0]).toFixed(1) + "–" + cmToIn(breed.chest[1]).toFixed(1) + " in"
        : breed.chest[0] + "–" + breed.chest[1] + "cm";
      guardrailMessage = "Double-check that measurement. " + breed.name + " typically measures neck " + neckRange + " and chest " + chestRange + ". Yours is noticeably outside that range — re-measure snugly, or continue if your dog is genuinely outside breed-standard proportions.";
    }

    return {
      sizeLabel: sizeLabel,
      showGuardrail: rs.status !== "none",
      guardrailTone: rs.status === "red" ? "red" : "amber",
      guardrailMessage: guardrailMessage,
      showBoundary: isBoundary,
      boundaryHeaderText: isBoundary ? "Right on a boundary between Size " + letters.lower + " and Size " + letters.upper + ". How did you measure?" : "",
      chooseLoose: function () { self.state.boundaryChoice[key] = "loose"; self.render(); },
      chooseSnug: function () { self.state.boundaryChoice[key] = "snug"; self.render(); },
      choice: choice
    };
  };

  // Sets the shopper's display-unit preference and best-effort persists it.
  // Never touches state.neckSize/chestSize — those stay cm regardless.
  LillebjornFitFinder.prototype.setUnit = function (unit) {
    if (unit !== "cm" && unit !== "in") return;
    this.state.unit = unit;
    try {
      if (window.localStorage) window.localStorage.setItem(UNIT_STORAGE_KEY, unit);
    } catch (e) {
      // Best-effort only — an in-session toggle still works even if it
      // can't persist across visits.
    }
  };

  LillebjornFitFinder.prototype.unitToggleMarkup = function () {
    var unit = this.state.unit;
    return (
      '<div class="lb-ff__unit-toggle" role="group" aria-label="Measurement unit" data-unit-toggle>' +
      '<button type="button" data-unit-btn="cm" aria-pressed="' + (unit === "cm") + '">CM</button>' +
      '<button type="button" data-unit-btn="in" aria-pressed="' + (unit === "in") + '">IN</button>' +
      '</div>'
    );
  };

  LillebjornFitFinder.prototype.renderScreen2 = function (el) {
    var self = this;
    var s = this.state;
    var types = this.currentTypes();
    var includesCollar = types.indexOf("collar") !== -1;
    var includesHarness = types.indexOf("harness") !== -1;
    var isCustomCollar = includesCollar && this.isCustomNeck();
    var isCustomHarness = includesHarness && this.isCustomChest();
    var isCustom = isCustomCollar || isCustomHarness;

    // Single-measurement steps (Neck-only or Chest-only) drop the H2
    // entirely now — "Find your collar/harness size" was redundant with
    // the illustration and NECK/CHEST SIZE readout directly below it, and
    // removing it hands that vertical space to the illustration instead
    // (see .lb-ff__measure-block--no-header and its illustration's taller
    // max-height in the CSS). [data-step-focus] still needs a landing
    // spot for goToScreen's post-navigation focus move (see goToScreen),
    // so it moves onto the STEP THREE eyebrow instead of disappearing
    // with the title. Bundle/dual steps still measure two different
    // things, so they keep the generic top title and let each block's own
    // eyebrow+title (see measureBlockMarkup's showHeader arg below)
    // distinguish Neck from Chest.
    var isDualMeasure = includesCollar && includesHarness;
    var mainTitle = isDualMeasure ? "Take your dog's measurements" : "";

    var html =
      '<div class="lb-ff__topbar">' +
      '<div class="lb-ff__back" data-back>← BACK</div>' +
      this.unitToggleMarkup() +
      '</div>' +
      (isDualMeasure
        ? '<div class="lb-ff__eyebrow">STEP THREE</div>' +
          '<h2 class="lb-ff__title" tabindex="-1" data-step-focus>' + mainTitle + '</h2>'
        : '<div class="lb-ff__eyebrow" tabindex="-1" data-step-focus>STEP THREE</div>');

    // Bundle path only (both a Collar and a Harness are being sized in this
    // one step) — flags up front that two full measurement blocks follow,
    // rather than letting the neck block's own boundary-disambiguation
    // panel be the first sign a second measurement is still coming.
    if (includesCollar && includesHarness) {
      html += '<div class="lb-ff__dual-measure-notice"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.3"/><path d="M8 7v4.2M8 5v.01" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>' +
        '<span><strong>Step 3 of 4: Two measurements needed</strong> (Neck &amp; Chest) — the Collar &amp; Harness Bundle sizes both pieces in this one step.</span></div>';
    }

    // Both neck and chest are deliberately allowed to travel past their
    // commercial-matrix ceiling (NECK_NODES / CHEST_NODES last node) up to
    // their own *_CUSTOM_MAX — that overflow zone is what triggers the
    // bespoke/custom UI below instead of silently clamping to XL.
    if (includesCollar) html += this.measureBlockMarkup("neck", "NECK MEASUREMENT", "Find your collar size", "<strong>Wrap a soft tape measure snugly around the base of the neck</strong> where the collar would naturally sit (keep in mind allowing space for two fingers of ease).", NECK_NODES[0], NECK_CUSTOM_MAX, isDualMeasure);
    if (includesHarness) html += this.measureBlockMarkup("chest", "CHEST MEASUREMENT", "Find your harness size", "<strong>Measure around the widest part of your dog's ribcage</strong>, typically right behind the front legs.", CHEST_NODES[0], CHEST_CUSTOM_MAX, isDualMeasure);

    // Consolidated status card — one shared box for every measurement's
    // breed-range guardrail (previously one full bordered box per
    // measurement, inline in that measurement's own block) plus the
    // custom-size banner (previously its own separate full box below both
    // measurements). Each piece keeps its own independently-computed
    // visibility/content (see updateStatusCard, refreshMeasureBlock,
    // syncCustomSizeUI) — this only changes WHERE those already-computed
    // strings render, not what triggers them or what they say.
    var neckGuardrailHtml = includesCollar ? this.guardrailSlotHtml("neck") : "";
    var chestGuardrailHtml = includesHarness ? this.guardrailSlotHtml("chest") : "";
    var customBannerSlotHtml = '<div data-custom-banner-slot>' +
      (isCustom ? '<div class="lb-ff__status-line" data-tone="accent">' + this.customBannerText(isCustomCollar, isCustomHarness) + '</div>' : '') +
      '</div>';
    var statusActive = neckGuardrailHtml.indexOf('lb-ff__status-line') !== -1 ||
      chestGuardrailHtml.indexOf('lb-ff__status-line') !== -1 || isCustom;
    // The inner wrapper is what the grid-template-rows:0fr/1fr collapse
    // (see CSS) actually clips via its own overflow:hidden — the card's
    // padding/border live on the inner div instead of the grid track
    // itself, which is what lets the track collapse all the way to zero
    // rather than being floored by its own padding.
    html += '<div class="lb-ff__status-card" data-status-card data-active="' + statusActive + '">' +
      '<div class="lb-ff__status-card-inner">' + neckGuardrailHtml + chestGuardrailHtml + customBannerSlotHtml + '</div>' +
      '</div>';

    el.innerHTML = html;

    // CTA lives in the sticky footer (see .lb-ff__footer in template()) —
    // never inside `el`'s scrolling content, so it can't be pushed below
    // the fold by the status card above. Custom-size CTA is a real mailto
    // <a>, not a JS-driven button — some mobile/in-app browsers (Instagram,
    // Facebook, iOS Safari in certain contexts) silently drop a
    // script-triggered window.location.href mailto navigation. A native
    // anchor click always opens the mail client.
    this.els.footer.innerHTML = isCustom
      ? '<a href="' + this.buildCustomSizeMailto(isCustomCollar, isCustomHarness) + '" class="lb-ff__cta" data-continue>REQUEST CUSTOM SIZE</a>'
      : '<button type="button" class="lb-ff__cta" data-continue>VIEW RECOMMENDATIONS</button>';
    this.wireScreen2ContinueClick(this.els.footer.querySelector("[data-continue]"));

    el.querySelector("[data-back]").addEventListener("click", function () { self.goToScreen(1); });

    // One unit toggle for the whole step — Neck and Chest always share a
    // single state.unit, so switching it re-renders this entire screen
    // (both measurement blocks + the shared status card) rather than
    // patching one slider's label in place. Neither state.neckSize/
    // chestSize nor state.boundaryChoice are touched, so an already-made
    // LOOSE/SNUG choice survives a unit switch untouched.
    el.querySelectorAll("[data-unit-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = btn.getAttribute("data-unit-btn");
        if (next === self.state.unit) return;
        self.setUnit(next);
        self.renderScreen2(el);
      });
    });

    if (includesCollar) this.wireMeasureBlock(el, "neck");
    if (includesHarness) this.wireMeasureBlock(el, "chest");

    // Strict Step 3 interlock: if either active measurement lands exactly
    // on a Size boundary, VIEW RECOMMENDATIONS starts disabled until the
    // user resolves it via LOOSE / SNUG.
    this.updateContinueButton(this.els.footer.querySelector("[data-continue]"));
  };

  // Builds one measurement's guardrail slot for the shared .lb-ff__status-card
  // (see renderScreen2). Reads the exact same buildMeasureVals() output
  // measureBlockMarkup itself reads for sizeLabel/boundary — this is a second,
  // side-effect-free call to a pure function, not a different computation.
  LillebjornFitFinder.prototype.guardrailSlotHtml = function (key) {
    var v = this.buildMeasureVals(key, this.state[key + "Size"], this.state[key + "Precise"]);
    return '<div data-guardrail-slot="' + key + '">' +
      (v.showGuardrail ? '<div class="lb-ff__status-line" data-tone="' + v.guardrailTone + '">' + v.guardrailMessage + '</div>' : '') +
      '</div>';
  };

  // The custom-size CTA swaps element type (button <-> mailto <a>) as a
  // measurement crosses its custom-size ceiling (see syncCustomSizeUI),
  // which replaces the node outright via outerHTML — a fresh node has no
  // listener, so this is called once at initial render and again every time
  // that swap happens, rather than relying on delegation to a shared
  // ancestor (the footer is now shared across screens, so a delegated
  // listener there would fire for whichever screen's CTA happens to be
  // showing, not necessarily this one).
  LillebjornFitFinder.prototype.wireScreen2ContinueClick = function (btn) {
    var self = this;
    if (!btn || btn.tagName === "A") return;
    btn.addEventListener("click", function () {
      if (self.isMeasureBlocked()) return;
      self.goToScreen(3);
    });
  };

  // Recomputes whether the shared status card has anything to show at all,
  // so its border/background (see CSS) can disappear entirely rather than
  // rendering as an empty bordered box once every guardrail/banner line
  // inside it collapses to nothing.
  LillebjornFitFinder.prototype.updateStatusCard = function (el) {
    var card = el.querySelector("[data-status-card]");
    if (!card) return;
    var types = this.currentTypes();
    var includesCollar = types.indexOf("collar") !== -1;
    var includesHarness = types.indexOf("harness") !== -1;
    var neckShow = includesCollar && this.buildMeasureVals("neck", this.state.neckSize, this.state.neckPrecise).showGuardrail;
    var chestShow = includesHarness && this.buildMeasureVals("chest", this.state.chestSize, this.state.chestPrecise).showGuardrail;
    var customShow = (includesCollar && this.isCustomNeck()) || (includesHarness && this.isCustomChest());
    var nowActive = neckShow || chestShow || customShow;
    var wasActive = card.getAttribute("data-active") === "true";
    card.setAttribute("data-active", nowActive ? "true" : "false");

    // Only on the actual false->true transition — a slider drag that keeps
    // it active on every tick must not keep re-triggering a scroll (that
    // would fight the user's own drag). "nearest" is a no-op when the card
    // is already fully visible, so this only actually moves anything when
    // the sticky footer (or a short mobile viewport) would otherwise leave
    // it stranded below the fold.
    if (nowActive && !wasActive) {
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      card.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "nearest" });
    }

    // The card's own grid-template-rows transition animates its height on
    // every active/inactive flip — re-measuring the rail (see
    // updateProgressRail) on the same tick keeps its fill in step rather
    // than snapping once the transition ends, same reasoning as the
    // Screen 3 accordion's own updateProgressRail() call.
    //
    // This same-tick call reads the PRE-animation height, which is fine
    // for keeping an existing rail's fill honest but can't decide whether
    // the rail should exist at all — this card opening is usually what
    // makes Screen 2 scrollable in the first place. The delegated
    // transitionend listener in bindStickyRecapScroll takes that second
    // measurement once the 0.35s transition lands; see its comment.
    this.updateProgressRail();
  };

  LillebjornFitFinder.prototype.isCustomNeck = function () {
    return this.state.neckSize > NECK_NODES[NECK_NODES.length - 1];
  };

  // Mirrors isCustomNeck() for the harness/chest side of the flow.
  LillebjornFitFinder.prototype.isCustomChest = function () {
    return this.state.chestSize > CHEST_NODES[CHEST_NODES.length - 1];
  };

  LillebjornFitFinder.prototype.customBannerText = function (isCustomCollar, isCustomHarness) {
    var noun = isCustomCollar && isCustomHarness ? "collars and harnesses"
      : isCustomHarness ? "harnesses"
      : "collars";
    return "Looking for a larger size? We handcraft custom " + noun + " tailored precisely to your dog's measurements. Click below to request a bespoke order.";
  };

  // Builds the bespoke-order mailto URL. Every query param is run through
  // encodeURIComponent — a raw, unencoded subject interpolated straight into
  // the URL is invalid (literal spaces), which is exactly the kind of thing
  // that silently no-ops in stricter browsers instead of opening the mail
  // client. isCustomCollar/isCustomHarness independently gate which
  // measurement(s) get included, so a Bundle with only chest in the custom
  // zone doesn't falsely claim a custom neck (and vice versa) — both true
  // together (Bundle, both custom) asks for both in one request.
  LillebjornFitFinder.prototype.buildCustomSizeMailto = function (isCustomCollar, isCustomHarness) {
    var s = this.state;
    var breedLabel = s.breedName && s.breedName.trim() ? s.breedName.trim() : "Not specified";
    var ageLabel = s.ageProfile === "puppy" ? "Growing Puppy" : "Adult Dog";
    // Only real archetype-derived breeds carry a sizeClass (see
    // deriveFromArchetype) — curated and mixed-breed profiles don't, and
    // that's left honest here rather than guessed at.
    var sizeClassLabel = s.breedProfile && s.breedProfile.sizeClass
      ? capitalizeFirst(s.breedProfile.sizeClass)
      : "Not specified";
    var dateLabel = new Date().toLocaleDateString();

    var itemLabel = isCustomCollar && isCustomHarness ? "Collar & Harness Bundle"
      : isCustomHarness ? "Harness"
      : "Collar";

    var measurementLines = [];
    if (isCustomCollar) measurementLines.push("• Neck Circumference: " + s.neckSize + " cm");
    if (isCustomHarness) measurementLines.push("• Chest Circumference: " + s.chestSize + " cm");
    measurementLines.push("• Date of Measurement: " + dateLabel);

    var subjectMeasure = isCustomCollar && isCustomHarness
      ? s.neckSize + "cm neck / " + s.chestSize + "cm chest"
      : isCustomHarness ? s.chestSize + "cm chest" : s.neckSize + "cm neck";

    var subject = "Bespoke " + itemLabel + " Request — " + breedLabel + " (" + subjectMeasure + ")";
    var body = [
      "Hello The Lille Björn Team,",
      "",
      "I would like to request a custom " + itemLabel.toLowerCase() + " size tailored specifically for my dog. Here are our measurements and details from Find My Dog's Size:",
      "",
      "DOG DETAILS",
      "• Breed: " + breedLabel,
      "• Age Status: " + ageLabel,
      "• Estimated Adult Size Class: " + sizeClassLabel,
      "",
      "MEASUREMENTS"
    ].concat(measurementLines).concat([
      "",
      "CUSTOMER NOTES & PREFERENCES",
      "• Preferred Style/Color (if any): ",
      "• Special Requirements (e.g. active puller, sensitive skin): ",
      "",
      "Please let me know the next steps, estimated crafting time, and pricing for this custom order. Thank you!",
      "",
      "Best regards,",
      ""
    ]).join("\n");

    return "mailto:support@thelillebjorn.com?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
  };

  // Live-syncs the custom-size banner + CTA during slider drag, without a
  // full re-render (which would disrupt an in-progress drag). Crossing
  // either ceiling swaps the CTA's element type itself (button <-> mailto
  // <a>), so the node is replaced outright rather than mutated in place —
  // the click listener lives on `el` via delegation, so the swap doesn't
  // lose it.
  LillebjornFitFinder.prototype.syncCustomSizeUI = function (el) {
    var bannerSlot = el.querySelector("[data-custom-banner-slot]");
    var btn = this.els.footer.querySelector("[data-continue]");
    if (!bannerSlot || !btn) return;
    var types = this.currentTypes();
    var isCustomCollar = types.indexOf("collar") !== -1 && this.isCustomNeck();
    var isCustomHarness = types.indexOf("harness") !== -1 && this.isCustomChest();
    var custom = isCustomCollar || isCustomHarness;
    bannerSlot.innerHTML = custom
      ? '<div class="lb-ff__status-line" data-tone="accent">' + this.customBannerText(isCustomCollar, isCustomHarness) + '</div>'
      : "";

    var isAnchor = btn.tagName === "A";
    if (custom === isAnchor) {
      // Already the right element type — an anchor still needs a fresh
      // href since the cm values (and so the mailto body) keep changing.
      if (custom) btn.setAttribute("href", this.buildCustomSizeMailto(isCustomCollar, isCustomHarness));
    } else {
      btn.outerHTML = custom
        ? '<a href="' + this.buildCustomSizeMailto(isCustomCollar, isCustomHarness) + '" class="lb-ff__cta" data-continue>REQUEST CUSTOM SIZE</a>'
        : '<button type="button" class="lb-ff__cta" data-continue>VIEW RECOMMENDATIONS</button>';
      var freshBtn = this.els.footer.querySelector("[data-continue]");
      this.wireScreen2ContinueClick(freshBtn);
      if (!custom) this.updateContinueButton(freshBtn);
    }
    this.updateStatusCard(el);
  };

  // A measurement is "blocked" when its value sits exactly on a genuine
  // Size-letter tie and the user hasn't yet resolved it with LOOSE / SNUG.
  LillebjornFitFinder.prototype.isMeasureBlocked = function () {
    var s = this.state;
    var types = this.currentTypes();
    var includesCollar = types.indexOf("collar") !== -1;
    var includesHarness = types.indexOf("harness") !== -1;
    // Premium custom-size flow: once a relevant measurement is past its
    // standard ceiling, the CTA is a "request a bespoke order" action, not a
    // sizing confirmation. It must never be locked out by an unrelated tie —
    // e.g. an unresolved CHEST boundary while only NECK is custom in Bundle
    // mode — which would otherwise leave the button disabled/pointer-events
    // :none and silently swallow the click.
    if ((includesCollar && this.isCustomNeck()) || (includesHarness && this.isCustomChest())) return false;
    if (includesCollar) {
      if (boundaryTie(s.neckPrecise, NECK_NODES, COLLAR_SIZES, BOUNDARY_TIE_EPSILON_CM) && !s.boundaryChoice.neck) return true;
    }
    if (includesHarness) {
      if (boundaryTie(s.chestPrecise, CHEST_NODES, HARNESS_SIZES, BOUNDARY_TIE_EPSILON_CM) && !s.boundaryChoice.chest) return true;
    }
    return false;
  };

  LillebjornFitFinder.prototype.updateContinueButton = function (btn) {
    // The custom-size CTA is a mailto <a>, which has no disabled state —
    // it's a real link and is always "enabled".
    if (!btn || btn.tagName === "A") return;
    var blocked = this.isMeasureBlocked();
    btn.disabled = blocked;
    btn.setAttribute("aria-disabled", blocked ? "true" : "false");
  };

  // showHeader gates this block's own eyebrow ("NECK MEASUREMENT") + H3
  // title ("Find your collar size") — only needed in dual/bundle mode
  // where two measure blocks share one screen and need their own labels
  // to tell them apart. In single-measurement mode that same text is
  // already the screen's main H2 (see renderScreen2's mainTitle), so
  // repeating it here would just be redundant stacked headings.
  // min/max here are always cm — the true commercial-matrix floor/ceiling
  // (e.g. NECK_NODES[0]/NECK_CUSTOM_MAX). They're stamped onto the block as
  // data-min-cm/data-max-cm so wireMeasureBlock can always clamp against
  // them regardless of which unit domain the slider/number input are
  // currently rendered in; everything else below derives the unit actually
  // shown (domain, step, displayed value) from those two cm numbers plus
  // this.state.unit.
  LillebjornFitFinder.prototype.measureBlockMarkup = function (key, eyebrow, title, copy, min, max, showHeader) {
    var v = this.buildMeasureVals(key, this.state[key + "Size"], this.state[key + "Precise"]);
    var imgUrl = this.getAttribute("data-" + key + "-illustration") || "";
    var unit = this.state.unit;
    var isIn = unit === "in";
    var cmValue = this.state[key + "Size"];
    // The slider/number-input min/max/step switch to an inches domain here
    // so dragging feels native — but only the DOM presentation changes.
    // cmToIn(min)/cmToIn(max) are used directly as the endpoints: cmToIn's
    // output always already sits exactly on the 0.1in step grid (see
    // INCHES_SLIDER_STEP's own comment), so no separate snapping is needed,
    // and they still mean exactly `min`/`max` in cm.
    var domainMin = isIn ? cmToIn(min) : min;
    var domainMax = isIn ? cmToIn(max) : max;
    var domainStep = isIn ? INCHES_SLIDER_STEP : 1;
    var displayValue = formatMeasureDisplay(cmValue, unit);
    var displayValueAttr = isIn ? displayValue.toFixed(1) : String(displayValue);
    var unitLabel = isIn ? "in" : "cm";
    var ariaUnitText = isIn ? "in inches" : "in centimeters";
    return (
      '<div class="lb-ff__measure-block' + (showHeader ? '' : ' lb-ff__measure-block--no-header') + '" data-measure="' + key + '" data-min-cm="' + min + '" data-max-cm="' + max + '">' +
      (showHeader ? '  <div class="lb-ff__eyebrow">' + eyebrow + '</div>' +
      '  <h3 class="lb-ff__title lb-ff__measure-title">' + title + '</h3>' : '') +
      (imgUrl ? '<div class="lb-ff__measure-figure"><img src="' + escapeHtml(imgUrl) + '" alt="' + title + ' illustration" loading="lazy" decoding="async"></div>' : '') +
      '  <p class="lb-ff__measure-copy">' + copy + '</p>' +
      '  <div class="lb-ff__measure-readout">' +
      '    <div class="lb-ff__field-label" style="margin:0;">' + key.toUpperCase() + ' SIZE</div>' +
      '    <div class="lb-ff__measure-value-wrap">' +
      '      <input type="number" inputmode="' + (isIn ? "decimal" : "numeric") + '" class="lb-ff__measure-value" data-readout min="' + domainMin + '" max="' + domainMax + '" step="' + domainStep + '" value="' + displayValueAttr + '" aria-label="' + key + ' measurement, ' + ariaUnitText + '">' +
      '      <span class="lb-ff__measure-unit">' + unitLabel + '</span>' +
      '    </div>' +
      '  </div>' +
      '  <div class="lb-ff__measure-sizelabel" data-sizelabel>' + v.sizeLabel + '</div>' +
      '  <input type="range" class="lb-ff__slider" data-slider min="' + domainMin + '" max="' + domainMax + '" step="' + domainStep + '" value="' + displayValueAttr + '">' +
      // The breed-range guardrail for this measurement no longer renders
      // here — see renderScreen2's shared .lb-ff__status-card (populated by
      // guardrailSlotHtml) and refreshMeasureBlock's [data-guardrail-slot]
      // update below. The boundary (Loose/Snug) chooser stays exactly here,
      // directly under its own slider — unlike the guardrail, it's an
      // active decision about *this* measurement, not a passive note.
      '  <div data-boundary>' + (v.showBoundary ? this.boundaryMarkup(key, v) : '') + '</div>' +
      '</div>'
    );
  };

  LillebjornFitFinder.prototype.boundaryMarkup = function (key, v) {
    return (
      '<div class="lb-ff__boundary">' +
      '  <div class="lb-ff__boundary-header">' + v.boundaryHeaderText + '</div>' +
      '  <div class="lb-ff__boundary-choices">' +
      '    <button type="button" class="lb-ff__boundary-btn" data-boundary-choice="loose" data-key="' + key + '" data-on="' + (v.choice === "loose") + '">LOOSE / RELAXED MEASUREMENT</button>' +
      '    <button type="button" class="lb-ff__boundary-btn" data-boundary-choice="snug" data-key="' + key + '" data-on="' + (v.choice === "snug") + '">SNUG / EXACT SKIN MEASUREMENT</button>' +
      '  </div>' +
      '</div>'
    );
  };

  LillebjornFitFinder.prototype.wireMeasureBlock = function (el, key) {
    var self = this;
    var block = el.querySelector('[data-measure="' + key + '"]');
    if (!block) return;
    var slider = block.querySelector("[data-slider]");
    var numberInput = block.querySelector("[data-readout]");
    // Canonical cm bounds — deliberately NOT read from the slider/number
    // input's own min/max, which are unit-dependent (inches endpoints in IN
    // mode, see measureBlockMarkup). Stamped onto the block itself so they
    // stay correct regardless of which domain the controls currently render.
    var minCm = parseInt(block.getAttribute("data-min-cm"), 10);
    var maxCm = parseInt(block.getAttribute("data-max-cm"), 10);

    // A raw slider/number-input reading is in whatever unit is currently
    // displayed — always convert to a whole cm before it ever reaches
    // state or the sizing engine, so sizeFromValue/rangeStatus/boundaryTie
    // never see (or need to know about) anything but an integer centimeter.
    function toCm(raw) {
      return self.state.unit === "in" ? inToCm(raw) : Math.round(raw);
    }

    // The unrounded cm-equivalent of a raw reading — used ONLY to update
    // state's *Precise companion (see BOUNDARY_TIE_EPSILON_CM), never for
    // the sizing engine itself.
    function toPreciseCm(raw) {
      return self.state.unit === "in" ? raw * CM_PER_INCH : raw;
    }

    // Commits a whole-cm value (plus its precise companion) to state and
    // refreshes every computed bit of UI that depends on it (size label,
    // guardrail, custom-size banner, continue button). Deliberately does
    // NOT touch the slider's or number input's own displayed text — each
    // event handler below owns that decision explicitly, since what's safe
    // to overwrite differs by which control the shopper is actually using
    // (see the "why" note on the number input's blur handler further down).
    function commit(cm, preciseCm) {
      self.state[key + "Size"] = cm;
      self.state[key + "Precise"] = preciseCm;
      self.state.boundaryChoice[key] = null;
      self.refreshMeasureBlock(el, block, key);
      // Custom-size banner/CTA must flip instantly as either control crosses
      // its standard ceiling in either direction — including swapping the
      // CTA's element type, so this runs before the disabled check
      // re-queries the (possibly just-replaced) CTA node. Also updates the
      // shared status card's active state (see updateStatusCard).
      self.syncCustomSizeUI(el);
      // Landing on a genuine boundary must disable the CTA immediately.
      self.updateContinueButton(self.els.footer.querySelector("[data-continue]"));
    }

    // Shared clamp-and-commit for a raw slider/typed reading: rounds to a
    // whole cm for the engine, clamps to this field's own floor/ceiling, and
    // — unless clamping actually changed the value — keeps the UNROUNDED
    // reading as the precise companion (that's what lets the boundary-tie
    // check in computeSize/buildMeasureVals tell a genuine 12.6in reading
    // apart from a 12.5in or 12.7in one that only LOOKS the same after
    // rounding to the same whole centimeter — see BOUNDARY_TIE_EPSILON_CM).
    function commitFromRaw(raw) {
      var rawCm = toCm(raw);
      var cm = clamp(rawCm, minCm, maxCm);
      var preciseCm = (cm === rawCm) ? toPreciseCm(raw) : cm;
      commit(cm, preciseCm);
      return cm;
    }

    slider.addEventListener("input", function () {
      var parsed = parseFloat(slider.value);
      // Defensive guard: sizeFromValue/rangeStatus/boundaryTie all degrade
      // SILENTLY on NaN (e.g. sizeFromValue falls through to the last size
      // letter, rangeStatus reports "no issue") rather than throwing — which
      // is worse than a crash, since it would look like a legitimate result.
      // A non-numeric slider.value should never happen from a real <input
      // type=range>, but if it ever did, ignore the event outright rather
      // than write garbage into state.
      if (isNaN(parsed)) return;
      // Mirror the slider's own raw reading into the number field directly
      // (not a rounded-then-reformatted value), so it tracks the thumb 1:1
      // with no mid-drag flicker.
      //
      // Deliberately unit-agnostic. This was previously gated on
      // `self.state.unit === "in"`, which left the cm readout frozen at
      // whatever measureBlockMarkup last rendered while the thumb moved
      // underneath it: state, size label, and guardrail all updated (via
      // commitFromRaw below), so the only broken thing was the one number
      // the shopper was actually reading. Nothing else writes this field
      // on a drag — refreshMeasureBlock deliberately never touches the
      // readout (see its own comment) precisely because this line owns it.
      //
      // Safe in both domains because slider.value is already in the
      // displayed unit: cm mode renders the slider on an integer cm
      // domain (step 1), inches on a 0.1in domain, and the number input
      // beside it carries the matching min/max/step either way — so this
      // is a like-for-like copy, never a cross-unit one.
      if (numberInput) numberInput.value = slider.value;
      commitFromRaw(parsed);
    });

    // Nothing left to reformat on release — the slider already shows
    // wherever the shopper's drag left it, and the number field already
    // mirrors that same value live (see "input" above). This is a cheap,
    // idempotent safety-net commit only, in case a browser/input method
    // ever fires "change" without a preceding final "input".
    slider.addEventListener("change", function () {
      var parsed = parseFloat(slider.value);
      if (isNaN(parsed)) return;
      commitFromRaw(parsed);
    });

    // A shopper who already has an exact tape-measure reading shouldn't
    // have to pixel-hunt a slider to enter it — this field is a direct,
    // precise alternative that stays in lockstep with the slider.
    if (numberInput) {
      numberInput.addEventListener("input", function () {
        var parsed = parseFloat(numberInput.value);
        if (isNaN(parsed)) return;
        var cm = toCm(parsed);
        // Only commit while already in range — clamping mid-keystroke (e.g.
        // forcing "4" to the 17cm floor while the shopper is still typing
        // "42", or forcing "13" to a rounded value while typing "13.25")
        // would fight the user and corrupt what they're typing. Out-of-range
        // digits are left alone until blur/Enter below. Never touches this
        // field's own displayed text — the shopper is actively typing it.
        if (cm < minCm || cm > maxCm) return;
        commit(cm, toPreciseCm(parsed));
      });

      numberInput.addEventListener("blur", function () {
        var unit = self.state.unit;
        var parsed = parseFloat(numberInput.value);

        if (isNaN(parsed)) {
          // Nothing valid left in the field — there's no typed reading
          // worth preserving, so redisplay the last committed value on
          // both controls.
          var cmNow = self.state[key + "Size"];
          var fallback = unit === "in" ? formatMeasureDisplay(cmNow, unit).toFixed(1) : String(cmNow);
          numberInput.value = fallback;
          slider.value = fallback;
          return;
        }

        var rawCm = toCm(parsed);
        var cm = clamp(rawCm, minCm, maxCm);

        if (cm !== rawCm) {
          // Out of range — the typed number doesn't correspond to a real
          // measurement this field can hold, so it's replaced with the
          // clamped value; there's nothing legitimate about the original
          // text to keep.
          var clampedDisplay = unit === "in" ? formatMeasureDisplay(cm, unit).toFixed(1) : String(cm);
          numberInput.value = clampedDisplay;
          slider.value = clampedDisplay;
          commit(cm, cm);
          return;
        }

        // In range: commit the cm conversion for the sizing engine, but
        // deliberately leave this field's own text exactly as typed —
        // reformatting it through cmToIn(cm) here was the actual cause of
        // typed values silently changing (e.g. typing "12.3" rounds to
        // 31cm, and cmToIn(31) prints "12.2", not the 12.3 that was typed).
        // The engine only ever sees the rounded whole centimeter; only the
        // *display* of what the shopper actually typed is preserved as-is.
        //
        // Two-way sync (Option D) still moves the slider to match — but
        // snapped to its own 0.1in grid DIRECTLY from the typed number, not
        // re-derived through cm and back (the same round-trip that would
        // otherwise show a barely-related figure, exactly like the number
        // field's own case above). Assigning an exact multiple of
        // INCHES_SLIDER_STEP is always grid-safe (see commit()'s own
        // comment on why), so this never risks the browser silently
        // substituting a different value.
        if (unit === "in") {
          slider.value = (Math.round(parsed / INCHES_SLIDER_STEP) * INCHES_SLIDER_STEP).toFixed(1);
        } else {
          slider.value = String(cm);
        }
        commit(cm, toPreciseCm(parsed));
      });

      numberInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") { e.preventDefault(); numberInput.blur(); }
      });
    }

    block.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-boundary-choice]");
      if (!btn) return;
      self.state.boundaryChoice[key] = btn.getAttribute("data-boundary-choice");
      self.refreshMeasureBlock(el, block, key);
      self.updateContinueButton(self.els.footer.querySelector("[data-continue]"));
    });
  };

  LillebjornFitFinder.prototype.refreshMeasureBlock = function (el, block, key) {
    var v = this.buildMeasureVals(key, this.state[key + "Size"], this.state[key + "Precise"]);
    // The readout's own displayed value is intentionally NOT touched here —
    // apply() (see wireMeasureBlock) already owns exactly when each control
    // is safe to overwrite (never mid-drag on the slider that triggered the
    // event, never mid-keystroke on the number input that triggered it);
    // duplicating that write here would re-fight whichever control the
    // caller deliberately left alone.
    block.querySelector("[data-sizelabel]").textContent = v.sizeLabel;
    // Guardrail slot lives in the shared .lb-ff__status-card now (see
    // renderScreen2/guardrailSlotHtml), not inside this measurement's own
    // block — same computed v.showGuardrail/v.guardrailMessage as before,
    // only the DOM target changed.
    var slot = el.querySelector('[data-guardrail-slot="' + key + '"]');
    if (slot) {
      slot.innerHTML = v.showGuardrail
        ? '<div class="lb-ff__status-line" data-tone="' + v.guardrailTone + '">' + v.guardrailMessage + '</div>' : '';
    }
    block.querySelector("[data-boundary]").innerHTML = v.showBoundary ? this.boundaryMarkup(key, v) : '';
  };

  /* ---------- Sizing outcome ---------- */

  // Strict current-size logic: the returned letter reflects ONLY the cm
  // input from Step 3 plus its LOOSE/SNUG resolution. Growing Puppy never
  // pads this — a loose collar is unsafe, so puppies get the size that
  // fits them right now. The puppy flag instead drives Step 4's safety
  // copy/width overrides (see renderScreen3).
  LillebjornFitFinder.prototype.computeSize = function (key) {
    var meta = MEASURE_META[key];
    var value = this.state[key + "Size"];
    var precise = this.state[key + "Precise"];
    var choice = this.state.boundaryChoice[key];
    var letters = boundaryTie(precise, meta.nodes, meta.sizes, BOUNDARY_TIE_EPSILON_CM);
    if (letters && choice) {
      return choice === "loose" ? letters.lower : letters.upper;
    }
    return sizeFromValue(value, meta.nodes, meta.sizes);
  };

  /* ============================================================
     Screen 3: results — variant mapping, reactive swatches, cart
     ============================================================ */

  LillebjornFitFinder.prototype.renderScreen3 = function (el) {
    var self = this;
    var s = this.state;
    // Results has no single primary CTA — each product card has its own
    // Add to Cart, and .lb-ff__sticky-recap (a separate, deliberately
    // action-less mechanism — see updateStickyRecapVisibility) already
    // covers the "don't lose track of your size" need for this screen.
    // Clears any footer content left over from Screen 1/2.
    this.els.footer.innerHTML = "";
    var breed = s.breedProfile;
    var types = this.currentTypes();
    var includesCollar = types.indexOf("collar") !== -1;
    var includesHarness = types.indexOf("harness") !== -1;

    var isPuppy = s.ageProfile === "puppy";
    var recNeckSize = includesCollar ? this.computeSize("neck") : null;
    var recChestSize = includesHarness ? this.computeSize("chest") : null;
    var neckRangeLabel = recNeckSize ? sizeRangeLabel(recNeckSize, NECK_NODES, COLLAR_SIZES, "necks", s.unit) : "";
    var chestRangeLabel = recChestSize ? sizeRangeLabel(recChestSize, CHEST_NODES, HARNESS_SIZES, "chests", s.unit) : "";

    var whyText = s.selectionId === "harness"
      ? "Given your " + breed.name + "'s skeletal build, we curated the Vero Harness to safely distribute pull-forces across the chest and sternum, ensuring complete throat freedom and uninhibited shoulder movement."
      : (WHY_TEXT[breed.category] || WHY_TEXT["standard"])(breed);
    // Strict current-size logic: no "extra room" language — the recommended
    // size already IS the puppy's exact current fit. Safety/guidance is
    // handled per-card below instead of by padding the size itself.
    if (isPuppy) whyText += " Sized to their exact current measurements — no upsizing — since a loose fit isn't safe for a growing puppy.";

    // Verdict panel: eyebrow + size/range + "why this fits" now share ONE
    // compact card instead of three separate stacked blocks (verdict card,
    // its own bordered why-box, and the guarantee line that used to sit
    // right under it). The 14-day guarantee text moved much lower — see
    // lb-ff__reassurance near the support block below — so the first thing
    // a shopper reads is compact enough to leave room for the actual offer
    // on the same screen.
    var verdictHtml;
    if (s.selectionId === "bundle") {
      verdictHtml =
        '<div class="lb-ff__verdict" tabindex="-1" data-step-focus>' +
        '  <div class="lb-ff__verdict-eyebrow">YOUR CUSTOM BUNDLE FIT</div>' +
        '  <div class="lb-ff__verdict-split">' +
        '    <div class="lb-ff__verdict-col"><div class="lb-ff__verdict-col-label">COLLAR</div><div class="lb-ff__verdict-col-size">SIZE ' + recNeckSize + '</div><div class="lb-ff__verdict-range">' + neckRangeLabel + '</div></div>' +
        '    <div class="lb-ff__verdict-divider"></div>' +
        '    <div class="lb-ff__verdict-col"><div class="lb-ff__verdict-col-label">HARNESS</div><div class="lb-ff__verdict-col-size">SIZE ' + recChestSize + '</div><div class="lb-ff__verdict-range">' + chestRangeLabel + '</div></div>' +
        '  </div>' +
        '  <hr class="lb-ff__verdict-hr">' +
        '  <div class="lb-ff__verdict-why">' + whyText + '</div>' +
        '</div>';
    } else {
      var singleSize = s.selectionId === "harness" ? recChestSize : recNeckSize;
      var singleRangeLabel = s.selectionId === "harness" ? chestRangeLabel : neckRangeLabel;
      verdictHtml =
        '<div class="lb-ff__verdict" tabindex="-1" data-step-focus>' +
        '  <div class="lb-ff__verdict-eyebrow">YOUR CUSTOM FIT</div>' +
        '  <div class="lb-ff__verdict-row">' +
        '    <span class="lb-ff__verdict-size">SIZE ' + singleSize + '</span>' +
        '    <span class="lb-ff__verdict-range">' + singleRangeLabel + '</span>' +
        '  </div>' +
        '  <hr class="lb-ff__verdict-hr">' +
        '  <div class="lb-ff__verdict-why">' + whyText + '</div>' +
        '</div>';
    }

    // Plain-text size recap shown by the sticky bar at the bottom of the
    // drawer (see lb-ff__sticky-recap below) — deliberately just the size,
    // not a price: with bundle-pair mode or multiple main families there
    // can be more than one matched card on screen at once, so there's no
    // single "the" price to mirror here safely. The "bundle" (dual-item)
    // case drops the "Recommended Fit:" prefix entirely — "Collar XL ·
    // Harness XL" is already unambiguous, and keeping the prefix on top of
    // two size labels was the exact combination that wrapped/truncated the
    // size codes off-screen on mobile widths (see .lb-ff__sticky-recap-size
    // in the CSS for the rest of that fix).
    var stickyRecapLabel = s.selectionId === "bundle"
      ? "Collar " + recNeckSize + " · Harness " + recChestSize
      : "Recommended Fit: Size " + (s.selectionId === "harness" ? recChestSize : recNeckSize);

    var swatchesHtml = LEATHERS.map(function (l) {
      return '<button type="button" class="lb-ff__swatch" style="background:' + l.hex + '" title="' + l.name + '" aria-label="' + l.name + '" data-leather="' + l.key + '" data-active="' + (s.selectedLeather === l.key) + '"></button>';
    }).join("");

    // Width routing is identical for adults and puppies — Sighthound always
    // gets Wide 4.5cm, Toy always gets the real 2cm Vero Classic, Bully
    // always gets Classic 3cm ONLY (see CATEGORY_WIDTH_ALLOWLIST), Standard
    // gets Classic 2cm/3cm. Growing Puppy changes ONLY the disclaimer
    // copy attached to each card below and the starting slider position
    // (see applyAgeProfile) — never which family/width is recommended.
    var rule = RECOMMENDATION_RULES[breed.category] || RECOMMENDATION_RULES["standard"];
    var mainFamilies = includesCollar ? rule.main.slice() : [];
    var altFamilies = includesCollar ? rule.alt.slice() : [];
    if (includesHarness) mainFamilies.push("harness");

    var cards = this.buildProductCards(mainFamilies, recNeckSize, recChestSize, neckRangeLabel, chestRangeLabel, { isPuppy: isPuppy, breedCategory: breed.category });
    // breedCategory is passed here too — the anatomical width gate inside
    // buildProductCards (CATEGORY_WIDTH_ALLOWLIST) applies to cross-sell
    // cards exactly the same as main ones (e.g. a sighthound's alt Classic
    // cross-sell must drop 2cm just as strictly as its main Wide pick).
    var crossSellCards = s.selectionId !== "harness" ? this.buildProductCards(altFamilies, recNeckSize, recChestSize, neckRangeLabel, chestRangeLabel, { breedCategory: breed.category }) : [];

    // Upsell context — resolved ONCE per render. leashColorMap/
    // leashHandsFreeColorMap are the RAW per-color product maps
    // (this.productMap.leash / this.productMap["leash-hands-free"]), not a
    // single resolved card: leash width is a value DERIVED per main card
    // (from that card's own resolved size — see resolveLeashForCard), so
    // it can't be resolved once for the whole screen. Both are read
    // unconditionally regardless of s.selectionId — there's no double-add
    // risk to gate against here: buildUpsellTiers itself makes Walk Kit
    // and Complete Bundle mutually exclusive by selectionId (see its own
    // comment), so the SAME leash data is safe to expose to every card.
    var leashColorMap = this.productMap.leash || null;
    var leashHandsFreeColorMap = this.productMap["leash-hands-free"] || null;
    // Kit imagery — real pre-composed studio photography AND real catalog
    // titles for Tier 2/3, NOT a CSS-composited stack of the individual
    // item/leash photos and NOT a synthesized title string. Shaped as
    // { walkkit: { Aeris: { black: { Classic: { "3cm": { url, title }, ... },
    // "Hands Free": {...} }, ... }, Vero: {...}, Harness: {...} },
    // bundle: {...same shape...} } — see resolveKitAsset/
    // designIdentifierForFamily. this.productMap["kit-imagery"] is
    // populated by the Liquid section via a REAL COLLECTION SCAN
    // (collections['dog-walk-kits'] / ['bundles-collection'], matched by
    // design line + color + leash style + width) — see
    // snippets/lillebjorn-kit-collection-scan.liquid — not a guessed
    // handle and not a merchant-picked setting. A missing/unmatched entry
    // (no product in that collection matches all four criteria) degrades
    // to the plain single-item photo already on the card rather than a
    // broken <img>, same as every other "no match found" path in this
    // file.
    var kitImagery = this.productMap["kit-imagery"] || null;
    var upsell = {
      leashColorMap: leashColorMap,
      leashHandsFreeColorMap: leashHandsFreeColorMap,
      kitImagery: kitImagery,
      selectedLeather: s.selectedLeather,
      // Rendered once, inside the first card only (see the showLeather
      // param on cardMarkup/bundlePairMarkup below) — selectedLeather is
      // single shared state, one choice governing every card on screen at
      // once, so showing this picker inside every card would just repeat
      // the same control 2-4 times for no reason. scrollToLeatherSwatches
      // (JS) and the [data-leather] click wiring both already do a
      // screen-wide querySelector for .lb-ff__leather-row/[data-leather],
      // not a positional lookup, so nesting it inside a card here needs no
      // changes on that side.
      leatherSwatchesHtml: swatchesHtml,
      // Complete Bundle needs to know WHICH selection produced this
      // screen (only "bundle" makes it eligible — see buildUpsellTiers)
      // and needs every main card on screen to find its own bundle
      // partner (see findBundlePartnerCard) — `cards` is the same array
      // already built above, reused as-is rather than recomputed.
      selectionId: s.selectionId,
      allCards: cards
    };

    // Fix for the "two separate result cards, each with its own duplicate
    // Complete Bundle tile" bug on the Collar & Harness Bundle entry point
    // — see buildBundlePairTiers' own comment for the full story. Splits
    // `cards` (which, for selectionId "bundle", already contains every main
    // collar card PLUS the harness card, all built above the normal way)
    // into the harness card and the collar card(s), so each collar option
    // can be consolidated with the SAME shared harness into one card. Falls
    // back to the normal one-card-per-family rendering the instant either
    // side is missing (out of stock/unmapped) — never invents a
    // consolidated view out of half-available data.
    var harnessCardForPair = null;
    var collarCardsForPair = [];
    if (s.selectionId === "bundle" && includesCollar && includesHarness) {
      cards.forEach(function (c) {
        var fam = PRODUCT_FAMILIES[c.familyKey] || {};
        if (fam.type === "harness") { harnessCardForPair = c; }
        else { collarCardsForPair.push(c); }
      });
    }
    var bundlePairMode = !!(harnessCardForPair && collarCardsForPair.length && harnessCardForPair.variant);

    var productsHtml = bundlePairMode
      ? collarCardsForPair.map(function (collarCard, i) { return self.bundlePairMarkup(collarCard, harnessCardForPair, upsell, i === 0); }).join("")
      : cards.map(function (c, i) { return self.cardMarkup(c, upsell, i === 0); }).join("");

    el.innerHTML =
      '<div class="lb-ff__back" data-back>← BACK</div>' +
      verdictHtml +
      (cards.length ? (
        '<div class="lb-ff__section-label">MATCHED FOR YOU</div>' +
        '<div class="lb-ff__products" data-product-cards>' + productsHtml + '</div>'
      ) : '') +
      (crossSellCards.length ? this.accordionMarkup(
        "crosssell",
        '<span class="lb-ff__section-label">OTHER FITS WORTH CONSIDERING</span>',
        '<div class="lb-ff__crosssell-row">' + crossSellCards.map(function (c) { return self.crossSellMarkup(c); }).join("") + '</div>'
      ) : '') +
      // A first-time buyer committing €200+ off a self-measured tape
      // reading is at peak size-anxiety right here — this is the one place
      // in the flow to name the safety net explicitly rather than leaving
      // it implicit. Moved down from directly under the verdict (see the
      // verdict-panel comment above): still unconditionally rendered, just
      // out of the way of the first glance, immediately above the support
      // block it shares a "we've got you covered" register with.
      '<div class="lb-ff__reassurance">' + escapeHtml(this.reassuranceText()) + '</div>' +
      '<div class="lb-ff__support">' +
      '  <p class="lb-ff__support-label">PERSONALIZED ASSISTANCE</p>' +
      '  <p class="lb-ff__support-text">Between sizes, or shopping for a breed we didn’t list? We’re happy to help by hand.</p>' +
      '  <a href="mailto:' + this.supportEmail + '" class="lb-ff__support-link">' + this.supportEmail + ' →</a>' +
      '</div>' +
      '<div class="lb-ff__sticky-recap-spacer" aria-hidden="true"></div>' +
      // Persistent size reminder pinned to the drawer's own bottom edge
      // (not this scrolling screen — see .lb-ff__sticky-recap, positioned
      // absolute against .lb-ff__drawer). Shown once the verdict panel
      // itself has scrolled out of view (see updateStickyRecapVisibility
      // below), so a shopper who's scrolled into cross-sells or the support
      // copy never loses track of the size they just got. Deliberately
      // carries no price/Add-to-Cart action of its own — see the
      // stickyRecapLabel comment above for why.
      '<div class="lb-ff__sticky-recap" data-sticky-recap data-visible="false">' +
      '  <span class="lb-ff__sticky-recap-size">' + escapeHtml(stickyRecapLabel) + '</span>' +
      '  <button type="button" class="lb-ff__sticky-recap-link" data-scroll-to-offer>VIEW OFFER</button>' +
      '</div>';

    el.querySelector("[data-back]").addEventListener("click", function () { self.goToScreen(2); });
    // Delegated on `el` (the whole results-screen container — this.els.
    // screens[3], a stable node render() reuses across every call, only
    // ever swapping its innerHTML) rather than bound directly to each
    // [data-leather] button. A direct bind here only ever wired the
    // buttons that existed in the DOM at THIS exact render — the first
    // card's leather row gets its markup regenerated from scratch by
    // replaceCardGroup/replaceBundlePairGroup (a tier switch, or the
    // leash-style toggle's refreshAllCards loop), producing fresh
    // [data-leather] buttons with no listener of their own ever attached.
    // A click on one of those orphaned buttons then had nothing to stop
    // it, so it bubbled straight up to the card's own click-to-open-PDP
    // handler — exactly the "leather swatch navigates away after
    // switching leash type" regression. Delegating here instead means
    // every [data-leather] button rendered inside `el`, now or after any
    // later partial re-render, is already covered.
    //
    // __lbffLeatherDelegated guards this exactly like wireTooltipDelegation
    // guards itself with __lbffTooltipDelegated — renderScreen3 re-runs on
    // EVERY re-render of this screen (any leather click, tier switch, or
    // leash toggle), and without this guard every one of those re-renders
    // bound one more identical listener on top of every listener already
    // there, since `el` itself is never recreated. That's a duplicate-
    // listener leak, not a one-time miswiring: a click fires ALL stacked
    // listeners, each one calling render() (which re-runs renderScreen3
    // and stacks one more) — the count roughly doubles every click.
    // Confirmed directly via console profiling before this fix: render()
    // fired 1x, then 2x, then 4x for three consecutive swatch clicks.
    if (!el.__lbffLeatherDelegated) {
      el.__lbffLeatherDelegated = true;
      // CAPTURE phase (the `true` below) — not bubble — for exactly the
      // reason wireTooltipDelegation's own click listener already
      // documents: wireSingleCard's cardEl.addEventListener("click",
      // openCard) is bound directly to [data-card], which sits BETWEEN
      // the swatch and this `el` listener in the tree. In the BUBBLE
      // phase, listeners fire nearest-target-first, so cardEl's own
      // bubble handler fired and opened a new tab BEFORE this one ever
      // ran — and it read the card's data-url from BEFORE this click's
      // color change, i.e. whatever color the PREVIOUS click had just
      // set. That's exactly the reported "clicking Red opens Black's
      // PDP, clicking Green opens Red's PDP" one-click-lagged pattern:
      // each click opened the tab for the PRIOR selection, then updated
      // state for the next one. Capture runs top-down before any
      // descendant's bubble-phase handler gets a turn, so
      // stopPropagation here now reliably stops the click before cardEl
      // ever sees it.
      el.addEventListener("click", function (e) {
        var btn = e.target.closest && e.target.closest("[data-leather]");
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        self.state.selectedLeather = btn.getAttribute("data-leather");
        self.render();
      }, true);
    }
    // Delegated the same way, and for the same reason, as the
    // [data-leather] handler directly above — capture phase so a tap on an
    // accordion header inside a clickable [data-card] (WHAT'S INCLUDED,
    // LEASH STYLE) is stopped before that card's own bubble-phase
    // click-to-open-PDP handler ever sees it, and doesn't need re-binding
    // on every re-render since `el` itself is never recreated (see
    // __lbffLeatherDelegated's own comment).
    //
    // Toggles the DOM directly rather than calling self.render() — a full
    // re-render would reset .lb-ff__content's scroll position for a
    // purely local, no-cart-state-affecting interaction. this.state.
    // accordionOpen is still updated so the choice survives the next
    // render() a *different* action triggers (tier switch, leash-style
    // change, leather swap).
    if (!el.__lbffAccordionDelegated) {
      el.__lbffAccordionDelegated = true;
      el.addEventListener("click", function (e) {
        var btn = e.target.closest && e.target.closest("[data-accordion-toggle]");
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var acc = btn.closest(".lb-ff__accordion");
        if (!acc) return;
        var id = acc.getAttribute("data-accordion");
        var nowOpen = acc.getAttribute("data-open") !== "true";
        acc.setAttribute("data-open", nowOpen ? "true" : "false");
        btn.setAttribute("aria-expanded", nowOpen ? "true" : "false");
        self.state.accordionOpen[id] = nowOpen;
        // The accordion's own CSS transition animates the height change;
        // re-measuring the rail on the same tick keeps its fill/marker
        // moving in step rather than snapping once the transition ends.
        self.updateProgressRail();
      }, true);
    }
    var scrollToOfferBtn = el.querySelector("[data-scroll-to-offer]");
    if (scrollToOfferBtn) {
      scrollToOfferBtn.addEventListener("click", function () {
        // Jump straight to the "CHOOSE YOUR SET" tier picker
        // (.lb-ff__set-selection, rendered inside the first product card —
        // see tiersHtml in cardMarkup/bundlePairMarkup) rather than the top
        // of the product cards themselves. Falls back to the card's own CTA
        // row (.lb-ff__card-actions) for a card whose leather has no
        // resolvable upsell tier at all (see buildUpsellTiers — a lone
        // plain product, no Walk Kit mapping), and to the product cards
        // container as a last resort if neither exists.
        var offerTarget = el.querySelector(".lb-ff__set-selection") ||
          el.querySelector(".lb-ff__card-actions") ||
          el.querySelector("[data-product-cards]");
        if (offerTarget) offerTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    if (bundlePairMode) {
      this.wireBundlePairCards(el, collarCardsForPair, harnessCardForPair, upsell);
    } else {
      this.wireProductCards(el, cards, upsell);
    }
    this.updateStickyRecapVisibility();
  };

  // Keeps the persistent size reminder (see .lb-ff__sticky-recap above) AND
  // the scroll progress rail (see updateProgressRail below) in sync with
  // scroll position. Bound to .lb-ff__content ONCE for the lifetime of
  // this component instance — that element is created once in template()
  // and reused across every screen and every re-render, so re-binding on
  // every render() call would stack up duplicate listeners instead of
  // replacing one. Called once from connectedCallback (not lazily from
  // renderScreen3, its previous home) since Screen 2 needs this same
  // listener too — a shopper reaching Screen 2 without ever having
  // rendered Screen 3 first would otherwise scroll with nothing bound.
  // The window resize listener lives here too (same once-per-instance
  // guard) since a viewport/orientation change can shift
  // .lb-ff__content's own visible box, which the rail's inline top/height
  // (see updateProgressRail) need to track.
  LillebjornFitFinder.prototype.bindStickyRecapScroll = function () {
    if (this._stickyRecapBound) return;
    this._stickyRecapBound = true;
    var content = this._drawerEl.querySelector(".lb-ff__content");
    if (!content) return;
    var self = this;
    content.addEventListener("scroll", function () {
      self.updateStickyRecapVisibility();
      self.updateProgressRail();
    }, { passive: true });
    window.addEventListener("resize", function () { self.updateProgressRail(); });

    // Re-measure once an expand/collapse animation has actually finished.
    // Every collapsible surface in this component animates height the same
    // way — grid-template-rows 0fr <-> 1fr (.lb-ff__status-card and its
    // per-row slots on Screen 2, .lb-ff__accordion-panel on Screen 3) — and
    // all of them are re-created wholesale by their screen's innerHTML
    // replace, so this is delegated on .lb-ff__content (bound once, never
    // replaced) rather than to each element, exactly like the [data-leather]
    // and tooltip delegation elsewhere in this file.
    //
    // Why this is needed at all, and not just the synchronous
    // updateProgressRail() call each toggle site already makes: that call
    // runs on the same tick as the class/attribute flip, when
    // content.scrollHeight is still the PRE-animation height. For Screen 3
    // that only means the fill lags by one frame on an already-visible
    // rail. For Screen 2 it decided whether the rail existed: the status
    // card is the very thing pushing that screen past the fold, so the
    // measurement that matters is the one taken after its 0.35s transition
    // lands. Without this the rail stayed hidden until the shopper's next
    // scroll or resize — i.e. it showed up only once they'd already
    // discovered, unaided, that there was more to scroll to.
    //
    // No reduced-motion special case: transition:none means the height
    // change is synchronous, so the existing same-tick call already reads
    // the final value and this listener simply never fires.
    content.addEventListener("transitionend", function (e) {
      if (e.propertyName !== "grid-template-rows") return;
      self.updateProgressRail();
    });
  };

  // Shows the bar once the shopper has scrolled past the verdict panel
  // itself (.lb-ff__verdict — the "YOUR CUSTOM FIT" summary, a fixed-height
  // anchor near the top of every results screen), NOT once past the entire
  // [data-product-cards] block. Gating on the full product-cards block used
  // to depend on there being more trailing content (cross-sell, reassurance,
  // support copy) below it than one viewport tall — on a short results
  // screen (one match, no upsell-eligible tier, a single cross-sell item)
  // that trailing content can be shorter than the viewport, so the block's
  // bottom edge could never actually clear the top and the bar would never
  // appear at all. Anchoring on the verdict panel instead ties visibility to
  // real scroll depth, which is reachable regardless of how much content
  // follows it.
  LillebjornFitFinder.prototype.updateStickyRecapVisibility = function () {
    if (this.state.screen !== 3) return;
    var content = this._drawerEl.querySelector(".lb-ff__content");
    var bar = this._drawerEl.querySelector("[data-sticky-recap]");
    var verdict = this._drawerEl.querySelector(".lb-ff__verdict");
    if (!content || !bar || !verdict) return;
    var pastVerdict = verdict.getBoundingClientRect().bottom < content.getBoundingClientRect().top;
    bar.setAttribute("data-visible", pastVerdict ? "true" : "false");
  };

  // Drives the slim vertical rail along .lb-ff__content's right inner edge
  // (see .lb-ff__progress-rail in the CSS) — a fill that grows with scroll
  // position, plus a small marker dot at the "CHOOSE YOUR SET" tier picker
  // ([data-upsell], the first card's — every card renders one, but the
  // first is the one a shopper reaches first and the rail only needs a
  // single reference point). Screen 2 (Measure) has no [data-upsell], so
  // the marker simply stays hidden there (see the !upsellEl branch below)
  // — that screen only needs the fill, not the marker. Called on every
  // render() (see its own comment), on every .lb-ff__content scroll and
  // window resize (see bindStickyRecapScroll), after every Screen 3
  // accordion toggle (see the [data-accordion-toggle] handler in
  // wireProductCards's caller) since expanding/collapsing WHAT'S INCLUDED
  // shifts everything below it including the marker's target, and after
  // every Screen 2 status-card toggle (see updateStatusCard) for the same
  // reason on the measure screen — plus once more when either of those
  // height animations actually ENDS, via the delegated transitionend
  // listener in bindStickyRecapScroll.
  //
  // top/height are set inline (not in CSS) because the space above
  // .lb-ff__content (the header) is a fixed but breakpoint-dependent
  // height already declared elsewhere in the stylesheet — reading it via
  // getBoundingClientRect here, the same way updateStickyRecapVisibility
  // already reads .lb-ff__verdict's position, is more robust than
  // duplicating every one of those breakpoints into a second place. Height
  // also shrinks to stop above .lb-ff__sticky-recap whenever that bar is
  // visible, so the rail never visually runs through it — see the inline
  // comment further down for why that has to happen here rather than via
  // z-index alone.
  //
  // Fill and marker are both expressed as fractions of the exact same
  // scrollable range (scrollHeight - clientHeight) — the same mapping a
  // native scrollbar thumb uses — so the fill visually reaches the marker
  // at precisely the scroll position where [data-upsell]'s own top aligns
  // with the top of the visible content, rather than two different scales
  // that only coincidentally line up.
  LillebjornFitFinder.prototype.updateProgressRail = function () {
    var rail = this.els.progressRail;
    var fill = this.els.progressRailFill;
    var marker = this.els.progressRailMarker;
    if (!rail || !fill || !marker) return;
    // Screens 2 (Measure) and 3 (Results) both qualify; every other screen
    // is short by construction and has nothing to scroll.
    //
    // Screen 2 used to be gated further, to Bundle Mode only (a Neck AND a
    // Chest block stacked in one step), on the assumption that was the only
    // Screen 2 shape tall enough to need this. It isn't: a SINGLE-
    // measurement step grows past the fold the moment .lb-ff__status-card
    // opens — a breed-range guardrail, or the custom-size banner once a
    // measurement crosses NECK_CUSTOM_MAX/CHEST_CUSTOM_MAX — and on a short
    // viewport the illustration plus the boundary (LOOSE/SNUG) chooser can
    // do it on their own. The scrollRange check below is the honest gate
    // for every one of those cases: it asks the only question that actually
    // matters ("is there anywhere to scroll?") rather than trying to
    // enumerate in advance which screen shapes will be tall. Net effect on
    // Screen 2 is what a shopper would expect — the rail appears exactly
    // when the content outgrows the pane, and goes away again when it
    // doesn't.
    if (this.state.screen !== 2 && this.state.screen !== 3) {
      rail.hidden = true;
      return;
    }
    var content = this._drawerEl.querySelector(".lb-ff__content");
    if (!content) {
      rail.hidden = true;
      return;
    }
    var scrollRange = content.scrollHeight - content.clientHeight;
    // Nothing to scroll (a short results screen: one match, no cross-sell)
    // — a rail with nowhere to travel is just visual noise.
    if (scrollRange <= 0) {
      rail.hidden = true;
      return;
    }
    var drawerRect = this._drawerEl.getBoundingClientRect();
    var contentRect = content.getBoundingClientRect();
    rail.hidden = false;
    rail.style.top = (contentRect.top - drawerRect.top) + "px";

    // Shortens the rail so its own box never extends behind
    // .lb-ff__sticky-recap once that bar has slid into view — z-index
    // alone can't settle this (see .lb-ff__progress-rail's own CSS
    // comment: the bar is nested many stacking-context levels below this
    // rail's actual drawer-level sibling position, so no z-index it
    // declares can win against the rail's). Measuring the bar's real
    // rendered height here — rather than a guessed constant — keeps this
    // correct across breakpoints where the bar wraps to fewer/more lines
    // (see its own 480px media query) without a second place to update.
    var stickyBar = this._drawerEl.querySelector("[data-sticky-recap]");
    var stickyBarHeight = (stickyBar && stickyBar.getAttribute("data-visible") === "true")
      ? stickyBar.getBoundingClientRect().height
      : 0;
    rail.style.height = Math.max(0, contentRect.height - stickyBarHeight) + "px";

    var fillPct = Math.max(0, Math.min(1, content.scrollTop / scrollRange));
    fill.style.height = (fillPct * 100) + "%";

    var upsellEl = content.querySelector("[data-upsell]");
    if (!upsellEl) {
      marker.hidden = true;
      return;
    }
    var upsellRect = upsellEl.getBoundingClientRect();
    var offsetFromContentTop = (upsellRect.top - contentRect.top) + content.scrollTop;
    var markerRatio = Math.max(0, Math.min(1, offsetFromContentTop / scrollRange));
    marker.hidden = false;
    marker.style.top = (markerRatio * 100) + "%";
  };

  // Merchant-editable trust copy (see data-reassurance-text in the Liquid
  // section) — shown once on the results screen, right where a first-time
  // buyer is deciding whether to trust a self-measured size on an
  // expensive handcrafted item. Falls back to sensible default copy so
  // nothing breaks for a store that hasn't set the attribute yet.
  LillebjornFitFinder.prototype.reassuranceText = function () {
    return this.getAttribute("data-reassurance-text") ||
      "Each piece is handcrafted to order. If the fit isn't quite right, we'll gladly arrange a size exchange within 14 days of delivery — just reach out.";
  };

  // Builds one card per family, splitting each "classic" family (Aeris and
  // Vero alike) into two width-bound cards (2cm / 3cm) per its widthSplit.
  // opts.isPuppy + opts.breedCategory drive the Step 4 safety disclaimer —
  // they never change WHICH family/width is recommended (see renderScreen3).
  LillebjornFitFinder.prototype.buildProductCards = function (familyKeys, recNeckSize, recChestSize, neckRangeLabel, chestRangeLabel, opts) {
    var self = this;
    opts = opts || {};
    var cards = [];
    familyKeys.forEach(function (key) {
      var family = PRODUCT_FAMILIES[key];
      // Each color is a distinct Shopify product in this catalogue (no
      // Color variant option) — self.productMap[key] is a color -> product
      // map, and the leather swatch picks WHICH product to read rather than
      // filtering variants within one. Title/description/url don't vary by
      // color, so a reference product (the selected color if mapped, else
      // whichever color the merchant did map) supplies those; but the exact
      // selected-color product is required for image/price/variant — same
      // Strict Stock Rule as before, just extended one level up from
      // variant to product.
      var colorMap = self.productMap[key];
      if (!family || !colorMap) return;
      var productData = colorMap[self.state.selectedLeather] || null;
      var referenceProduct = productData || firstMappedProduct(colorMap);
      if (!referenceProduct) return;

      var declaredWidths = family.widthSplit ? family.widths : [family.widths[0] || null];

      var widths;
      if (productCarriesWidthData(referenceProduct)) {
        // Two independent filters, both must pass:
        //  1. Stock reality — a width the catalog data declares but this
        //     product doesn't actually carry is omitted entirely rather
        //     than rendered as an UNAVAILABLE ghost card.
        //  2. Anatomical safety — CATEGORY_WIDTH_ALLOWLIST + the large-neck
        //     ceiling (see isWidthAllowedForCategory) hard-gate which
        //     widths are appropriate for this breed's category/size,
        //     independent of what the product happens to stock.
        widths = declaredWidths.filter(function (width) {
          return productHasWidth(referenceProduct, width) &&
            isWidthAllowedForCategory(width, opts.breedCategory, family.type, recNeckSize);
        });
      } else {
        // No real Width option on this product at all — there's exactly
        // one real SKU, so declaredWidths can't be trusted to say which
        // number it actually is (see the widthSplit families above, which
        // declare two). Collapse to a single card labeled with the family's
        // fixed defaultWidth instead — the physical width that one SKU
        // actually ships in — rather than guessing from declaredWidths or
        // omitting the width entirely. Still gated by the anatomical
        // allowlist: the card only renders at all if at least one of the
        // family's declared widths would be appropriate for this breed
        // category.
        var eligible = declaredWidths.some(function (width) {
          return isWidthAllowedForCategory(width, opts.breedCategory, family.type, recNeckSize);
        });
        widths = eligible ? [family.defaultWidth || null] : [];
      }
      widths.forEach(function (width) {
        // Only collar/harness carry a breed-derived size at all — every
        // family declared in PRODUCT_FAMILIES today is one or the other,
        // but this stays type-driven rather than an implicit fallback so
        // any future non-sized family added here gets no size badge/
        // fit-range instead of silently inheriting recChestSize.
        var size = null, fitRangeLabel = "";
        if (family.type === "collar") { size = recNeckSize; fitRangeLabel = neckRangeLabel; }
        else if (family.type === "harness") { size = recChestSize; fitRangeLabel = chestRangeLabel; }
        var variant = productData ? resolveVariant(productData, { size: size, width: width }) : null;

        var note = "";
        if (family.type === "collar" && opts.isPuppy) {
          note = PUPPY_COLLAR_DISCLAIMER[opts.breedCategory] || "";
        } else if (family.type === "harness" && opts.isPuppy) {
          note = PUPPY_HARNESS_DISCLAIMER;
        }

        cards.push({
          familyKey: key,
          width: width,
          // Item 5 — the real Shopify product.title, verbatim, no synthetic
          // " — 3cm" width suffix appended (that measurement already has
          // its own home in widthLabel below and in the WHAT'S INCLUDED
          // spec row — see cardMarkup/bundlePairMarkup).
          title: referenceProduct.title,
          widthLabel: (TYPE_LABELS[family.type] || family.type.toUpperCase()) + (width ? " — " + width.toUpperCase() : ""),
          url: referenceProduct.url,
          size: size,
          fitRangeLabel: fitRangeLabel,
          variant: variant,
          note: note,
          differentiator: familyDifferentiator(key, width)
        });
      });
    });
    return cards;
  };

  // First color (in LEATHERS order) that the merchant actually mapped a
  // product to for this family — used only to source color-independent
  // display copy (title/description/url) when the currently selected
  // leather itself has no product for this family.
  function firstMappedProduct(colorMap) {
    for (var i = 0; i < LEATHERS.length; i++) {
      if (colorMap[LEATHERS[i].key]) return colorMap[LEATHERS[i].key];
    }
    return null;
  }

  function capitalizeFirst(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // cardKey is the same familyKey+"|"+width identity cartAdded/wireProductCards
  // already key off — pulled into one helper now that upsellTier state needs
  // the identical key.
  function cardKey(c) { return c.familyKey + "|" + (c.width || ""); }

  // DOM-legal id fragment for this card's tier radio group name — "|" and
  // "." (both possible in a cardKey) aren't legal unescaped in a `name`
  // attribute value the way this template builds them.
  function idSafe(key) { return key.replace(/[^a-zA-Z0-9]/g, "-"); }

  // ---- Screen 3 global accordion (OTHER FITS WORTH CONSIDERING) ----
  // The per-card accordions this helper originally also built (WHAT'S
  // INCLUDED / LEASH STYLE) were retired by the segmented-configurator
  // refactor — a pixel audit against four candidate layouts showed the
  // segmented card is 37-39% shorter than the accordion card expanded and
  // still 6-12% shorter than it fully collapsed (see
  // segmentedConfigMarkup below). The screen-level cross-sell section is
  // the one remaining accordion: it's global (below every card), optional
  // by definition, and collapsing it costs no purchase-path information.
  //
  // `id` must be unique within the results screen — it becomes the
  // data-accordion value, the aria-controls target, and the key
  // this.state.accordionOpen persists open/closed state under.
  // grid-template-rows: 0fr → 1fr (see CSS) is what lets the panel animate
  // to its own real content height with no JS scrollHeight measurement and
  // no page jump, however tall the panel's content turns out to be.
  LillebjornFitFinder.prototype.accordionMarkup = function (id, labelHtml, innerHtml) {
    var isOpen = !!this.state.accordionOpen[id];
    var panelId = "lb-ff-acc-panel-" + idSafe(id);
    return (
      '<div class="lb-ff__accordion" data-accordion="' + escapeHtml(id) + '" data-open="' + isOpen + '">' +
      '  <button type="button" class="lb-ff__accordion-toggle" data-accordion-toggle aria-expanded="' + isOpen + '" aria-controls="' + panelId + '">' +
           labelHtml +
      '    <svg class="lb-ff__accordion-chevron" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '  </button>' +
      '  <div class="lb-ff__accordion-panel" id="' + panelId + '" role="region">' +
      '    <div class="lb-ff__accordion-panel-inner">' + innerHtml + '</div>' +
      '  </div>' +
      '</div>'
    );
  };

  function itemNounForCard(c) {
    var family = PRODUCT_FAMILIES[c.familyKey];
    return family && family.type === "collar" ? "Collar" : "Harness";
  }

  // ---- Step 4 segmented configurator (Concept 2 architecture) ----
  // One decision surface per card: a framed, connected tab group (YOUR
  // SET / LEASH STYLE / DETAILS — hairline-bordered segments, selected
  // one filled solid black with white text) switches a single panel,
  // with the Add to Cart footer directly below it — so switching tabs
  // NEVER displaces the buy button. Chosen over the earlier per-card
  // accordion layout on a pixel audit: 37-39% shorter than that layout
  // expanded, and still 6-12% shorter than it fully collapsed.
  //
  // No separate price row below the panel (removed — the price already
  // lives in the selected tier tile itself, inside the "set" panel, and
  // again on the Add to Cart button's own label right below; a third
  // copy here was pure repetition, not a second source of truth).
  //
  // Tabs render only for facets this card actually has: "set" needs
  // tiers.length > 1 (a lone-tier card has no set choice), "leash" needs
  // the selected tier to resolve a leash, "details" always exists. If
  // the stored segment for this card no longer exists (a tier switch to
  // "single" removes the leash tab out from under a shopper parked on
  // it), fall back to the first available tab rather than rendering an
  // empty panel.
  //
  // .lb-ff__seg-group (not .lb-ff__seg-row) carries role="tablist" — it's
  // the element that directly contains the role="tab" buttons, which is
  // what the tablist/tab ARIA pattern actually requires. .lb-ff__seg-row
  // is just the outer flex row that also holds the "Updated" pill
  // (see flashUpdatedPill) beside the group, right-aligned and visible no
  // matter which segment is active, so the cross-card "leash style
  // changed" confirmation still lands even on a card currently showing a
  // different tab.
  LillebjornFitFinder.prototype.segmentedConfigMarkup = function (key, parts) {
    var segments = [];
    if (parts.tiersHtml) segments.push({ id: "set", label: "YOUR SET" });
    if (parts.leashOptionsHtml) segments.push({ id: "leash", label: "LEASH STYLE" });
    segments.push({ id: "details", label: "DETAILS" });
    var active = this.state.cardSegment[key];
    if (!segments.some(function (s) { return s.id === active; })) active = segments[0].id;
    var panelHtml = active === "set" ? parts.tiersHtml
      : active === "leash" ? parts.leashOptionsHtml
      : parts.detailsHtml;
    return (
      '<div class="lb-ff__seg-row">' +
      '  <div class="lb-ff__seg-group" role="tablist" aria-label="Configure your set">' +
      segments.map(function (s) {
        var isActive = s.id === active;
        return '<button type="button" class="lb-ff__seg" data-card-segment="' + s.id + '" role="tab" aria-selected="' + isActive + '" data-active="' + isActive + '">' + s.label + '</button>';
      }).join("") +
      '  </div>' +
      '  <span class="lb-ff__updated-pill" data-updated-pill><span class="lb-ff__updated-pill-inner"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3.2L13 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg> Updated</span></span>' +
      '</div>' +
      '<div class="lb-ff__seg-panel" role="tabpanel">' + panelHtml + '</div>'
    );
  };

  // Builds the tier list a given main card can actually offer, in cents
  // throughout (see money()'s own contract). "single" is always present
  // when the card itself has a real variant. The upsell tier is chosen by
  // s.selectionId, and there is at most ONE of them — never both — per
  // the mutual-exclusivity rule explained where UPSELL_DISCOUNT_RATE_DEFAULT is
  // declared:
  //   - selectionId === "bundle": "bundle" (Collar + Harness + Leash),
  //     requiring a resolvable partner card (see findBundlePartnerCard) AND
  //     a resolvable leash.
  //   - any other selectionId ("collar" or "harness" alone): "walkkit"
  //     (this item + Leash), requiring only a resolvable leash.
  // Either one missing degrades gracefully to the plain "single" tier
  // rather than rendering a half-priced, half-broken option.
  LillebjornFitFinder.prototype.buildUpsellTiers = function (c, upsell) {
    var discountRate = this.bundleDiscountRate;
    var mainCents = c.variant ? c.variant.price : null;
    if (mainCents == null) {
      lbffDiag("buildUpsellTiers: bailing immediately — this card has no main variant at all (UNAVAILABLE card), so no tiers of any kind can be offered", { familyKey: c.familyKey, size: c.size });
      return [];
    }
    var leash = resolveLeashForCard(c, upsell, this.state.leashStyle);
    var leashCents = leash ? leash.variant.price : null;
    var isBundlePath = upsell.selectionId === "bundle";

    var partner = isBundlePath ? findBundlePartnerCard(c, upsell.allCards) : null;
    var partnerCents = (partner && partner.variant) ? partner.variant.price : null;

    var canWalkKit = !isBundlePath && leashCents != null;
    var canBundle = isBundlePath && leashCents != null && partnerCents != null;

    // This is the single log to check FIRST when a tier is missing — shows
    // exactly which gate is false, rather than re-deriving it from the
    // resolveLeashForCard logs above by hand every time.
    lbffDiag("buildUpsellTiers: tier eligibility summary", {
      familyKey: c.familyKey,
      size: c.size,
      category: (PRODUCT_FAMILIES[c.familyKey] || {}).type,
      selectionId: upsell.selectionId,
      mainVariantId: c.variant ? c.variant.id : null,
      leashResolved: !!leash,
      resolvedLeashVariantId: leash ? leash.variant.id : null,
      bundlePartnerFamilyKey: partner ? partner.familyKey : null,
      bundlePartnerVariantId: partner ? partner.variant.id : null,
      canWalkKit: canWalkKit,
      canBundle: canBundle
    });

    var tiers = [{ key: "single", label: "Just the " + itemNounForCard(c), priceCents: mainCents }];

    if (canWalkKit) {
      var walkKitSetCents = mainCents + leashCents;
      var walkKitCents = Math.round(walkKitSetCents * (1 - discountRate));
      tiers.push({
        key: "walkkit",
        label: "Walk Kit — Your Dog's Complete Fit",
        priceCents: walkKitCents,
        compareCents: walkKitSetCents,
        savingsCents: walkKitSetCents - walkKitCents,
        badge: "SAVE " + Math.round(discountRate * 100) + "%",
        // Item 2 — badge parity: every discounted set gets the same "★ BEST
        // VALUE" treatment as Complete Bundle, not just it. Safe against
        // ever double-showing two hero tiles side by side: walkkit and
        // bundle are mutually exclusive within a single tiers array (see
        // canWalkKit/canBundle above, gated by isBundlePath), so exactly one
        // of them — alongside "single" — is ever actually on screen here.
        isHero: true,
        // Exposed so cardMarkup can render the width-transparency note
        // (friction point 3) without re-resolving the leash a second time.
        leashWidth: leash.width
      });
    }
    if (canBundle) {
      var bundleSetCents = mainCents + partnerCents + leashCents;
      var bundleCents = Math.round(bundleSetCents * (1 - discountRate));
      tiers.push({
        key: "bundle",
        label: "Complete Bundle — Fully Equipped",
        priceCents: bundleCents,
        compareCents: bundleSetCents,
        savingsCents: bundleSetCents - bundleCents,
        badge: "SAVE " + Math.round(discountRate * 100) + "%",
        isHero: true,
        leashWidth: leash.width
      });
    }
    return tiers;
  };

  /* ============================================================
     Collar & Harness Bundle entry point — ONE consolidated card
     ------------------------------------------------------------
     Fix for the "two separate result cards, each with its own duplicate
     Complete Bundle tile" bug: when selectionId === "bundle", the collar
     card's own buildUpsellTiers call above and the harness card's own call
     each independently offered a "Complete Bundle" tier (collar + harness +
     leash), since each card only knows about ITSELF plus whatever
     findBundlePartnerCard finds — nothing stopped both from rendering that
     same set side by side. Real fix is architectural, not a copy tweak:
     stop rendering the harness card as its own sibling card at all in this
     one flow, and instead fold it into ONE card per collar option (see
     renderScreen3's bundle-pair branch and bundlePairMarkup below), with
     exactly two tiers:
       - "base"   — Collar + Harness only, no leash, no discount (there is
         no real Shopify product or Automatic Discount for this exact pair
         without a leash — see UPSELL_DISCOUNT_RATE_DEFAULT's own comment — so this
         is a plain undiscounted sum of the two real component prices).
       - "bundle" — adds a Leash at 10% off the full three-item set, same
         discount math as the single-card path above.
     A dog with more than one eligible MAIN collar choice (e.g. "standard"
     category recommends both Aeris Classic and Vero Classic — see
     RECOMMENDATION_RULES) still gets one consolidated card PER collar
     option, each paired with the SAME shared harness — that mirrors how
     multiple collar cards already coexist outside the bundle flow, rather
     than arbitrarily picking just one collar to pair.
     ============================================================ */

  // Leash width is derived from the HARNESS card's own resolved size, not
  // the collar's — every real Harness Walk Kit description checked (e.g.
  // "the back-clip Vero Harness and a Omni hands-free leash") pairs the
  // leash with the harness's own back-clip, not the collar. Documented here
  // as a judgment call: the catalog doesn't have a real "collar + harness +
  // leash, no discount" product to confirm this against directly the way
  // the Walk Kit pattern was confirmed, but it's the more anatomically
  // grounded choice of the two cards' sizes.
  LillebjornFitFinder.prototype.buildBundlePairTiers = function (collarCard, harnessCard, upsell) {
    var discountRate = this.bundleDiscountRate;
    var collarCents = collarCard.variant ? collarCard.variant.price : null;
    var harnessCents = harnessCard.variant ? harnessCard.variant.price : null;
    if (collarCents == null || harnessCents == null) {
      lbffDiag("buildBundlePairTiers: bailing — collar or harness has no variant at all (UNAVAILABLE)", { collarFamilyKey: collarCard.familyKey, collarVariantId: collarCard.variant ? collarCard.variant.id : null, harnessVariantId: harnessCard.variant ? harnessCard.variant.id : null });
      return [];
    }
    var baseCents = collarCents + harnessCents;
    var tiers = [{ key: "base", label: "Just the Collar & Harness", priceCents: baseCents }];

    var leash = resolveLeashForCard(harnessCard, upsell, this.state.leashStyle);
    var leashCents = leash ? leash.variant.price : null;
    lbffDiag("buildBundlePairTiers: tier eligibility", { collarFamilyKey: collarCard.familyKey, harnessSize: harnessCard.size, leashResolved: !!leash, canBundle: leashCents != null });
    if (leashCents != null) {
      var bundleSetCents = baseCents + leashCents;
      var bundleCents = Math.round(bundleSetCents * (1 - discountRate));
      tiers.push({
        key: "bundle",
        label: "Complete Bundle — Fully Equipped",
        priceCents: bundleCents,
        compareCents: bundleSetCents,
        savingsCents: bundleSetCents - bundleCents,
        badge: "SAVE " + Math.round(discountRate * 100) + "%",
        isHero: true,
        leashWidth: leash.width
      });
    }
    return tiers;
  };

  // Mirrors buildBundleItems' contract exactly (one atomic /cart/add.js
  // items array, "properties" informational only) but for a fixed PAIR of
  // main items instead of one main item + an optional partner lookup.
  LillebjornFitFinder.prototype.buildBundlePairItems = function (collarCard, harnessCard, upsell, tier) {
    var items = [
      { id: collarCard.variant.id, quantity: 1, properties: { "Set": "Collar & Harness" } },
      { id: harnessCard.variant.id, quantity: 1, properties: { "Set": "Collar & Harness" } }
    ];
    if (tier !== "bundle") return items;
    var leash = resolveLeashForCard(harnessCard, upsell, this.state.leashStyle);
    if (!leash) return items; // stock vanished under the shopper — degrade to the base pair rather than send a broken request
    items[0].properties["Set"] = "Complete Bundle (10% off set)";
    items[1].properties["Set"] = "Complete Bundle (10% off set)";
    items.push({ id: leash.variant.id, quantity: 1, properties: { "Set": "Complete Bundle (10% off set)", "Leash width": leash.width, "Leash style": leash.style } });
    return items;
  };

  // One consolidated card for the Collar & Harness Bundle entry point — see
  // the file comment above. Deliberately a SEPARATE function from
  // cardMarkup (not a branch inside it): the two render fundamentally
  // different things (one main item vs. a fixed pair), and keeping them
  // apart means every other entry point (Collar, Harness, Walk Kit) is
  // provably untouched by this change.
  LillebjornFitFinder.prototype.bundlePairMarkup = function (collarCard, harnessCard, upsell, showLeather) {
    upsell = upsell || {};
    // Deliberately the SAME key addToCart derives from the DOM
    // (data-family + "|" + data-width, both set to the collar's own
    // identity below) — no "|pair" suffix. addToCart has no way to know
    // this card is a pair; it reads data-family/data-width straight off
    // the [data-card] element and writes this.state.cartAdded under that
    // exact key. A suffixed key here would silently never match, so
    // "ADDED ✓" would never show after a real successful add.
    var key = cardKey(collarCard);
    var added = !!this.state.cartAdded[key];
    var baseImg = collarCard.variant && collarCard.variant.image ? collarCard.variant.image : "";

    var tiers = this.buildBundlePairTiers(collarCard, harnessCard, upsell);
    var selectedTierKey = this.state.upsellTier[key];
    if (!selectedTierKey || !tiers.some(function (t) { return t.key === selectedTierKey; })) {
      selectedTierKey = tiers.length > 1 ? tiers[tiers.length - 1].key : "base";
    }
    var selectedTier = tiers.filter(function (t) { return t.key === selectedTierKey; })[0] || tiers[0];

    // Item 5 — the real catalog title for the "bundle" tier comes from
    // the SAME matched real Shopify product as its photo (see
    // resolveKitAsset) — never a synthesized "Brand Complete Bundle in
    // Color" string. "base" tier (no real "collar + harness only" product
    // exists) has no kit asset to resolve (resolveKitAsset's own tierKey
    // gate returns null for anything other than "walkkit"/"bundle") and
    // correctly falls back to the collar's own real product.title.
    var kitAsset = resolveKitAsset(collarCard, upsell, selectedTierKey === "bundle" ? "bundle" : "", this.state.leashStyle);
    var displayTitle = (kitAsset && kitAsset.title) || collarCard.title;
    var eyebrow = selectedTierKey === "bundle" ? "COMPLETE BUNDLE" : "COLLAR & HARNESS BUNDLE";
    // Add to Cart button gets its own, shorter, category label — "COMPLETE
    // BUNDLE"/"COLLAR & HARNESS BUNDLE" (the eyebrow above) reads fine as a
    // small pill but is too long for the button itself (see
    // cartCtaLabelHtml's own comment).
    var ctaCategoryLabel = selectedTierKey === "bundle" ? "BUNDLE" : "COLLAR & HARNESS";

    // "bundle" tier has a real Complete Bundle product (see kitAsset
    // above) — the whole card links straight to it, same as any other
    // real product card. "base" (collar + harness, no leash) has no real
    // Shopify PDP for that exact pair at all (see buildBundlePairTiers'
    // own comment) — falling back to the collar's own solo product page
    // here would send someone who chose "the pair" to a page selling
    // only half of it, so this stays "" rather than a misleading link.
    // addToCart/buildBundlePairItems already add BOTH real line items
    // regardless of tier, so the pair stays fully purchasable either way
    // — this only withholds the "view product page" affordance for the
    // one tier with no real page to show.
    var cardUrl = selectedTierKey === "bundle"
      ? ((kitAsset && kitAsset.productUrl) || variantUrl(collarCard))
      : "";

    // "bundle" tier reuses the exact same real studio photography (and,
    // as of the kitAsset lookup above, title) as the single-card Complete
    // Bundle tier — same real product, same photo, whenever the kit
    // collection scan actually matched one for this color/style/width
    // (kitAsset.url is the truthiness check, same rule as everywhere else
    // this lookup is used). "base" tier, or a "bundle" tier the scan
    // didn't match, has no single real photo of the two items together —
    // see splitImgHtml below for what shows instead.
    var kitImg = kitAsset && kitAsset.url;
    var harnessImg = harnessCard.variant && harnessCard.variant.image ? harnessCard.variant.image : "";

    // No real combined studio shot exists for this exact pair outside a
    // matched kit product (see kitImg above) — rather than silently
    // falling back to just the collar's own solo photo (which used to
    // make the harness invisible on the card and, combined with the card
    // no longer being clickable at all, read as "why does this only show
    // half of what I'm buying"), show BOTH real per-item photos side by
    // side. Never a fabricated "together" shot — each half is exactly the
    // same real photo cardMarkup would show for that item on its own.
    var splitImgHtml =
      '<div class="lb-ff__card-img lb-ff__card-img--split">' +
      (baseImg ? '<img class="lb-ff__card-photo" src="' + escapeHtml(baseImg) + '" alt="" loading="lazy">' : '') +
      (harnessImg ? '<img class="lb-ff__card-photo" src="' + escapeHtml(harnessImg) + '" alt="" loading="lazy">' : '') +
      '</div>';
    var imgHtml = kitImg
      ? '<div class="lb-ff__card-img"><img class="lb-ff__card-photo" src="' + escapeHtml(kitImg) + '" alt="" loading="lazy"></div>'
      : splitImgHtml;

    // ---- WHAT'S INCLUDED: the one place spec info lives on this card ----
    var includedRowHtml =
      '<span class="lb-ff__spec-chip"><span class="lb-ff__spec-k">Collar</span><span class="lb-ff__spec-v">' + escapeHtml(collarCard.size) + (collarCard.width ? ' · ' + escapeHtml(collarCard.width) : '') + '</span></span>' +
      '<span class="lb-ff__spec-chip"><span class="lb-ff__spec-k">Harness</span><span class="lb-ff__spec-v">' + escapeHtml(harnessCard.size) + '</span></span>' +
      (selectedTier && selectedTier.leashWidth ? '<span class="lb-ff__spec-chip"><span class="lb-ff__spec-k">Leash</span><span class="lb-ff__spec-v">' + escapeHtml(selectedTier.leashWidth) + ' · ' + escapeHtml(this.state.leashStyle) + '</span></span>' : '');

    var collarFitId = "lb-ff-fit-collar-" + idSafe(key);
    var harnessFitId = "lb-ff-fit-harness-" + idSafe(key);
    var fitLinesHtml =
      (collarCard.fitRangeLabel ? (
        '<span class="lb-ff__fit-line">' + escapeHtml(collarCard.fitRangeLabel) +
        '<button type="button" class="lb-ff__info-btn" data-tooltip-trigger data-tooltip-text="Matched to your dog’s neck measurement (' + escapeHtml(collarCard.size) + ') for a secure, comfortable fit." aria-expanded="false" id="' + collarFitId + '">' +
        '<span aria-hidden="true">ⓘ</span><span class="lb-ff__sr-only">Why this collar size</span>' +
        '</button></span>'
      ) : '') +
      (harnessCard.fitRangeLabel ? (
        '<span class="lb-ff__fit-line">' + escapeHtml(harnessCard.fitRangeLabel) +
        '<button type="button" class="lb-ff__info-btn" data-tooltip-trigger data-tooltip-text="Matched to your dog’s chest measurement (' + escapeHtml(harnessCard.size) + ') — distributes pressure evenly across the chest and sternum." aria-expanded="false" id="' + harnessFitId + '">' +
        '<span aria-hidden="true">ⓘ</span><span class="lb-ff__sr-only">Why this harness size</span>' +
        '</button></span>'
      ) : '');

    var tiersHtml = tiers.length > 1 ? (
      // .lb-ff__set-selection (alongside the existing data-upsell
      // attribute other code already keys off) is the named scroll target
      // the sticky recap bar's "VIEW OFFER" button and the progress-rail
      // offer marker both resolve against — see scrollToOfferBtn's handler
      // and updateProgressRail below.
      '<div class="lb-ff__upsell lb-ff__set-selection" data-upsell>' +
      tiers.map(function (t) {
        var isSel = t.key === selectedTierKey;
        var radioName = "lb-ff-tier-" + idSafe(key);
        // Item 1 — hero tile gets a "★ BEST VALUE" eyebrow; any tier with
        // NO discount gets a "STANDARD PRICE" pill in the exact same spot
        // a SAVE badge would sit, so both tiles read as the same kind of
        // thing (a priced option), one just costs less.
        var heroEyebrowHtml = t.isHero ? '<span class="lb-ff__hero-eyebrow">★ BEST VALUE</span>' : '';
        var priceBadgeHtml = t.badge ? '<span class="lb-ff__upsell-savebadge">' + t.badge + '</span>' : '<span class="lb-ff__upsell-tier-neutraltag">STANDARD PRICE</span>';
        // Item 3 — micro-copy cleanup: drop "not combinable with promo
        // codes", keep the checkout-limitation disclosure itself, inline
        // on the tile so it's visible before the shopper selects anything.
        // "+ Free Custom Name Tag" gated on t.key === "bundle" explicitly
        // (this markup's only tiers are "base"/no-badge and "bundle"/
        // badge, so t.badge alone happens to be equivalent here — but
        // written the same explicit way as cardMarkup's identical line so
        // the rule ("this perk belongs to the 3-item Complete Bundle,
        // never a 2-item set") can't silently drift if a badged-but-not-
        // "bundle" tier is ever added to this pair markup too).
        var disclosureHtml = t.badge
          ? '<span class="lb-ff__tier-disclosure-inline">Auto-applied at checkout' + (t.key === "bundle" ? ' · + Free Custom Name Tag' : '') + '</span>'
          : '';
        return (
          '<label class="lb-ff__upsell-tier' + (t.isHero ? ' lb-ff__upsell-tier--hero' : '') + '" data-tier-tile data-selected="' + isSel + '">' +
               heroEyebrowHtml +
          '  <input type="radio" name="' + radioName + '" value="' + t.key + '" data-upsell-tier' + (isSel ? ' checked' : '') + '>' +
          '  <span class="lb-ff__upsell-tier-copy">' +
          '    <span class="lb-ff__upsell-tier-name">' + escapeHtml(t.label) + '</span>' +
                 disclosureHtml +
          '  </span>' +
          '  <span class="lb-ff__upsell-tier-price">' +
                 (t.compareCents ? '<span class="lb-ff__price-compare">' + money(t.compareCents, this.moneyFormat) + '</span>' : '') +
          '    <span class="lb-ff__upsell-tier-now">' + money(t.priceCents, this.moneyFormat) + '</span>' +
                 priceBadgeHtml +
          '  </span>' +
          '</label>'
        );
      }, this).join("") +
      '</div>'
    ) : '';

    // ---- Leash selector (Option B — typographic, no icon) ----
    var leashOptionsHtml = (selectedTier && selectedTier.leashWidth) ? (
      '<div class="lb-ff__leash-options" role="group" aria-label="Leash style">' +
           LEASH_STYLE_OPTIONS.map(function (style) {
             var active = this.state.leashStyle === style;
             return (
               '<button type="button" class="lb-ff__leash-opt-b" data-leash-style="' + style + '" data-selected="' + active + '" aria-pressed="' + active + '">' +
               '<span class="lb-ff__leash-inner">' +
               '<span class="lb-ff__leash-ring" aria-hidden="true"></span>' +
               '<span class="lb-ff__leash-copy">' +
               '<span class="lb-ff__leash-name-row">' +
               '<span class="lb-ff__leash-serif">' + escapeHtml(LEASH_STYLE_DISPLAY_NAME[style] || style) + '</span>' +
               '<span class="lb-ff__leash-sub">' + escapeHtml(LEASH_STYLE_SUBTITLE[style]) + '</span>' +
               '</span>' +
               '<span class="lb-ff__leash-desc">' + escapeHtml(LEASH_STYLE_DESCRIPTIONS[style]) + '</span>' +
               '</span>' +
               '</span>' +
               '</button>'
             );
           }, this).join("") +
      '</div>'
    ) : '';

    // Segmented configurator — tiers, leash, and the spec/fit details
    // each live in one switchable panel with the selected tier's price
    // pinned below it; see segmentedConfigMarkup for the architecture
    // rationale.
    var detailsHtml =
      '<div class="lb-ff__included-row">' + includedRowHtml + '</div>' +
      (fitLinesHtml ? '<div class="lb-ff__fit-lines">' + fitLinesHtml + '</div>' : '');
    var segHtml = this.segmentedConfigMarkup(key, {
      tiersHtml: tiersHtml,
      leashOptionsHtml: leashOptionsHtml,
      detailsHtml: detailsHtml
    });

// Item 2 — out-of-stock degrades to an ACTIVE prompt back to the
    // (shared, already-existing) leather swatch row instead of a dead
    // disabled button. Only the post-add cosmetic-lock window disables
    // the button now; being out of stock no longer does, since that state
    // needs to stay clickable for the redirect to work at all.
    var bothAvailable = !!(collarCard.variant && harnessCard.variant);
    var outOfStock = !bothAvailable;
    var readyLabelHtml = cartCtaLabelHtml(ctaCategoryLabel, selectedTier ? money(selectedTier.priceCents, this.moneyFormat) : "");
    var addLabel = added ? "ADDED ✓" : (outOfStock ? "TRY ANOTHER COLOR →" : readyLabelHtml);
    var addBtnClass = "lb-ff__card-add" + (outOfStock && !added ? " lb-ff__card-add--outline" : "");
    var addBtnAttrs = outOfStock ? "data-try-another-color" : ('data-add-to-cart data-tier="' + selectedTierKey + '" data-ready-label="' + escapeHtml(readyLabelHtml) + '"');
    var stockHintHtml = (outOfStock && !added) ? '<p class="lb-ff__card-stock-hint">' + escapeHtml(capitalizeFirst(String(upsell.selectedLeather || ""))) + ' isn’t available as a set in this size right now.</p>' : '';
    var secureNoteHtml = outOfStock ? '' : '<p class="lb-ff__card-secure-note">' + CART_LOCK_ICON_SVG + '<span>Secure checkout · major cards &amp; digital wallets accepted</span></p>';

    // See the identical comment on cardMarkup's own leatherBlockHtml — same
    // reasoning applies here (first pair card only, nested inside
    // card-body rather than as a sibling of .lb-ff__card-img).
    var leatherBlockHtml = showLeather ? (
      '<div class="lb-ff__leather">' +
      '  <div class="lb-ff__leather-label">LEATHER</div>' +
      '  <div class="lb-ff__leather-row">' + (upsell.leatherSwatchesHtml || "") + '</div>' +
      '</div>'
    ) : '';

    return (
      '<div class="lb-ff__card-group" data-pair="true">' +
      '  <div class="lb-ff__card" data-card' +
           (cardUrl ? ' tabindex="0" role="link" aria-label="View ' + escapeHtml(displayTitle) + ' — opens in a new tab"' : '') +
           ' data-family="' + collarCard.familyKey + '" data-width="' + (collarCard.width || '') + '" data-url="' + escapeHtml(cardUrl) + '">' +
           imgHtml +
      '    <div class="lb-ff__card-body">' +
           leatherBlockHtml +
      '      <div class="lb-ff__card-eyebrow">' + eyebrow + '</div>' +
      '      <div class="lb-ff__card-name">' + escapeHtml(displayTitle) + '</div>' +
           segHtml +
      '      <div class="lb-ff__card-footer">' +
           stockHintHtml +
      '        <div class="lb-ff__card-actions">' +
      '          <button type="button" class="' + addBtnClass + '" ' + addBtnAttrs + ' data-added="' + added + '"' + (added ? ' disabled' : '') + '>' +
               addLabel +
      '          </button>' +
      '          <a href="/cart" target="_blank" rel="noopener" class="lb-ff__card-viewcart" data-view-cart' + (added ? '' : ' hidden') + '>View Cart →</a>' +
      '        </div>' +
           secureNoteHtml +
      '      </div>' +
      '      <div class="lb-ff__card-error" data-cart-error role="alert" hidden></div>' +
      '    </div>' +
      '  </div>' +
      '</div>'
    );
  };

  LillebjornFitFinder.prototype.cardMarkup = function (c, upsell, showLeather) {
    upsell = upsell || {};
    var key = cardKey(c);
    var added = !!this.state.cartAdded[key];
    var baseImg = c.variant && c.variant.image ? c.variant.image : "";
    var noun = itemNounForCard(c);

    var tiers = this.buildUpsellTiers(c, upsell);
    var selectedTierKey = this.state.upsellTier[key];
    // Nothing chosen yet, OR a leather swap since the last choice dropped
    // stock out from under the previously chosen tier (e.g. this color has
    // no leash mapped) — in either case, fall back to the richest tier
    // still actually on offer rather than rendering a selection that no
    // longer exists.
    if (!selectedTierKey || !tiers.some(function (t) { return t.key === selectedTierKey; })) {
      // Exactly one upsell tier is ever possible per card now (walkkit XOR
      // bundle, never both — see buildUpsellTiers), so there's no "richest
      // of several" tier to choose between here the way there used to be:
      // whichever one exists (if any) is simply the default.
      selectedTierKey = tiers.length > 1 ? tiers[tiers.length - 1].key : "single";
    }
    var selectedTier = tiers.filter(function (t) { return t.key === selectedTierKey; })[0] || tiers[0];

    // Item 5 — for "walkkit"/"bundle", the real catalog title comes from
    // the SAME matched real Shopify product as its photo (see
    // resolveKitAsset) — never a synthesized "Brand Walk Kit in Color"
    // string. "single" has no kit asset to resolve (resolveKitAsset's own
    // tierKey gate returns null for anything other than
    // "walkkit"/"bundle") and correctly falls back to this card's own
    // real product.title.
    var kitAsset = resolveKitAsset(c, upsell, selectedTierKey, this.state.leashStyle);
    var displayTitle = (kitAsset && kitAsset.title) || c.title;
    var eyebrow = selectedTierKey === "walkkit" ? "WALK KIT" : noun.toUpperCase();

    // Card's own click-through target, tier-aware: "walkkit"/"bundle"
    // link to the matched real kit product's own PDP (see resolveKitAsset
    // / lillebjorn-kit-collection-scan.liquid's productUrl) rather than
    // always pointing at this card's single item regardless of which set
    // is selected. That kit product has no client-known variant id (the
    // collection scan intentionally stops at url/title/productUrl, not a
    // full variants array — see that snippet's own comment on why),  so it
    // links to the kit's page without a variant preselected. "single", or
    // any tier whose kit photo/product wasn't matched, falls back to this
    // card's own product+variant — never a dead link.
    var cardUrl = (selectedTierKey === "walkkit" || selectedTierKey === "bundle") && kitAsset && kitAsset.productUrl
      ? kitAsset.productUrl
      : variantUrl(c);

    // Real pre-composed studio photography (and, as of the kitAsset lookup
    // above, title) for Walk Kit/Bundle — see resolveKitAsset. Falls back
    // to this card's own plain single-item photo the instant that
    // specific (tier, item type, color, STYLE) shot hasn't been mapped
    // yet, rather than an empty/broken <img>. Style is part of the lookup
    // (friction point 2): switching Classic/Hands Free re-renders every
    // card (see refreshAllCards) with a freshly resolved photo/title for
    // whichever style is now active.
    var img = (kitAsset && kitAsset.url) || baseImg;

    // ---- WHAT'S INCLUDED: the one place spec info lives on this card.
    // Previously this same information (width, size, leash width/style)
    // was spread across the top width-label row, the meta badge row, and
    // a note buried inside the tier tile — a shopper had to piece all
    // three together to know what they were actually buying. ----
    var includedRowHtml =
      '<span class="lb-ff__spec-chip"><span class="lb-ff__spec-k">' + escapeHtml(noun) + '</span><span class="lb-ff__spec-v">' + escapeHtml(c.size) + (c.width ? ' · ' + escapeHtml(c.width) : '') + '</span></span>' +
      (selectedTier && selectedTier.leashWidth ? '<span class="lb-ff__spec-chip"><span class="lb-ff__spec-k">Leash</span><span class="lb-ff__spec-v">' + escapeHtml(selectedTier.leashWidth) + ' · ' + escapeHtml(this.state.leashStyle) + '</span></span>' : '');

    var fitId = "lb-ff-fit-" + idSafe(key);
    var fitLinesHtml = c.fitRangeLabel ? (
      '<span class="lb-ff__fit-line">' + escapeHtml(c.fitRangeLabel) +
      '<button type="button" class="lb-ff__info-btn" data-tooltip-trigger data-tooltip-text="Matched to your dog’s ' + escapeHtml(noun.toLowerCase()) + ' measurement (' + escapeHtml(c.size) + ') for a secure, comfortable fit." aria-expanded="false" id="' + fitId + '">' +
      '<span aria-hidden="true">ⓘ</span><span class="lb-ff__sr-only">Why this size</span>' +
      '</button></span>'
    ) : '';

    var tiersHtml = tiers.length > 1 ? (
      // .lb-ff__set-selection (alongside the existing data-upsell
      // attribute other code already keys off) is the named scroll target
      // the sticky recap bar's "VIEW OFFER" button and the progress-rail
      // offer marker both resolve against — see scrollToOfferBtn's handler
      // and updateProgressRail below.
      '<div class="lb-ff__upsell lb-ff__set-selection" data-upsell>' +
      tiers.map(function (t) {
        var isSel = t.key === selectedTierKey;
        var radioName = "lb-ff-tier-" + idSafe(key);
        // Item 1 — hero tile gets a "★ BEST VALUE" eyebrow; any tier with
        // NO discount gets a "STANDARD PRICE" pill in the exact same spot
        // a SAVE badge would sit, so both tiles read as the same kind of
        // thing (a priced option), one just costs less.
        var heroEyebrowHtml = t.isHero ? '<span class="lb-ff__hero-eyebrow">★ BEST VALUE</span>' : '';
        var priceBadgeHtml = t.badge ? '<span class="lb-ff__upsell-savebadge">' + t.badge + '</span>' : '<span class="lb-ff__upsell-tier-neutraltag">STANDARD PRICE</span>';
        // Item 3 — micro-copy cleanup: drop "not combinable with promo
        // codes", keep the checkout-limitation disclosure itself, inline
        // on the tile so it's visible before the shopper selects anything.
        // "+ Free Custom Name Tag" is gated on t.key === "bundle" SPECIFICALLY,
        // not on t.badge/discounted-ness in general — "walkkit" here is
        // ALSO badged (discounted) but is only a 2-item set (this card's
        // item + Leash, no partner item), and the free name tag is a
        // perk of the 3-item Complete Bundle only. Using t.badge alone
        // previously leaked this line onto Walk Kit tiles too.
        var disclosureHtml = t.badge
          ? '<span class="lb-ff__tier-disclosure-inline">Auto-applied at checkout' + (t.key === "bundle" ? ' · + Free Custom Name Tag' : '') + '</span>'
          : '';
        return (
          '<label class="lb-ff__upsell-tier' + (t.isHero ? ' lb-ff__upsell-tier--hero' : '') + '" data-tier-tile data-selected="' + isSel + '">' +
               heroEyebrowHtml +
          '  <input type="radio" name="' + radioName + '" value="' + t.key + '" data-upsell-tier' + (isSel ? ' checked' : '') + '>' +
          '  <span class="lb-ff__upsell-tier-copy">' +
          '    <span class="lb-ff__upsell-tier-name">' + escapeHtml(t.label) + '</span>' +
                 disclosureHtml +
          '  </span>' +
          '  <span class="lb-ff__upsell-tier-price">' +
                 (t.compareCents ? '<span class="lb-ff__price-compare">' + money(t.compareCents, this.moneyFormat) + '</span>' : '') +
          '    <span class="lb-ff__upsell-tier-now">' + money(t.priceCents, this.moneyFormat) + '</span>' +
                 priceBadgeHtml +
          '  </span>' +
          '</label>'
        );
      }, this).join("") +
      '</div>'
    ) : '';

    // ---- Leash selector (Option B — typographic, no icon). Replaces the
    // old two-segment button toggle (a single caption swapping under
    // whichever segment was active) — this shows BOTH styles' names and
    // descriptions at once so a shopper compares before choosing instead
    // of having to click one to learn what the other even is. ----
    var leashOptionsHtml = (selectedTier && selectedTier.leashWidth) ? (
      '<div class="lb-ff__leash-options" role="group" aria-label="Leash style">' +
           LEASH_STYLE_OPTIONS.map(function (style) {
             var active = this.state.leashStyle === style;
             return (
               '<button type="button" class="lb-ff__leash-opt-b" data-leash-style="' + style + '" data-selected="' + active + '" aria-pressed="' + active + '">' +
               '<span class="lb-ff__leash-inner">' +
               '<span class="lb-ff__leash-ring" aria-hidden="true"></span>' +
               '<span class="lb-ff__leash-copy">' +
               '<span class="lb-ff__leash-name-row">' +
               '<span class="lb-ff__leash-serif">' + escapeHtml(LEASH_STYLE_DISPLAY_NAME[style] || style) + '</span>' +
               '<span class="lb-ff__leash-sub">' + escapeHtml(LEASH_STYLE_SUBTITLE[style]) + '</span>' +
               '</span>' +
               '<span class="lb-ff__leash-desc">' + escapeHtml(LEASH_STYLE_DESCRIPTIONS[style]) + '</span>' +
               '</span>' +
               '</span>' +
               '</button>'
             );
           }, this).join("") +
      '</div>'
    ) : '';

    // Segmented configurator — see segmentedConfigMarkup for the
    // architecture rationale. "single" carries no set choice and no
    // leash, so its tab row degrades to DETAILS alone.
    var detailsHtml =
      '<div class="lb-ff__included-row">' + includedRowHtml + '</div>' +
      (fitLinesHtml ? '<div class="lb-ff__fit-lines">' + fitLinesHtml + '</div>' : '');
    var segHtml = this.segmentedConfigMarkup(key, {
      tiersHtml: tiersHtml,
      leashOptionsHtml: leashOptionsHtml,
      detailsHtml: detailsHtml
    });

// Item 2 — out-of-stock degrades to an ACTIVE prompt back to the
    // leather swatch row instead of a dead disabled button. Only the
    // post-add cosmetic-lock window disables the button now; being out of
    // stock no longer does, since that state needs to stay clickable for
    // the redirect to work at all.
    var outOfStock = !c.variant;
    // Reuses `eyebrow` (COLLAR / HARNESS / WALK KIT) as the button's short
    // category label — the same category logic Size Guide's own eyebrow
    // uses — rather than `displayTitle`'s full Shopify product title (see
    // cartCtaLabelHtml's own comment on why).
    var readyLabelHtml = cartCtaLabelHtml(eyebrow, selectedTier ? money(selectedTier.priceCents, this.moneyFormat) : "");
    var addLabel = added ? "ADDED ✓" : (outOfStock ? "TRY ANOTHER COLOR →" : readyLabelHtml);
    var addBtnClass = "lb-ff__card-add" + (outOfStock && !added ? " lb-ff__card-add--outline" : "");
    var addBtnAttrs = outOfStock ? "data-try-another-color" : ('data-add-to-cart data-tier="' + selectedTierKey + '" data-ready-label="' + escapeHtml(readyLabelHtml) + '"');
    var stockHintHtml = (outOfStock && !added) ? '<p class="lb-ff__card-stock-hint">' + escapeHtml(capitalizeFirst(String(upsell.selectedLeather || ""))) + ' isn’t available in this size right now.</p>' : '';
    var secureNoteHtml = outOfStock ? '' : '<p class="lb-ff__card-secure-note">' + CART_LOCK_ICON_SVG + '<span>Secure checkout · major cards &amp; digital wallets accepted</span></p>';

    // Rendered as the first thing inside .lb-ff__card-body — after the
    // photo, before the eyebrow/name — only when showLeather is true (see
    // the caller in renderScreen3: the first rendered card only, since
    // selectedLeather is shared state and this control shouldn't repeat
    // across every card on screen). Nested inside card-body rather than as
    // a sibling of .lb-ff__card-img so the row-layout @container rule
    // (which assumes exactly image + body as .lb-ff__card's two children —
    // see the tablet-crop fix on .lb-ff__card-img) stays untouched.
    var cardDifferentiatorHtml = c.differentiator ? '<p class="lb-ff__card-differentiator">' + escapeHtml(c.differentiator) + '</p>' : '';
    var leatherBlockHtml = showLeather ? (
      '<div class="lb-ff__leather">' +
      '  <div class="lb-ff__leather-label">LEATHER</div>' +
      '  <div class="lb-ff__leather-row">' + (upsell.leatherSwatchesHtml || "") + '</div>' +
      '</div>'
    ) : '';

    // The card is a <div>, not a real <a> — a role="link" ARIA widget on a
    // div doesn't create the "interactive-inside-interactive" HTML validity
    // problem a real nested <a><button> would, so the Add to Cart <button>
    // below stays fully valid while the whole card is still keyboard-
    // reachable and screen-reader-announced as "View {title}" (see the
    // keydown handling wired in wireProductCards).
    return (
      '<div class="lb-ff__card-group">' +
      '  <div class="lb-ff__card" data-card' +
           (cardUrl ? ' tabindex="0" role="link" aria-label="View ' + escapeHtml(displayTitle) + ' — opens in a new tab"' : '') +
           ' data-family="' + c.familyKey + '" data-width="' + (c.width || '') + '" data-url="' + escapeHtml(cardUrl) + '">' +
           // A real <img> here (not a fixed-ratio background-image div) is
           // deliberate: these photos mix portrait crops (harness) and
           // landscape ones (collar), and only letting the box take the
           // photo's own intrinsic size — instead of forcing every photo
           // into one fixed shape — can show the complete image with
           // neither cropping nor letterboxing, at any width. alt is
           // intentionally empty: the card's own aria-label above already
           // announces "View {title}", so a second announcement here would
           // just be duplicate noise for screen-reader users.
      '    <div class="lb-ff__card-img">' +
           (img ? '<img class="lb-ff__card-photo" src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
      '    </div>' +
      '    <div class="lb-ff__card-body">' +
           leatherBlockHtml +
      '      <div class="lb-ff__card-eyebrow">' + eyebrow + '</div>' +
      '      <div class="lb-ff__card-name">' + escapeHtml(displayTitle) + '</div>' +
           cardDifferentiatorHtml +
           segHtml +
      '      <div class="lb-ff__card-footer">' +
           stockHintHtml +
      '        <div class="lb-ff__card-actions">' +
      '          <button type="button" class="' + addBtnClass + '" ' + addBtnAttrs + ' data-added="' + added + '"' + (added ? ' disabled' : '') + '>' +
               addLabel +
      '          </button>' +
                // Hidden by default — addToCart() reveals this on a
                // successful add as a theme-independent confirmation, since
                // a dispatched cart-refresh event has no guarantee any given
                // theme's cart drawer is actually listening for it.
      '          <a href="/cart" target="_blank" rel="noopener" class="lb-ff__card-viewcart" data-view-cart' + (added ? '' : ' hidden') + '>View Cart →</a>' +
      '        </div>' +
           secureNoteHtml +
      '      </div>' +
                // Populated by addToCart()'s catch handler only — an
                // assertive live region so a failed add is actually
                // announced to screen-reader users, not just a silent
                // button-text swap.
      '      <div class="lb-ff__card-error" data-cart-error role="alert" hidden></div>' +
      '    </div>' +
      '  </div>' +
      (c.note ? '  <p class="lb-ff__card-note">' + escapeHtml(c.note) + '</p>' : '') +
      '</div>'
    );
  };

  LillebjornFitFinder.prototype.crossSellMarkup = function (c) {
    var img = c.variant && c.variant.image ? c.variant.image : "";
    var price = c.variant ? money(c.variant.price, this.moneyFormat) : "—";
    var cardUrl = variantUrl(c);
    return (
      '<div class="lb-ff__cs-card" data-card' +
           (cardUrl ? ' tabindex="0" role="link" aria-label="View ' + escapeHtml(c.title) + ' — opens in a new tab"' : '') +
           ' data-family="' + c.familyKey + '" data-width="' + (c.width || '') + '" data-url="' + escapeHtml(cardUrl) + '">' +
      '  <div class="lb-ff__cs-img" style="' + (img ? "background-image:url('" + img + "')" : '') + '"></div>' +
      '  <div class="lb-ff__cs-body">' +
      '    <div class="lb-ff__cs-width">' + c.widthLabel + '</div>' +
      '    <div class="lb-ff__cs-name">' + escapeHtml(c.title) + '</div>' +
      '    <div class="lb-ff__cs-price">' + price + '</div>' +
      '  </div>' +
      '</div>'
    );
  };

  /* 2 (cont). Clean redirection + 3. AJAX cart integration */

  // Closes every OPEN info tooltip under listEl except (optionally) one —
  // module-level and re-queried from listEl (the whole product list, not
  // just one card) each call so it keeps working correctly regardless of
  // which single card most recently got torn down/replaced by a tier
  // switch (see wireSingleCard's own [data-upsell-tier] handler below).
  /* ============================================================
     Shared smart-positioned tooltip
     ------------------------------------------------------------
     Replaces the old per-trigger CSS hover/focus tooltip
     (.lb-ff__info / .lb-ff__info-tooltip / .lb-ff__info--open / the
     removed closeAllTooltips): that tooltip was a DESCENDANT of the card
     it explained, absolutely positioned against a small ancestor (the
     leash-width one anchored to a tiny icon-sized wrapper with a fixed
     220px width, growing leftward) — on a narrow card there simply isn't
     220px of room to its left, so it rendered partly outside the drawer's
     own left edge. No amount of retuning that CSS fixes it structurally:
     an element positioned relative to a small ancestor has no way to know
     the REAL viewport edges.

     This version is ONE shared element, created once and reused, always
     appended to document.body (never .lb-ff__drawer or .lb-ff__content:
     the drawer carries its own open/close transform, and any transformed
     ancestor creates a new containing block for position:fixed — the
     JS's viewport-relative getBoundingClientRect() math would then be
     positioning against the drawer's box instead of the viewport,
     silently misplacing the tooltip off-screen. body has no such
     ancestor). Position is computed fresh from the trigger's real
     getBoundingClientRect() every time it opens: centered under the
     trigger, flipped above it if there isn't room below, and clamped so
     it can never extend past either viewport edge. It literally cannot be
     clipped by an ancestor's overflow, because it isn't a descendant of
     any card at all by the time it's visible.
     ============================================================ */
  var lbffTooltipOpenTrigger = null;
  // Whether the CURRENTLY open tooltip was "pinned" by a click/tap, as
  // opposed to merely being previewed by hover or keyboard focus. Hover-
  // opened tooltips auto-dismiss on mouseout (standard tooltip behavior);
  // pinned ones only close via another click/tap on the same trigger, a
  // click elsewhere, Escape, or scroll/resize. This is what lets hover AND
  // click coexist without fighting each other — see the click handler in
  // wireTooltipDelegation for why that fight existed before this flag.
  var lbffTooltipPinned = false;
  var lbffTooltipGlobalWired = false;

  function lbffTooltipHost() {
    return document.body;
  }

  function ensureTooltipEl(hostEl) {
    var el = hostEl.querySelector("[data-lb-ff-tooltip]");
    if (!el) {
      el = document.createElement("div");
      // "lb-ff" (not just "lb-ff__tooltip") for the same reason
      // .lb-ff__drawer carries it too after being reparented to body (see
      // that class's own CSS comment): every --lbff-* custom property
      // (background, text, border colors) is defined scoped under .lb-ff,
      // nowhere near document.body — without this class here, every
      // var(--lbff-*) below falls through to nothing, background silently
      // becomes transparent, and text falls back to whatever color it
      // happens to inherit. That's exactly what looked like "hover does
      // nothing" on desktop (transparent tooltip is easy to miss against
      // a busy card) and "transparent background" on mobile (same cause,
      // more obvious there because the text overlaps card content behind
      // it) — both the same missing-scope bug, not two separate ones.
      el.className = "lb-ff__tooltip lb-ff";
      el.setAttribute("data-lb-ff-tooltip", "");
      el.setAttribute("role", "tooltip");
      // Stable id — this ONE shared element gets reused by every trigger
      // on the page, so aria-describedby (set/cleared per open/close in
      // showSharedTooltip/hideSharedTooltip) always has a real target to
      // point at, the same way the old per-trigger tooltip's own unique id
      // did before this replaced it.
      el.id = "lb-ff-shared-tooltip";
      hostEl.appendChild(el);
    }
    return el;
  }

  function positionTooltip(tooltipEl, triggerEl) {
    var rect = triggerEl.getBoundingClientRect();
    tooltipEl.style.left = "0px";
    tooltipEl.style.top = "0px";
    tooltipEl.setAttribute("data-visible", "true");
    var tw = tooltipEl.offsetWidth, th = tooltipEl.offsetHeight;
    var vw = window.innerWidth, vh = window.innerHeight;
    var placeAbove = rect.top - th - 10 > 8;
    var top = placeAbove ? rect.top - th - 8 : rect.bottom + 8;
    var left = rect.left + rect.width / 2 - tw / 2;
    left = Math.max(8, Math.min(left, vw - tw - 8));
    top = Math.max(8, Math.min(top, vh - th - 8));
    tooltipEl.style.left = left + "px";
    tooltipEl.style.top = top + "px";
  }

  function hideSharedTooltip() {
    if (!lbffTooltipOpenTrigger) return;
    var hostEl = lbffTooltipHost(lbffTooltipOpenTrigger);
    var tooltipEl = hostEl.querySelector("[data-lb-ff-tooltip]");
    if (tooltipEl) tooltipEl.setAttribute("data-visible", "false");
    lbffTooltipOpenTrigger.setAttribute("aria-expanded", "false");
    lbffTooltipOpenTrigger.removeAttribute("aria-describedby");
    lbffTooltipOpenTrigger = null;
    lbffTooltipPinned = false;
  }

  // Document/window-level listeners only need attaching once, the first
  // time any tooltip is ever shown — lazy rather than wired in
  // connectedCallback so this whole subsystem stays fully self-contained.
  function ensureTooltipGlobalListeners() {
    if (lbffTooltipGlobalWired) return;
    lbffTooltipGlobalWired = true;
    document.addEventListener("click", function (e) {
      if (lbffTooltipOpenTrigger && !e.target.closest("[data-tooltip-trigger]")) hideSharedTooltip();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") hideSharedTooltip();
    });
    // capture:true — .lb-ff__content's own internal scroll doesn't bubble
    // a "scroll" event to window, but capture-phase listeners still see
    // it fire on the way down regardless of target, so this is the one
    // reliable way to catch "the drawer's content just scrolled" from here.
    window.addEventListener("scroll", function () { hideSharedTooltip(); }, true);
    window.addEventListener("resize", function () { hideSharedTooltip(); });
  }

  function showSharedTooltip(triggerEl, pinned) {
    ensureTooltipGlobalListeners();
    var hostEl = lbffTooltipHost(triggerEl);
    var tooltipEl = ensureTooltipEl(hostEl);
    tooltipEl.textContent = triggerEl.getAttribute("data-tooltip-text") || "";
    positionTooltip(tooltipEl, triggerEl);
    lbffTooltipOpenTrigger = triggerEl;
    lbffTooltipPinned = !!pinned;
    triggerEl.setAttribute("aria-expanded", "true");
    triggerEl.setAttribute("aria-describedby", tooltipEl.id);
  }

  // Item 1 — replaces the old wireTooltipTriggers, which re-queried
  // [data-tooltip-trigger] and attached a fresh set of listeners to every
  // trigger inside a card group each time that group was wired — correct
  // right after each render, but silently orphaned the instant a card
  // group was torn down and rebuilt without that exact call being re-run
  // from every new call site. A single delegated listener set on the
  // drawer itself (see connectedCallback) has no such gap: since it's
  // never a descendant of anything replaceCardGroup/replaceBundlePairGroup/
  // refreshAllCards ever swap out, it keeps matching every trigger on
  // every card, present now or rendered later, with no per-card wiring
  // step required at all.
  //
  // click is bound in the CAPTURE phase deliberately: [data-card]'s own
  // click-to-open-product-page handler is attached directly to the card
  // element, which sits BETWEEN the trigger and this drawer-level listener
  // in the bubble chain — a bubble-phase delegated listener here would
  // only run after that handler already fired and opened a new tab.
  // Capture runs top-down before any bubble-phase listener on a
  // descendant gets a chance to, so stopPropagation here reliably stops
  // the click from ever reaching the card's own handler.
  function wireTooltipDelegation(containerEl) {
    if (containerEl.__lbffTooltipDelegated) return;
    containerEl.__lbffTooltipDelegated = true;
    ensureTooltipGlobalListeners();

    // click always PINS rather than unconditionally toggling closed. A
    // plain "click on the already-open trigger closes it" rule (the old
    // behavior) fights real-mouse hover: hovering opens the tooltip
    // unpinned, and an extremely natural next move — clicking the ⓘ you're
    // already hovering — would then immediately slam it shut on the very
    // click that revealed it, reading as "hover is broken." Splitting
    // "open" from "pinned open" fixes that: a click on a trigger that's
    // only open via hover/focus PINS it (first real intent signal), and
    // only a SECOND click while already pinned closes it. On a touch
    // device (see hasRealHover below) mouseover never fires at all, so
    // every open only ever happens via this click handler and is pinned
    // from the very first tap — a second tap on the same trigger closes
    // it, i.e. plain tap-to-toggle, unaffected by any of this.
    containerEl.addEventListener("click", function (e) {
      var trigger = e.target.closest && e.target.closest("[data-tooltip-trigger]");
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      if (lbffTooltipOpenTrigger === trigger) {
        if (lbffTooltipPinned) { hideSharedTooltip(); } else { lbffTooltipPinned = true; }
        return;
      }
      showSharedTooltip(trigger, true);
    }, true);

    // Real hover only (hover:hover + pointer:fine — i.e. an actual mouse).
    // Touch browsers synthesize a mouseover for the tapped element
    // immediately BEFORE the click event on a first tap — without this
    // guard, that synthetic mouseover would open the tooltip via
    // showSharedTooltip, and the click handler above would then see
    // lbffTooltipOpenTrigger already === trigger and pin it instead of
    // opening it fresh, which is harmless on its own, but real touch
    // devices have no hover state to preview in the first place — this
    // guard keeps them on the simpler tap-to-toggle path entirely.
    var hasRealHover = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    // mouseover/mouseout (not mouseenter/mouseleave, which never bubble
    // and so can't be delegated at all) relatedTarget-checked against the
    // trigger so a mouse move between the trigger's own descendant nodes
    // (icon <span> <-> button) doesn't flicker the tooltip open/closed.
    if (hasRealHover) {
      containerEl.addEventListener("mouseover", function (e) {
        var trigger = e.target.closest && e.target.closest("[data-tooltip-trigger]");
        if (!trigger || (e.relatedTarget && trigger.contains(e.relatedTarget))) return;
        // Already open (via this same hover, or pinned by an earlier
        // click) — leave it exactly as it is rather than re-opening it
        // unpinned, which would let a stray mouseover un-pin a click-
        // pinned tooltip out from under the shopper.
        if (lbffTooltipOpenTrigger === trigger) return;
        showSharedTooltip(trigger, false);
      });
      containerEl.addEventListener("mouseout", function (e) {
        var trigger = e.target.closest && e.target.closest("[data-tooltip-trigger]");
        if (!trigger || (e.relatedTarget && trigger.contains(e.relatedTarget))) return;
        // Pinned (opened, or confirmed, by a click) tooltips only close
        // via another click, a click elsewhere, Escape, or scroll/resize
        // — the mouse merely leaving must never dismiss one.
        if (lbffTooltipPinned) return;
        hideSharedTooltip();
      });
    }

    // focusin/focusout (unlike focus/blur) DO bubble, so these two need no
    // capture trick — keyboard nav into/out of a trigger anywhere in the
    // drawer is caught here regardless of which card it lives on. Same
    // "don't reopen/close a pinned tooltip out from under an unrelated
    // event" guards as the hover pair above.
    containerEl.addEventListener("focusin", function (e) {
      var trigger = e.target.closest && e.target.closest("[data-tooltip-trigger]");
      if (trigger && lbffTooltipOpenTrigger !== trigger) showSharedTooltip(trigger, false);
    });
    containerEl.addEventListener("focusout", function (e) {
      var trigger = e.target.closest && e.target.closest("[data-tooltip-trigger]");
      if (trigger && !lbffTooltipPinned) hideSharedTooltip();
    });
  }

  // Item 4 — confirms a shared-state change (the leash style toggle
  // affects every visible card, not just the one clicked). Replaces an
  // earlier bottom-of-drawer toast that depended on counting visible
  // cards and walking up to .lb-ff__drawer — it never actually appeared
  // live. This version is unconditional (fires every time, on every
  // screen, regardless of how many cards are on screen) and inline right
  // next to the control that changed, so there's no separate positioning
  // or DOM-traversal logic left to get wrong.
  function flashUpdatedPill(group) {
    var pill = group.querySelector("[data-updated-pill]");
    if (!pill) return;
    pill.classList.remove("lb-ff__updated-pill--show");
    void pill.offsetWidth;
    pill.classList.add("lb-ff__updated-pill--show");
    setTimeout(function () { pill.classList.remove("lb-ff__updated-pill--show"); }, 2200);
  }

  // Item 2 — shared by wireSingleCard's and wireSingleBundlePairCard's own
  // [data-try-another-color] handlers: scrolls the ALREADY-EXISTING shared
  // leather swatch row into view and pulses it once, rather than each out-
  // of-stock card duplicating its own swatch picker.
  function scrollToLeatherSwatches(listEl) {
    var swatchRow = listEl.querySelector(".lb-ff__leather-row");
    if (!swatchRow) return;
    swatchRow.scrollIntoView({ behavior: "smooth", block: "center" });
    // Restart the animation even on a second click in a row — removing the
    // class, forcing layout, then re-adding it is the standard way to
    // reset a CSS animation that's still (or already finished) running.
    swatchRow.classList.remove("lb-ff__leather-row--pulse");
    void swatchRow.offsetWidth;
    swatchRow.classList.add("lb-ff__leather-row--pulse");
    setTimeout(function () { swatchRow.classList.remove("lb-ff__leather-row--pulse"); }, 2000);
  }

  // Shared by wireProductCards (initial wiring) and refreshAllCards (the
  // leash-style toggle's re-render) — reads a card-group's own
  // data-family/data-width attributes and looks up the matching entry in
  // `cards`, rather than each caller re-deriving that lookup its own way.
  function cardDataForGroup(group, cards) {
    var cardEl = group.querySelector("[data-card]");
    if (!cardEl) return null;
    var familyKey = cardEl.getAttribute("data-family");
    var width = cardEl.getAttribute("data-width");
    return cards.filter(function (c) { return c.familyKey === familyKey && (c.width || "") === width; })[0] || null;
  }

  LillebjornFitFinder.prototype.wireProductCards = function (el, cards, upsell) {
    var self = this;
    upsell = upsell || {};
    el.querySelectorAll(".lb-ff__card-group").forEach(function (group) {
      // Consolidated Collar & Harness Bundle cards (data-pair="true", see
      // bundlePairMarkup) are wired separately by wireBundlePairCards —
      // skip here so this generic path never double-wires the same
      // [data-add-to-cart]/[data-upsell-tier] elements with the WRONG
      // (single-item) handlers.
      if (group.getAttribute("data-pair") === "true") return;
      var cardData = cardDataForGroup(group, cards);
      if (cardData) self.wireSingleCard(el, group, cardData, cards, upsell);
    });
  };

  // Re-renders and re-wires EVERY main card currently on screen, in place —
  // used only by the leash-style toggle (see wireSingleCard's own
  // [data-leash-style] handler below), because this.state.leashStyle is
  // shared, global state (one style choice per shopper session, the same
  // way this.state.selectedLeather already is), not a per-card value the
  // way this.state.upsellTier is. Patching only the ONE card the shopper
  // clicked would leave every sibling card silently showing a price for a
  // leash style it's no longer actually resolving against — this loop is
  // what keeps every visible card's price/photo consistent with the single
  // shared style choice, while still avoiding a full self.render() teardown
  // of the leather row/verdict header/support footer around them.
  LillebjornFitFinder.prototype.refreshAllCards = function (listEl, cards, upsell) {
    var self = this;
    listEl.querySelectorAll(".lb-ff__card-group").forEach(function (group) {
      if (group.getAttribute("data-pair") === "true") {
        var collarCardData = cardDataForGroup(group, cards);
        var harnessCardData = cards.filter(function (c) { return (PRODUCT_FAMILIES[c.familyKey] || {}).type === "harness"; })[0];
        if (collarCardData && harnessCardData) self.replaceBundlePairGroup(listEl, group, collarCardData, harnessCardData, upsell);
        return;
      }
      var cardData = cardDataForGroup(group, cards);
      if (!cardData) return;
      self.replaceCardGroup(listEl, group, cardData, cards, upsell);
    });
  };

  // Layout-shift fix (Step 4 "CHOOSE YOUR SET"): switching tiers on a card
  // can add/remove a whole LEASH STYLE block (only tiers with a leash —
  // walkkit/bundle — render one, see cardMarkup's/bundlePairMarkup's own
  // leashSectionHtml), which used to change this card-group's height with
  // no transition at all — group.replaceWith(freshGroup) is an atomic DOM
  // swap, so the old and new heights just snapped between each other,
  // yanking everything below (the rest of this card's own CTA, every
  // sibling card, the footer) up or down in a single reflow tick.
  //
  // This is a FLIP (First-Last-Invert-Play) height animation around that
  // same swap: measure the stale card's real rendered height BEFORE
  // removing it, do the swap exactly as before, then pin the fresh card at
  // the OLD height for one frame and transition it to its own natural
  // height. Deliberately height-only and content-agnostic — it doesn't
  // care WHY the height changed (leash section, a longer/shorter tier
  // price string, a re-wrapped title), so it stays correct if any of that
  // markup changes later. No-ops (leaves the already-correct end state
  // alone) under prefers-reduced-motion, when the stale node had no
  // measurable height yet (first paint), or when the height didn't
  // actually change.
  //
  // IMPORTANT which element this pins/animates: cardMarkup/bundlePairMarkup
  // both render `<div class="lb-ff__card-group"> <div class="lb-ff__card">
  // ...all the real content... </div> </div>` — .lb-ff__card-group is a
  // bare `display:flex; flex-direction:column` wrapper with no border/
  // shadow/background of its own; every visible pixel of "the card"
  // (border, hover shadow, rounded corners) belongs to the INNER
  // .lb-ff__card. An earlier version of this fix pinned height/overflow on
  // the OUTER .lb-ff__card-group instead — which doesn't stretch its child
  // to match (column-flex only stretches the CROSS axis, i.e. width, not
  // height), so .lb-ff__card kept rendering at its own full natural height
  // regardless and simply got hard-clipped by the wrapper's overflow:hidden
  // boundary. On every GROWING swap that clipped the real card's bottom
  // border/shadow/rounded corners off entirely at the old (shorter) height,
  // then peeled them back into view as the wrapper grew — reading as a
  // shudder/jitter on the card itself rather than a smooth resize, on every
  // card, not just later ones (confirmed identical on the very first card
  // too — bisecting "which card" was never the actual variable). Pinning
  // the INNER .lb-ff__card instead means the thing with the border IS the
  // thing being clipped/resized, so what's revealed each frame is exactly
  // this card's own real content growing into view — no seam, no separate
  // box to desync from it. The outer .lb-ff__card-group needs no height of
  // its own at all: as a column-flex wrapper around a single child, it
  // already tracks that child's height automatically every frame for free.
  function animateGroupHeightSwap(group, freshGroup) {
    var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var staleCard = group.querySelector(".lb-ff__card") || group;
    var startHeight = staleCard.getBoundingClientRect().height;
    group.replaceWith(freshGroup);
    if (prefersReducedMotion || !startHeight) return;
    var freshCard = freshGroup.querySelector(".lb-ff__card") || freshGroup;
    var endHeight = freshCard.getBoundingClientRect().height;
    if (Math.abs(endHeight - startHeight) < 1) return;
    freshCard.style.height = startHeight + "px";
    freshCard.style.overflow = "hidden";
    // Force a layout flush while still pinned at startHeight, so the very
    // first paint of the fresh card shows the OLD height, not a flash of
    // its full natural height before the transition below kicks in.
    void freshCard.offsetHeight;
    freshCard.style.transition = "height 0.32s cubic-bezier(0.22, 1, 0.36, 1)";
    var cleanup = function () {
      freshCard.style.transition = "";
      freshCard.style.height = "";
      freshCard.style.overflow = "";
      freshCard.removeEventListener("transitionend", onTransitionEnd);
    };
    var onTransitionEnd = function (e) {
      if (e.target === freshCard && e.propertyName === "height") cleanup();
    };
    freshCard.addEventListener("transitionend", onTransitionEnd);
    // Belt-and-suspenders: if this exact node gets swapped out again (a
    // rapid second tier click) before transitionend ever fires, there's
    // nothing left to clean up — removeEventListener above is a no-op on a
    // detached node, and the timeout below simply finds inline styles that
    // no longer matter to anything still on screen.
    setTimeout(cleanup, 400);
    requestAnimationFrame(function () {
      freshCard.style.height = endHeight + "px";
    });
  }

  // Rebuilds one card's markup via cardMarkup (a fresh <img src="...">
  // among it) and swaps it in for the stale group, then re-wires the new
  // node — shared by the per-card tier switch and the cross-card leash-
  // style refresh above, so there is exactly one place that performs this
  // swap rather than two copies that could drift apart.
  LillebjornFitFinder.prototype.replaceCardGroup = function (listEl, group, cardData, cards, upsell) {
    // Whether the STALE group being replaced is the first card in
    // [data-product-cards] — not whether cardData itself is "cards[0]" —
    // since this same function replaces one card in isolation (a tier
    // switch on that one card) as well as every card in turn (the
    // leash-style refresh loop in refreshAllCards). Checking the live DOM
    // position is what keeps the leather picker exactly where it started
    // (first card only) through either path.
    var showLeather = group.parentElement && group.parentElement.firstElementChild === group;
    var freshHtml = this.cardMarkup(cardData, upsell, showLeather);
    var temp = document.createElement("div");
    temp.innerHTML = freshHtml;
    var freshGroup = temp.firstElementChild;
    animateGroupHeightSwap(group, freshGroup);
    this.wireSingleCard(listEl, freshGroup, cardData, cards, upsell);
  };

  // Wires ONE card's group (image/tiers/Add to Cart/info) in isolation.
  // Split out from wireProductCards so a tier switch (see the
  // [data-upsell-tier] "change" handler below) can re-render and re-wire
  // just THIS card — swapping its photo/price/Add-to-Cart label in place —
  // instead of tearing down and rebuilding the whole results screen the
  // way a leather swap still does. That matters here specifically because
  // the photo swap between tiers is the actual point of this interaction;
  // a full self.render() would still show the right photo, but as a
  // flash-rebuild of the entire screen (losing scroll position, closing
  // every other card's open tooltip, restarting the image's own transition)
  // rather than a contained swap on the one card the shopper is looking at.
  LillebjornFitFinder.prototype.wireSingleCard = function (listEl, group, cardData, cards, upsell) {
    var self = this;
    var cardEl = group.querySelector("[data-card]");

    function openCard() {
      var url = cardEl.getAttribute("data-url");
      if (url) window.open(url, "_blank", "noopener");
    }
    cardEl.addEventListener("click", function () { openCard(); });
    cardEl.addEventListener("keydown", function (e) {
      // The Add to Cart button, View Cart link, info/tooltip trigger, and
      // upsell tier radios are all real focusable controls nested inside
      // this card and handle their own Enter/Space activation — this
      // keydown still bubbles up to the card from them, so it must bail
      // out here, or a single Enter press on any of them would also pop
      // open a second tab.
      if (e.target.closest("[data-add-to-cart], [data-view-cart], [data-tooltip-trigger], [data-tier-tile], [data-leash-style], [data-card-segment]")) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openCard();
      }
    });

    // stopPropagation is wired on the [data-tier-tile] LABEL, not the radio
    // input itself: the input is visually a 1x1px, opacity:0 box (see the
    // CSS), so every real click actually lands on the label or the text
    // spans inside it — the browser's own label-click forwarding is what
    // still toggles the radio from there. A click event dispatched at the
    // input by that forwarding never happens; the raw click bubbles from
    // whatever visible child was actually tapped, straight past the input,
    // so intercepting only the input here would have left every tile
    // click still reaching the card's own click handler and popping the
    // product page open in a new tab underneath the tier picker.
    // Segment tabs (YOUR SET / LEASH STYLE / DETAILS) — same blur-before-
    // replace discipline as the tier radios below (this button's own
    // .lb-ff__card-group is removed while focused otherwise), and
    // stopPropagation so a tab tap never bubbles to the card's
    // click-to-open-PDP handler. replaceCardGroup's FLIP height animation
    // (see animateGroupHeightSwap) smooths the small panel-height delta
    // between segments.
    group.querySelectorAll("[data-card-segment]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var seg = btn.getAttribute("data-card-segment");
        var segKey = cardKey(cardData);
        if (self.state.cardSegment[segKey] === seg) return;
        btn.blur();
        self.state.cardSegment[segKey] = seg;
        self.replaceCardGroup(listEl, group, cardData, cards, upsell);
        self.updateProgressRail();
      });
    });

    group.querySelectorAll("[data-tier-tile]").forEach(function (tile) {
      tile.addEventListener("click", function (e) { e.stopPropagation(); });
    });
    group.querySelectorAll("[data-upsell-tier]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        var key = cardData.familyKey + "|" + (cardData.width || "");
        self.state.upsellTier[key] = radio.value;
        // Targeted swap: re-render just this one card's markup (a fresh
        // <img src="..."> for the newly selected tier's photo among it) —
        // every other card and the leather row are left completely alone.
        //
        // blur() alone (no scrollTop snapshot/restore — see below for why
        // not): this radio is the element that just received focus from
        // the native label-click that checked it, and replaceCardGroup
        // removes this radio's own .lb-ff__card-group from the DOM (via
        // animateGroupHeightSwap's group.replaceWith) while it's still
        // focused. Removing a focused element is what triggers the
        // browser's own focus-loss rescue — an abrupt, ARBITRARY scrollTop
        // snap unrelated to this card's own height change at all (observed
        // as a jump to some unrelated position). Blurring first hands focus
        // back to <body> under OUR control before the node is actually
        // removed, so there's nothing left for the browser to "rescue" the
        // scroll position over.
        //
        // Deliberately NOT pairing this with a savedScrollTop restore the
        // way the [data-leash-style] handler below does: that handler
        // swaps EVERY card at once with no height transition, so its old
        // scrollTop is still valid content-wise and worth restoring
        // verbatim. Here, animateGroupHeightSwap's own height transition
        // continuously changes .lb-ff__content's real scrollHeight over
        // ~320ms — on a SHRINKING swap the old scrollTop can end up past
        // the new (shorter) max entirely. A one-shot "set it back to the
        // old value" fights the browser's own natural, animation-frame-
        // synced clamping with a competing, unsynced write, which is what
        // actually produced a visible extra snap/slide on top of the
        // height transition (verified: removing this restore removes that
        // snap). Left alone, the browser clamps scrollTop smoothly on the
        // exact same frames that drive the height transition itself —
        // already in lockstep, nothing else needed.
        radio.blur();
        self.replaceCardGroup(listEl, group, cardData, cards, upsell);
        // A leash section can appear/disappear with the tier switch,
        // changing .lb-ff__content's total scrollHeight — re-measure the
        // rail so its fill percentage still reflects the real scrollable
        // range rather than the one from before this swap.
        self.updateProgressRail();
      });
    });

    // Leash style selector (Classic / Omni Hands Free) — only rendered on tiers
    // that include a leash (see cardMarkup's leashSectionHtml). Unlike the
    // tier radio above, this.state.leashStyle is SHARED, global state (one
    // choice per shopper, same as this.state.selectedLeather), so its
    // handler refreshes every visible card via refreshAllCards rather than
    // just this one — see that method's own comment for why patching only
    // this card would leave siblings showing a stale price. preventDefault
    // + stopPropagation mirror the Add to Cart button's own handling: a
    // real <button> already stops any native label-click forwarding, but
    // the click must still not bubble to the card itself (which would pop
    // the product page open in a new tab).
    group.querySelectorAll("[data-leash-style]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var style = btn.getAttribute("data-leash-style");
        if (style === self.state.leashStyle) return;
        // refreshAllCards below replaces THIS exact button's own
        // .lb-ff__card-group (via replaceCardGroup's group.replaceWith), and
        // it's still focused at that point — removing a focused element from
        // the DOM is what was snapping .lb-ff__content's scroll all the way
        // back to the top on every leash-style switch (a real browser focus-
        // loss/scroll-anchoring quirk, not anything this component did on
        // purpose). Blurring first hands focus back to <body> under OUR
        // control before the node is actually removed, so there's nothing
        // left for the browser to "rescue" the scroll position over.
        btn.blur();
        self.state.leashStyle = style;
        var scrollEl = self._drawerEl && self._drawerEl.querySelector(".lb-ff__content");
        var savedScrollTop = scrollEl ? scrollEl.scrollTop : null;
        self.refreshAllCards(listEl, cards, upsell);
        // Belt-and-suspenders re-assert one frame later too, in case the
        // fresh card's <img> (no reserved width/height until it loads) still
        // causes a late layout shift after this synchronous restore.
        if (scrollEl && savedScrollTop !== null) {
          scrollEl.scrollTop = savedScrollTop;
          requestAnimationFrame(function () { scrollEl.scrollTop = savedScrollTop; });
        }
        self.updateProgressRail();
        // Item 4 — unconditional inline confirmation next to the leash
        // selector that was just clicked (replaces an earlier bottom-of-
        // drawer toast that never actually appeared live — see
        // flashUpdatedPill's own comment). refreshAllCards above already
        // replaced the original `group` node with a fresh one (via
        // replaceCardGroup), so it has to be re-found by the card's own
        // data-family/data-width rather than reused directly.
        var freshCardEl = listEl.querySelector('[data-family="' + cardData.familyKey + '"][data-width="' + (cardData.width || "") + '"]');
        var freshGroup = freshCardEl ? freshCardEl.closest(".lb-ff__card-group") : null;
        if (freshGroup) flashUpdatedPill(freshGroup);
      });
    });

    group.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!cardData.variant) return;
        var tier = btn.getAttribute("data-tier") || "single";
        var items = self.buildBundleItems(cardData, upsell, tier);
        if (!items.length) return;
        self.addToCart(items, btn);
      });
    });

    // Item 2 — out-of-stock's button (see cardMarkup's addBtnAttrs) is
    // this instead of [data-add-to-cart]; scrolls to the shared swatch row
    // rather than attempting an add that can't succeed.
    group.querySelectorAll("[data-try-another-color]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToLeatherSwatches(listEl);
      });
    });

    // Event isolation: "View Cart →" is a real <a> nested inside the
    // [data-card] wrapper, and that wrapper's own click handler (openCard,
    // above) fires on ANY bubbled click — including this anchor's — which
    // was popping the product page open in a second tab at the same time
    // the anchor navigated to /cart. stopPropagation alone (no
    // preventDefault) is deliberate: the anchor's default navigation is the
    // wanted behavior here, target="_blank"/rel="noopener" on the element
    // (see cardMarkup) already routes it to a new tab so the shopper's
    // in-progress fit-finder drawer stays open and untouched in the
    // original one.
    group.querySelectorAll("[data-view-cart]").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    });

    // Item 1 — tooltip triggers inside this group need no wiring call of
    // their own: wireTooltipDelegation (wired once, on the drawer, in
    // connectedCallback) already delegates for every [data-tooltip-trigger]
    // anywhere inside it, this group included.
  };

  // Wires every consolidated Collar & Harness Bundle card (see
  // bundlePairMarkup) — the [data-pair="true"] counterpart to
  // wireProductCards, called separately from renderScreen3's bundle branch
  // since these groups are deliberately skipped by wireProductCards itself.
  LillebjornFitFinder.prototype.wireBundlePairCards = function (el, collarCards, harnessCard, upsell) {
    var self = this;
    el.querySelectorAll('.lb-ff__card-group[data-pair="true"]').forEach(function (group) {
      var collarCardData = cardDataForGroup(group, collarCards);
      if (collarCardData) self.wireSingleBundlePairCard(el, group, collarCardData, harnessCard, upsell);
    });
  };

  LillebjornFitFinder.prototype.replaceBundlePairGroup = function (listEl, group, collarCardData, harnessCard, upsell) {
    // See the identical comment in replaceCardGroup above.
    var showLeather = group.parentElement && group.parentElement.firstElementChild === group;
    var freshHtml = this.bundlePairMarkup(collarCardData, harnessCard, upsell, showLeather);
    var temp = document.createElement("div");
    temp.innerHTML = freshHtml;
    var freshGroup = temp.firstElementChild;
    // See animateGroupHeightSwap's own comment (defined above
    // replaceCardGroup) — same tier-switch layout-shift fix, applied here
    // too since this consolidated pair card has the exact same
    // appearing/disappearing LEASH STYLE block as the single-item path.
    animateGroupHeightSwap(group, freshGroup);
    this.wireSingleBundlePairCard(listEl, freshGroup, collarCardData, harnessCard, upsell);
  };

  // Mirrors wireSingleCard's event wiring exactly, adapted for the fixed
  // (collar, harness) pair instead of one main item (+ an optional
  // separately-looked-up partner). Kept as its own function rather than
  // branching inside wireSingleCard so every existing entry point (Collar,
  // Harness, Walk Kit) stays provably unaffected by this addition.
  LillebjornFitFinder.prototype.wireSingleBundlePairCard = function (listEl, group, collarCardData, harnessCard, upsell) {
    var self = this;
    var cardEl = group.querySelector("[data-card]");

    // Whole-card click-to-PDP, same as wireSingleCard — only ever actually
    // opens anything on the "bundle" tier (see bundlePairMarkup's cardUrl:
    // "base" has no real PDP for this exact pair, so data-url is "" there
    // and this is a no-op, same degrade-quietly rule as every other empty-
    // url card in the file).
    function openCard() {
      var url = cardEl.getAttribute("data-url");
      if (url) window.open(url, "_blank", "noopener");
    }
    cardEl.addEventListener("click", function () { openCard(); });
    cardEl.addEventListener("keydown", function (e) {
      if (e.target.closest("[data-add-to-cart], [data-view-cart], [data-tooltip-trigger], [data-tier-tile], [data-leash-style], [data-card-segment]")) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openCard();
      }
    });

    group.querySelectorAll("[data-tier-tile]").forEach(function (tile) {
      tile.addEventListener("click", function (e) { e.stopPropagation(); });
    });
    // See the identical comment on wireSingleCard's own
    // [data-card-segment] handler.
    group.querySelectorAll("[data-card-segment]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var seg = btn.getAttribute("data-card-segment");
        var segKey = cardKey(collarCardData);
        if (self.state.cardSegment[segKey] === seg) return;
        btn.blur();
        self.state.cardSegment[segKey] = seg;
        self.replaceBundlePairGroup(listEl, group, collarCardData, harnessCard, upsell);
        self.updateProgressRail();
      });
    });

    group.querySelectorAll("[data-upsell-tier]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        var key = cardKey(collarCardData);
        self.state.upsellTier[key] = radio.value;
        // See the identical comment on wireSingleCard's own
        // [data-upsell-tier] handler — blur() alone (this radio is still
        // focused when replaceBundlePairGroup removes its own
        // .lb-ff__card-group from the DOM), deliberately with NO scrollTop
        // snapshot/restore (fights the height transition's own natural,
        // frame-synced scroll clamping on a shrinking swap).
        radio.blur();
        self.replaceBundlePairGroup(listEl, group, collarCardData, harnessCard, upsell);
        self.updateProgressRail();
      });
    });

    group.querySelectorAll("[data-leash-style]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var style = btn.getAttribute("data-leash-style");
        if (style === self.state.leashStyle) return;
        // See wireSingleCard's own [data-leash-style] handler for why this
        // blur + scrollTop snapshot/restore pair exists — refreshAllCards
        // replaces THIS button's own .lb-ff__card-group while it's still
        // focused, which is what was resetting .lb-ff__content's scroll to
        // the top on every leash-style switch.
        btn.blur();
        self.state.leashStyle = style;
        var scrollEl = self._drawerEl && self._drawerEl.querySelector(".lb-ff__content");
        var savedScrollTop = scrollEl ? scrollEl.scrollTop : null;
        self.refreshAllCards(listEl, upsell.allCards, upsell);
        if (scrollEl && savedScrollTop !== null) {
          scrollEl.scrollTop = savedScrollTop;
          requestAnimationFrame(function () { scrollEl.scrollTop = savedScrollTop; });
        }
        self.updateProgressRail();
        // Item 4 — same unconditional inline confirmation as the single-
        // card path (see wireSingleCard's own comment on why this has to
        // be re-found rather than reused after refreshAllCards).
        var freshCardEl = listEl.querySelector('[data-family="' + collarCardData.familyKey + '"][data-width="' + (collarCardData.width || "") + '"]');
        var freshGroup = freshCardEl ? freshCardEl.closest(".lb-ff__card-group") : null;
        if (freshGroup) flashUpdatedPill(freshGroup);
      });
    });

    group.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!collarCardData.variant || !harnessCard.variant) return;
        var tier = btn.getAttribute("data-tier") || "base";
        var items = self.buildBundlePairItems(collarCardData, harnessCard, upsell, tier);
        if (!items.length) return;
        self.addToCart(items, btn);
      });
    });

    group.querySelectorAll("[data-try-another-color]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToLeatherSwatches(listEl);
      });
    });

    group.querySelectorAll("[data-view-cart]").forEach(function (link) {
      link.addEventListener("click", function (e) { e.stopPropagation(); });
    });

    // Item 1 — see wireSingleCard's own comment: wireTooltipDelegation is
    // wired once on the drawer in connectedCallback and already covers
    // every [data-tooltip-trigger] rendered inside this group.
  };

  // The cart drawer's runtime section id is only ever reliably known from
  // the DOM — Shopify wraps every rendered section in
  // <div id="shopify-section-{{ section.id }}"> regardless of whether
  // it's a static `{% section %}` include or a section-group member.
  // Shared by addToCart (to request this section inline in the /cart/add
  // POST) and refreshCartDrawerMarkup (to request it via a follow-up GET
  // if the inline attempt didn't come back with it).
  function resolveCartDrawerSectionId() {
    var liveDrawer = document.querySelector(".cart-drawer__wrapper");
    if (!liveDrawer) return null;
    var sectionHost = liveDrawer.closest('[id^="shopify-section-"]');
    return sectionHost ? sectionHost.id.replace(/^shopify-section-/, "") : null;
  }

  // Turns one main-card + the shopper's chosen tier into the exact
  // /cart/add.js `items` array to POST — every tier is a single atomic
  // request (see addToCart below), never a sequence of separate adds, so
  // there is no window where only some of a bundle lands in the cart.
  // "properties" on each line are informational only (visible on the order
  // and in the cart) — they do NOT themselves cause any discount; the 10%
  // off the Walk Kit/Bundle set comes from a real Shopify Automatic
  // Discount the merchant configures against this exact fixed product list
  // (see the Liquid section's comments), which reads real variant IDs, not
  // line-item properties.
  LillebjornFitFinder.prototype.buildBundleItems = function (cardData, upsell, tier) {
    var items = [{ id: cardData.variant.id, quantity: 1 }];
    if (tier === "single") return items;

    // Re-resolved here (not read off a value cardMarkup computed earlier)
    // so an Add to Cart click always builds against the leash that's
    // actually current for this card/leather/style right now — the same
    // single source of truth buildUpsellTiers uses, never a stale copy.
    var leash = resolveLeashForCard(cardData, upsell, this.state.leashStyle);
    if (!leash) return items; // stock vanished under the shopper — degrade to single rather than send a broken request

    if (tier === "walkkit") {
      items.push({ id: leash.variant.id, quantity: 1, properties: { "Set": "Walk Kit (10% off set)", "Leash width": leash.width, "Leash style": leash.style } });
      return items;
    }

    if (tier === "bundle") {
      // Same re-resolve-fresh rule as the leash above — never trust a
      // value computed at an earlier render.
      var partner = findBundlePartnerCard(cardData, upsell.allCards);
      if (!partner || !partner.variant) return items; // sibling item's stock vanished under the shopper — degrade to single rather than send a broken request
      items.push({ id: partner.variant.id, quantity: 1, properties: { "Set": "Complete Bundle (10% off set)" } });
      items.push({ id: leash.variant.id, quantity: 1, properties: { "Set": "Complete Bundle (10% off set)", "Leash width": leash.width, "Leash style": leash.style } });
      return items;
    }

    return items;
  };

  LillebjornFitFinder.prototype.addToCart = function (items, btn) {
    var self = this;
    var card = btn.closest("[data-card]");
    var key = card.getAttribute("data-family") + "|" + card.getAttribute("data-width");
    var viewCartLink = card.querySelector("[data-view-cart]");
    btn.disabled = true;

    // This storefront's own theme.liquid defines window.routes
    // (cart_add_url, cart_url, etc.) straight from Liquid's `routes` object,
    // already locale/market-correct — and the theme's own bundle.js reads
    // from that exact global, so it's the most accurate source available.
    // Shopify.routes.root (a Dawn-only convention this theme never sets) is
    // kept only as a fallback for other storefronts this same component
    // might be dropped into, with a plain "/" as the last resort.
    var routes = window.routes || {};
    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var cartAddUrl = routes.cart_add_url || (cartRoot + "cart/add.js");

    // Requesting the drawer's section markup INLINE, as part of this same
    // POST — same mechanism Dawn's own cart.js uses — instead of only via
    // a follow-up GET to /cart?sections=<id>. This theme's cart drawer
    // lives inside the header section, itself rendered through a section
    // group (confirmed by its own runtime id, "sections-...__header"):
    // Shopify's standalone Section Rendering API doesn't reliably serve
    // section-group members, but the inline render requested here uses a
    // different path that often succeeds where that GET doesn't.
    var drawerSectionId = resolveCartDrawerSectionId();
    var payload = { items: items };
    if (drawerSectionId) {
      payload.sections = [drawerSectionId];
      payload.sections_url = window.location.pathname;
    }

    fetch(cartAddUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (response) {
        // The items-array contract responds with { items: [...] } instead
        // of a single line-item object — unwrap it here so every existing
        // consumer below keeps getting the single added item it expects.
        var item = (response && response.items && response.items[0]) || response;
        self.state.cartAdded[key] = true;
        // btn stays disabled for the full "ADDED ✓" cosmetic window (reset
        // together with the label below) — re-enabling it immediately would
        // let a double-click fire a second, genuine /cart/add.js request
        // while the button still visibly reads "ADDED ✓", silently doubling
        // the cart quantity instead of erroring.
        btn.setAttribute("data-added", "true");
        btn.textContent = "ADDED ✓";
        // Theme-independent confirmation: a dispatched cart-refresh event
        // (below) has no guarantee any given theme's cart drawer is actually
        // listening for it, so this is shown regardless of whether the
        // theme's own drawer opens.
        if (viewCartLink) viewCartLink.removeAttribute("hidden");
        // Restores the exact bag-icon + product-name + price label
        // cardMarkup/bundlePairMarkup rendered onto this button (see its
        // own data-ready-label attribute, set via cartCtaLabelHtml) — a
        // plain hardcoded "ADD TO CART" here would silently relabel a
        // Walk Kit/Bundle button back to a generic one, and lose the icon,
        // even though the tier selection itself hasn't changed.
        var resetLabelHtml = btn.getAttribute("data-ready-label") || "";
        setTimeout(function () {
          self.state.cartAdded[key] = false;
          btn.disabled = false;
          btn.setAttribute("data-added", "false");
          btn.innerHTML = resetLabelHtml;
          if (viewCartLink) viewCartLink.setAttribute("hidden", "");
        }, 2200);

        // Let the theme's own slide-out cart intercept without a page reload.
        // Dawn-family themes listen for CartUpdate; older themes commonly
        // listen for cart:refresh / cart:build. Firing all three covers
        // the vast majority of Shopify themes without extra configuration —
        // but the "View Cart" link above is the guaranteed fallback for
        // themes that listen for none of them.
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { item: item } }));
        document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true, detail: { item: item } }));
        document.documentElement.dispatchEvent(new CustomEvent("CartUpdate", { bubbles: true, detail: { item: item } }));
        self.dispatchEvent(new CustomEvent("lillebjorn:added-to-cart", { bubbles: true, detail: { item: item } }));

        // Shopify's own documented channel for custom/headless cart
        // integrations to notify Web Pixels of a cart mutation, with a
        // complete, standard-shaped payload — gives any correctly-built
        // pixel what it needs directly instead of leaving it to sniff this
        // fetch call itself (and potentially crash on an unexpected shape,
        // as at least one installed pixel currently does on this store).
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
          // A Walk Kit/Complete Bundle add carries 2-3 real line items, not
          // just the one `item` unwrapped above for the DOM events — every
          // one of them needs its own publish call, or a pixel tallying
          // revenue by this event would silently undercount every bundled
          // add by the leash/partner-item lines' own value.
          var publishedLines = (response && response.items) || [item];
          publishedLines.forEach(function (line) {
            try {
              window.Shopify.analytics.publish("product_added_to_cart", { cartLine: line });
            } catch (pixelErr) {
              // A broken third-party pixel must never block the cart flow itself.
              console.warn("lillebjorn-fit-finder: Shopify.analytics.publish failed", pixelErr);
            }
          });
        }

        // GA4's own recommended add_to_cart event shape (ecommerce.items[]),
        // not a custom-shaped payload — this is what lights up GA4's built-in
        // Ecommerce reports, not just a raw custom event. Computed fresh from
        // response.items (falling back to the single unwrapped `item`) rather
        // than reusing publishedLines above, since that variable only gets
        // assigned inside the Shopify.analytics-present branch.
        var gaLines = (response && response.items) || [item];
        var gaItems = gaLines.map(function (line) {
          return {
            item_id: String(line.variant_id != null ? line.variant_id : line.id),
            item_name: line.product_title || line.title || "",
            item_variant: line.variant_title || undefined,
            price: (line.price || 0) / 100,
            quantity: line.quantity || 1
          };
        });
        var gaValue = gaLines.reduce(function (sum, line) {
          var lineTotal = line.final_line_price != null ? line.final_line_price
            : line.line_price != null ? line.line_price
            : (line.price || 0) * (line.quantity || 1);
          return sum + lineTotal / 100;
        }, 0);
        trackSizingEvent("sizing_tool_add_to_cart", {
          ecommerce: {
            // Shopify's AJAX cart response carries no ISO currency code of
            // its own — Shopify.currency.active is the standard global every
            // storefront sets, so this is read from there rather than
            // parsed out of moneyFormat (a display template, e.g.
            // "€{{amount}}", not a currency code, and not reliably parseable
            // into one).
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined,
            value: gaValue,
            items: gaItems
          },
          tier: btn.getAttribute("data-tier")
        });

        // /cart/add.js's response describes only the single line item just
        // added (its own quantity/price) — it does NOT carry cart.item_count,
        // the number this store's actual header badge renders (see
        // .header__cart-count / .cart-count-number in theme.liquid's cart
        // icon markup). A second read of the real cart is the only way to
        // get that total, so the header count can be patched directly
        // instead of only hoping bundle.js is listening for one of the
        // events above.
        var cartJsUrl = (routes.cart_url || (cartRoot + "cart")) + ".js";
        var cartCountPromise = fetch(cartJsUrl, { headers: { Accept: "application/json" } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            self.refreshHeaderCartCount(cart);
            document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
          })
          .catch(function (cartErr) {
            // Non-fatal: the item is already in the cart at this point —
            // only the header badge's live refresh is skipped. The "View
            // Cart" link and an eventual page navigation still show the
            // real, correct state.
            console.warn("lillebjorn-fit-finder: could not refresh header cart count", cartErr);
          });

        // The events dispatched above only help if this theme's own
        // bundle.js happens to be listening for one of them — confirmed
        // NOT sufficient here (header count now updates via the direct
        // DOM patch above, but the drawer itself still shows "Your cart
        // is empty" until a hard refresh). refreshCartDrawerMarkup()
        // below replaces the drawer's stale server-rendered content
        // directly, independent of whatever event contract this theme's
        // own JS actually uses.
        var inlineSectionHtml = drawerSectionId && response && response.sections && response.sections[drawerSectionId];
        var drawerRefreshPromise = self.refreshCartDrawerMarkup(inlineSectionHtml)
          .catch(function (drawerErr) {
            console.warn("lillebjorn-fit-finder: could not refresh cart drawer markup", drawerErr);
          });

        return Promise.all([cartCountPromise, drawerRefreshPromise]);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = "TRY AGAIN";
        // Surface WHY it failed (Shopify's /cart/add.js error payload
        // carries a human-readable description — e.g. "sold out") instead
        // of leaving the shopper to guess between sold-out, a dropped
        // connection, or something else. role="alert" on the container
        // means this is announced to screen-reader users too, not just a
        // silent button-text swap.
        var errorEl = card.querySelector("[data-cart-error]");
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) ||
            "Couldn't add this to your cart — please try again.";
          errorEl.hidden = false;
        }
        // "TRY AGAIN" is a call to action, not a permanent label — left
        // showing indefinitely, a shopper who steps away and comes back
        // later has no way to tell whether that add ever succeeded.
        var errorResetLabelHtml = btn.getAttribute("data-ready-label") || "";
        setTimeout(function () {
          btn.innerHTML = errorResetLabelHtml;
          if (errorEl) errorEl.hidden = true;
        }, 5000);
        console.error("lillebjorn-fit-finder: add to cart failed", err);
      });
  };

  // Direct DOM patch for this storefront's real header cart badge — see
  // sections/header.liquid, which renders `.header__cart-count >
  // .cart-count-number`, an `opacity-0 hidden-xs` pair gated on
  // `cart.item_count == 0`, and a `header-cart-count-N` class, all computed
  // once at page-load time from Liquid. Dispatching custom events (above)
  // only helps if this theme's own bundle.js happens to listen for one of
  // them, which can't be confirmed without that bundle's source. Patching
  // these known, real selectors directly is what actually guarantees the
  // badge updates the instant an item is added, independent of whether
  // anything else is listening. querySelectorAll/closest all no-op safely
  // if the theme's markup ever changes, rather than throwing.
  LillebjornFitFinder.prototype.refreshHeaderCartCount = function (cart) {
    document.querySelectorAll(".header__cart-count").forEach(function (badge) {
      var numberEl = badge.querySelector(".cart-count-number");
      if (numberEl) numberEl.textContent = cart.item_count;
      // Mirrors header.liquid's own {% if cart.item_count == 0 %}opacity-0
      // hidden-xs{% endif %} exactly, so the badge's visibility rule stays
      // in sync with the real cart instead of the page-load snapshot.
      var isEmpty = cart.item_count === 0;
      badge.classList.toggle("opacity-0", isEmpty);
      badge.classList.toggle("hidden-xs", isEmpty);
      badge.className = badge.className.replace(/header-cart-count-\d+/, "header-cart-count-" + cart.item_count);
      // Replays the theme's own counter-pulse animation (see
      // .header-cart-status--animate in theme.liquid's inline stylesheet) —
      // best-effort only, since the exact ancestor node that convention
      // expects isn't in the files available here.
      var animateHost = badge.closest("a, button") || badge.parentElement;
      if (animateHost) {
        animateHost.classList.add("header-cart-status--animate");
        setTimeout(function () { animateHost.classList.remove("header-cart-status--animate"); }, 400);
      }
    });
  };

  // Swaps freshly-rendered markup into the live, currently-stale
  // .drawer__wrapper.cart-drawer__wrapper element —
  // <sht-cart-drwr id="shtCartDrawer"> > div.cart-drawer#cartDrawer >
  // div.drawer__wrapper.cart-drawer__wrapper. That scope is deliberate:
  // it's the one element whose content actually differs between the
  // {% if cart == empty %} and item-list branches in that file, and it
  // sits below both #personalizationModal and the outer <sht-cart-drwr>
  // shell (which exposes window.shtCartDrawer for the close button's
  // onclick) — so neither of those is touched or invalidated by this.
  //
  // Interactive controls inside the swapped markup (quantity steppers,
  // remove buttons) are wired through this theme's own registered custom
  // elements (sht-cart-drwr-qty-inp, sht-cart-drwr-rmv-btn,
  // sht-cart-drwr-frm) rather than one-off listeners — connectedCallback
  // fires again automatically the moment this new markup is inserted, so
  // those keep working without needing this theme's own JS to notice
  // anything happened. Same guarantee applies whichever fetch path below
  // ends up supplying the markup.
  //
  // preFetchedHtml: section HTML addToCart already got back inline as
  // part of its own /cart/add.js response (see the `sections` param
  // there) — when present, this skips the follow-up GET entirely.
  LillebjornFitFinder.prototype.refreshCartDrawerMarkup = function (preFetchedHtml) {
    var liveDrawer = document.querySelector(".cart-drawer__wrapper");
    if (!liveDrawer) return Promise.resolve();

    var self = this;
    // Two adds in quick succession (two different cards' own Add to Cart
    // buttons, each only disabling itself) each start their own
    // independent fetch here — network responses have no guaranteed
    // order, so without this, a SLOWER first request could apply its
    // (now stale) drawer snapshot AFTER a faster second request already
    // applied the correct, more current one. this._cartDrawerRequestId is
    // bumped once per call and captured locally; applyFreshDrawer below
    // only ever writes to the DOM if this is still the MOST RECENT call,
    // silently discarding a superseded one instead of letting whichever
    // response merely arrives last win.
    this._cartDrawerRequestId = (this._cartDrawerRequestId || 0) + 1;
    var myRequestId = this._cartDrawerRequestId;

    var routes = window.routes || {};
    var cartUrl = routes.cart_url || "/cart";
    var sectionId = resolveCartDrawerSectionId();

    // True once a NEWER call to this same method has started — checked at
    // the start of every async continuation below so a superseded request
    // stops immediately instead of still running its own fallback fetch
    // for a drawer refresh nothing needs anymore.
    function isStale() { return myRequestId !== self._cartDrawerRequestId; }

    // Returns true if usable drawer markup was actually found and applied
    // — the caller needs to know this to decide whether the fallback
    // below is necessary, not just whether the fetch itself succeeded.
    function applyFreshDrawer(html) {
      if (isStale()) return false;
      var freshDoc = new DOMParser().parseFromString(html, "text/html");
      var freshDrawer = freshDoc.querySelector(".cart-drawer__wrapper");
      if (!freshDrawer) return false;
      liveDrawer.innerHTML = freshDrawer.innerHTML;
      return true;
    }

    // Guaranteed-correct fallback: re-fetch the CURRENT page (not a
    // sections=/JSON endpoint) and pull the same .cart-drawer__wrapper out
    // of that instead. This needs zero knowledge of section ids — the
    // drawer's markup lives on every page via theme.liquid regardless.
    // Heavier than the Section Rendering API (a full page vs. one
    // section), which is why it's the fallback and not the primary path.
    function fallbackToFullPageFetch() {
      if (isStale()) return Promise.resolve();
      return fetch(window.location.href, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) { if (html) applyFreshDrawer(html); });
    }

    if (preFetchedHtml && applyFreshDrawer(preFetchedHtml)) return Promise.resolve();

    // No ancestor carrying a real section id was found — there's nothing
    // to query the Section Rendering API with, so go straight to the
    // fallback instead of firing a request that can't possibly succeed.
    if (!sectionId) return fallbackToFullPageFetch();

    return fetch(cartUrl + "?sections=" + sectionId, { headers: { Accept: "application/json" } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (sections) {
        if (isStale()) return;
        var sectionHtml = sections && sections[sectionId];
        if (sectionHtml && applyFreshDrawer(sectionHtml)) return;
        // This section (id ends in "__<type>", e.g. "__header") is very
        // likely a section-group member — Shopify's standalone Section
        // Rendering API is documented not to reliably serve those, which
        // is expected here and not something a different id would fix.
        // The full-page refetch below is the guaranteed-correct path.
        console.info(
          "lillebjorn-fit-finder: '" + sectionId + "' isn't fetchable via the Section " +
          "Rendering API (likely a section-group member) — using a full-page refetch instead."
        );
        return fallbackToFullPageFetch();
      })
      .catch(function () {
        return fallbackToFullPageFetch();
      });
  };

  /* ---------- utils ---------- */

  function escapeHtml(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  customElements.define("lillebjorn-fit-finder", LillebjornFitFinder);
})();
